// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"3XSn5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Prompt", ()=>(0, _reactRouter.Prompt));
parcelHelpers.export(exports, "Redirect", ()=>(0, _reactRouter.Redirect));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _reactRouter.StaticRouter));
parcelHelpers.export(exports, "Switch", ()=>(0, _reactRouter.Switch));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "useHistory", ()=>(0, _reactRouter.useHistory));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useRouteMatch", ()=>(0, _reactRouter.useRouteMatch));
parcelHelpers.export(exports, "withRouter", ()=>(0, _reactRouter.withRouter));
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
var _reactRouter = require("react-router");
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var HashRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, _reactDefault.default).Component);
var resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, _history.createLocation)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim(C) {
    return C;
};
var forwardRef = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef === "undefined") forwardRef = forwardRefShim;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, _extendsDefault.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history;
        var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, _extendsDefault.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, _history.createPath)(context.location) === (0, _history.createPath)(normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props);
    });
});
var toType, refType;
var forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var forwardRef$1 = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef$1 === "undefined") forwardRef$1 = forwardRefShim$1;
function joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, _reactRouter.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = joinClassnames(className, activeClassName);
            style = (0, _extendsDefault.default)({}, style, activeStyle);
        }
        var props = (0, _extendsDefault.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if (forwardRefShim$1 !== forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Link, props);
    });
});
var ariaCurrentType;

},{"react-router":"djWTS","@babel/runtime/helpers/esm/inheritsLoose":"kg9va","react":"IMRgT","history":"1anis","prop-types":"iRwZ2","tiny-warning":"cn9Tg","@babel/runtime/helpers/esm/extends":"lIuHI","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"MAchW","tiny-invariant":"4UCjb","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9WDu5":[function(require,module,exports,__globalThis) {
// .create-event-container {
// 	pointer-events: auto;
// 	height: auto;
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// TODO: fix shadow
parcelHelpers.export(exports, "DashboardContainer", ()=>DashboardContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _fadeIn = require("../../../../../../src/vendored/FadeIn");
var _fadeInDefault = parcelHelpers.interopDefault(_fadeIn);
var _dashboardUtils = require("../../../dashboard_utils");
function DashboardContainer(props) {
    const content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("m-auto flex w-11/12 flex-col bg-base-primary px-4 pb-8 pt-4 shadow-md sm:p-12", {
            "sm:w-3/4 xl:w-3/5 2xl:w-1/2": !props.size || props.size === "md",
            "sm:w-4/5 xl:w-3/5": props.size === "lg",
            "sm:w-11/12 xl:w-4/5": props.size === "xl"
        }),
        children: [
            props.bread_crumbs && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: props.bread_crumbs
            }),
            props.title && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "title mx-auto w-full text-center",
                children: props.title
            }),
            props.is_loading ? (0, _dashboardUtils.DashboardUtils).RenderLoadingThrobber() : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: props.children
            })
        ]
    });
    return props.no_fade_in ? content : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeInDefault.default), {
        transitionDuration: (0, _dashboardUtils.FADE_IN_ANIMATION_DURATION),
        children: content
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","../../../../../../src/vendored/FadeIn":"aMGHU","../../../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1I8d2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingThrobber", ()=>LoadingThrobber);
var _jsxRuntime = require("react/jsx-runtime");
var _dashboardUtils = require("../../../dashboard_utils");
function LoadingThrobber(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: (0, _dashboardUtils.DashboardUtils).RenderLoadingThrobber(props.loading_text, props.vertical_spaces)
    });
}

},{"react/jsx-runtime":"dpQXr","../../../dashboard_utils":"jvA8A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3QyI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// background-color: $dark-gray !important;
// 	color: $white !important;
// 	border: 2px solid $sesh-color !important;
parcelHelpers.export(exports, "SeshPrimaryButton", ()=>SeshPrimaryButton);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function SeshPrimaryButton(props) {
    const { is_loading, ...base_props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        ...base_props,
        className: (0, _classnamesDefault.default)(props.className, "w-full border-sesh-primary bg-base-dark font-bold text-white ", {
            // Important css here to override bulmas button stuff
            "button is-loading !rounded-none !border-2 !border-sesh-primary !bg-base-dark": is_loading,
            "input-disabled": props.disabled || is_loading,
            "hover:bg-base-light": !props.disabled,
            "h-8 border px-2 text-sm": props.custom_size === "small",
            "h-10 border-2 px-4 text-base": !props.custom_size || props.custom_size === "medium"
        }),
        type: base_props.type ?? "button"
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dyYvM":[function(require,module,exports,__globalThis) {
// utils/trpc.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trpc", ()=>trpc);
var _reactQuery = require("@trpc/react-query");
const trpc = (0, _reactQuery.createTRPCReact)();

},{"@trpc/react-query":"i8LmI","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"i8LmI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createReactQueryHooks", ()=>createReactQueryHooks);
parcelHelpers.export(exports, "createTRPCReact", ()=>createTRPCReact);
var _client = require("@trpc/client");
parcelHelpers.exportAll(_client, exports);
var _shared = require("@trpc/server/shared");
var _react = require("react");
var _createHooksInternalB47Ee704Mjs = require("./createHooksInternal-b47ee704.mjs");
var _reactQuery = require("@tanstack/react-query");
var _getArrayQueryKey062214E0Mjs = require("./getArrayQueryKey-062214e0.mjs");
/**
 * @internal
 */ function createHooksInternalProxy(trpc) {
    return (0, _shared.createFlatProxy)((key)=>{
        if (key === 'useContext') return ()=>{
            const context = trpc.useContext();
            // create a stable reference of the utils context
            return (0, _react.useMemo)(()=>{
                return (0, _createHooksInternalB47Ee704Mjs.a)(context);
            }, [
                context
            ]);
        };
        if (key in trpc) return trpc[key];
        return (0, _createHooksInternalB47Ee704Mjs.b)(key, trpc);
    });
}
function createTRPCReact(opts) {
    const hooks = (0, _createHooksInternalB47Ee704Mjs.c)(opts);
    const proxy = createHooksInternalProxy(hooks);
    return proxy;
}
// interop:
/**
 * @deprecated use `createTRPCReact` instead
 */ function createReactQueryHooks(opts) {
    const trpc = (0, _createHooksInternalB47Ee704Mjs.c)(opts);
    const proxy = createHooksInternalProxy(trpc);
    return {
        ...trpc,
        proxy
    };
}

},{"@trpc/client":"98Zm4","@trpc/server/shared":"96Vy9","react":"IMRgT","./createHooksInternal-b47ee704.mjs":"ikoge","@tanstack/react-query":"dh3yw","./getArrayQueryKey-062214e0.mjs":"dOzeP","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"98Zm4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRPCClientError", ()=>(0, _transformResult106791D7Mjs.T));
parcelHelpers.export(exports, "splitLink", ()=>(0, _splitLinkAd44A55DMjs.s));
parcelHelpers.export(exports, "httpBatchLink", ()=>(0, _httpBatchLinkMjs.httpBatchLink));
parcelHelpers.export(exports, "getFetch", ()=>(0, _httpUtilsD1885508Mjs.g));
parcelHelpers.export(exports, "httpLink", ()=>(0, _httpLinkMjs.httpLink));
parcelHelpers.export(exports, "loggerLink", ()=>(0, _loggerLinkMjs.loggerLink));
parcelHelpers.export(exports, "createWSClient", ()=>(0, _wsLinkMjs.createWSClient));
parcelHelpers.export(exports, "wsLink", ()=>(0, _wsLinkMjs.wsLink));
parcelHelpers.export(exports, "createTRPCClient", ()=>createTRPCClient);
parcelHelpers.export(exports, "createTRPCClientProxy", ()=>createTRPCClientProxy);
parcelHelpers.export(exports, "createTRPCProxyClient", ()=>createTRPCProxyClient);
var _observable = require("@trpc/server/observable");
var _transformResult106791D7Mjs = require("./transformResult-106791d7.mjs");
var _splitLinkAd44A55DMjs = require("./splitLink-ad44a55d.mjs");
var _httpBatchLinkMjs = require("./links/httpBatchLink.mjs");
var _shared = require("@trpc/server/shared");
var _httpUtilsD1885508Mjs = require("./httpUtils-d1885508.mjs");
var _httpLinkMjs = require("./links/httpLink.mjs");
var _loggerLinkMjs = require("./links/loggerLink.mjs");
var _wsLinkMjs = require("./links/wsLink.mjs");
class TRPCClient {
    $request({ type, input, path, context = {} }) {
        const chain$ = (0, _splitLinkAd44A55DMjs.c)({
            links: this.links,
            op: {
                id: ++this.requestId,
                type,
                path,
                input,
                context
            }
        });
        return chain$.pipe((0, _observable.share)());
    }
    requestAsPromise(opts) {
        const req$ = this.$request(opts);
        const { promise, abort } = (0, _observable.observableToPromise)(req$);
        const abortablePromise = new Promise((resolve, reject)=>{
            opts.signal?.addEventListener('abort', abort);
            promise.then((envelope)=>{
                resolve(envelope.result.data);
            }).catch((err)=>{
                reject((0, _transformResult106791D7Mjs.T).from(err));
            });
        });
        return abortablePromise;
    }
    query(path, input, opts) {
        return this.requestAsPromise({
            type: 'query',
            path,
            input: input,
            context: opts?.context,
            signal: opts?.signal
        });
    }
    mutation(path, input, opts) {
        return this.requestAsPromise({
            type: 'mutation',
            path,
            input: input,
            context: opts?.context,
            signal: opts?.signal
        });
    }
    subscription(path, input, opts) {
        const observable$ = this.$request({
            type: 'subscription',
            path,
            input,
            context: opts?.context
        });
        return observable$.subscribe({
            next (envelope) {
                if (envelope.result.type === 'started') opts.onStarted?.();
                else if (envelope.result.type === 'stopped') opts.onStopped?.();
                else opts.onData?.(envelope.result.data);
            },
            error (err) {
                opts.onError?.(err);
            },
            complete () {
                opts.onComplete?.();
            }
        });
    }
    constructor(opts){
        this.requestId = 0;
        function getTransformer() {
            if (!opts.transformer) return {
                serialize: (data)=>data,
                deserialize: (data)=>data
            };
            if ('input' in opts.transformer) return {
                serialize: opts.transformer.input.serialize,
                deserialize: opts.transformer.output.deserialize
            };
            return opts.transformer;
        }
        this.runtime = {
            transformer: getTransformer()
        };
        // Initialize the links
        this.links = opts.links.map((link)=>link(this.runtime));
    }
}
/**
 * @deprecated use `createTRPCProxyClient` instead
 */ function createTRPCClient(opts) {
    const getLinks = ()=>{
        if ('links' in opts) return opts.links;
        return [
            (0, _httpBatchLinkMjs.httpBatchLink)(opts)
        ];
    };
    const client = new TRPCClient({
        transformer: opts.transformer,
        links: getLinks()
    });
    return client;
}
const clientCallTypeMap = {
    query: 'query',
    mutate: 'mutation',
    subscribe: 'subscription'
};
/**
 * @deprecated use `createTRPCProxyClient` instead
 * @internal
 */ function createTRPCClientProxy(client) {
    const proxy = (0, _shared.createRecursiveProxy)(({ path, args })=>{
        const pathCopy = [
            ...path
        ];
        const clientCallType = pathCopy.pop();
        const procedureType = clientCallTypeMap[clientCallType];
        const fullPath = pathCopy.join('.');
        return client[procedureType](fullPath, ...args);
    });
    return proxy;
}
function createTRPCProxyClient(opts) {
    const client = new TRPCClient(opts);
    const proxy = createTRPCClientProxy(client);
    return proxy;
}

},{"@trpc/server/observable":"4dKlj","./transformResult-106791d7.mjs":"d5w2o","./splitLink-ad44a55d.mjs":"768Ra","./links/httpBatchLink.mjs":"g49kM","@trpc/server/shared":"96Vy9","./httpUtils-d1885508.mjs":"8HSNX","./links/httpLink.mjs":"jxkGD","./links/loggerLink.mjs":"3eNOA","./links/wsLink.mjs":"1AZOu","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4dKlj":[function(require,module,exports,__globalThis) {
module.exports = require("a99499e9806f361d");

},{"a99499e9806f361d":"fuWYH"}],"fuWYH":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var observable = require("4f3733c110ce175a");
function share(_opts) {
    return (originalObserver)=>{
        let refCount = 0;
        let subscription = null;
        const observers = [];
        function startIfNeeded() {
            if (subscription) return;
            subscription = originalObserver.subscribe({
                next (value) {
                    for (const observer of observers)observer.next?.(value);
                },
                error (error) {
                    for (const observer of observers)observer.error?.(error);
                },
                complete () {
                    for (const observer of observers)observer.complete?.();
                }
            });
        }
        function resetIfNeeded() {
            // "resetOnRefCountZero"
            if (refCount === 0 && subscription) {
                const _sub = subscription;
                subscription = null;
                _sub.unsubscribe();
            }
        }
        return {
            subscribe (observer) {
                refCount++;
                observers.push(observer);
                startIfNeeded();
                return {
                    unsubscribe () {
                        refCount--;
                        resetIfNeeded();
                        const index = observers.findIndex((v)=>v === observer);
                        if (index > -1) observers.splice(index, 1);
                    }
                };
            }
        };
    };
}
function map(project) {
    return (originalObserver)=>{
        return {
            subscribe (observer) {
                let index = 0;
                const subscription = originalObserver.subscribe({
                    next (value) {
                        observer.next?.(project(value, index++));
                    },
                    error (error) {
                        observer.error?.(error);
                    },
                    complete () {
                        observer.complete?.();
                    }
                });
                return subscription;
            }
        };
    };
}
function tap(observer) {
    return (originalObserver)=>{
        return {
            subscribe (observer2) {
                return originalObserver.subscribe({
                    next (v) {
                        observer.next?.(v);
                        observer2.next?.(v);
                    },
                    error (v) {
                        observer.error?.(v);
                        observer2.error?.(v);
                    },
                    complete () {
                        observer.complete?.();
                        observer2.complete?.();
                    }
                });
            }
        };
    };
}
class ObservableAbortError extends Error {
    constructor(message){
        super(message);
        this.name = 'ObservableAbortError';
        Object.setPrototypeOf(this, ObservableAbortError.prototype);
    }
}
/** @internal */ function observableToPromise(observable) {
    let abort;
    const promise = new Promise((resolve, reject)=>{
        let isDone = false;
        function onDone() {
            if (isDone) return;
            isDone = true;
            reject(new ObservableAbortError('This operation was aborted.'));
            obs$.unsubscribe();
        }
        const obs$ = observable.subscribe({
            next (data) {
                isDone = true;
                resolve(data);
                onDone();
            },
            error (data) {
                isDone = true;
                reject(data);
                onDone();
            },
            complete () {
                isDone = true;
                onDone();
            }
        });
        abort = onDone;
    });
    return {
        promise,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        abort: abort
    };
}
exports.isObservable = observable.isObservable;
exports.observable = observable.observable;
exports.map = map;
exports.observableToPromise = observableToPromise;
exports.share = share;
exports.tap = tap;

},{"4f3733c110ce175a":"20BUQ"}],"20BUQ":[function(require,module,exports,__globalThis) {
'use strict';
function identity(x) {
    return x;
}
/** @internal */ function pipeFromArray(fns) {
    if (fns.length === 0) return identity;
    if (fns.length === 1) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return fns[0];
    return function piped(input) {
        return fns.reduce((prev, fn)=>fn(prev), input);
    };
}
function isObservable(x) {
    return typeof x === 'object' && x !== null && 'subscribe' in x;
}
function observable(subscribe) {
    const self = {
        subscribe (observer) {
            let teardownRef = null;
            let isDone = false;
            let unsubscribed = false;
            let teardownImmediately = false;
            function unsubscribe() {
                if (teardownRef === null) {
                    teardownImmediately = true;
                    return;
                }
                if (unsubscribed) return;
                unsubscribed = true;
                if (typeof teardownRef === 'function') teardownRef();
                else if (teardownRef) teardownRef.unsubscribe();
            }
            teardownRef = subscribe({
                next (value) {
                    if (isDone) return;
                    observer.next?.(value);
                },
                error (err) {
                    if (isDone) return;
                    isDone = true;
                    observer.error?.(err);
                    unsubscribe();
                },
                complete () {
                    if (isDone) return;
                    isDone = true;
                    observer.complete?.();
                    unsubscribe();
                }
            });
            if (teardownImmediately) unsubscribe();
            return {
                unsubscribe
            };
        },
        pipe (...operations) {
            return pipeFromArray(operations)(self);
        }
    };
    return self;
}
exports.isObservable = isObservable;
exports.observable = observable;

},{}],"d5w2o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "T", ()=>TRPCClientError);
parcelHelpers.export(exports, "t", ()=>transformResult);
class TRPCClientError extends Error {
    static from(cause, opts = {}) {
        if (!(cause instanceof Error)) return new TRPCClientError(cause.error.message ?? '', {
            ...opts,
            cause: undefined,
            result: cause
        });
        if (cause.name === 'TRPCClientError') return cause;
        return new TRPCClientError(cause.message, {
            ...opts,
            cause,
            result: null
        });
    }
    constructor(message, opts){
        const cause = opts?.cause;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore https://github.com/tc39/proposal-error-cause
        super(message, {
            cause
        });
        this.meta = opts?.meta;
        this.cause = cause;
        this.shape = opts?.result?.error;
        this.data = opts?.result?.error.data;
        this.name = 'TRPCClientError';
        Object.setPrototypeOf(this, TRPCClientError.prototype);
    }
}
// FIXME:
// - the generics here are probably unnecessary
// - the RPC-spec could probably be simplified to combine HTTP + WS
/** @internal */ function transformResult(response, runtime) {
    if ('error' in response) {
        const error = runtime.transformer.deserialize(response.error);
        return {
            ok: false,
            error: {
                ...response,
                error
            }
        };
    }
    const result = {
        ...response.result,
        ...(!response.result.type || response.result.type === 'data') && {
            type: 'data',
            data: runtime.transformer.deserialize(response.result.data)
        }
    };
    return {
        ok: true,
        result
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"768Ra":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c", ()=>createChain);
parcelHelpers.export(exports, "s", ()=>splitLink);
var _observable = require("@trpc/server/observable");
/** @internal */ function createChain(opts) {
    return (0, _observable.observable)((observer)=>{
        function execute(index = 0, op = opts.op) {
            const next = opts.links[index];
            if (!next) throw new Error('No more links to execute - did you forget to add an ending link?');
            const subscription = next({
                op,
                next (nextOp) {
                    const nextObserver = execute(index + 1, nextOp);
                    return nextObserver;
                }
            });
            return subscription;
        }
        const obs$ = execute();
        return obs$.subscribe(observer);
    });
}
function asArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function splitLink(opts) {
    return (runtime)=>{
        const yes = asArray(opts.true).map((link)=>link(runtime));
        const no = asArray(opts.false).map((link)=>link(runtime));
        return (props)=>{
            return (0, _observable.observable)((observer)=>{
                const links = opts.condition(props.op) ? yes : no;
                return createChain({
                    op: props.op,
                    links
                }).subscribe(observer);
            });
        };
    };
}

},{"@trpc/server/observable":"4dKlj","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"g49kM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "httpBatchLink", ()=>httpBatchLink);
var _observable = require("@trpc/server/observable");
var _transformResult106791D7Mjs = require("../transformResult-106791d7.mjs");
var _httpUtilsD1885508Mjs = require("../httpUtils-d1885508.mjs");
/* eslint-disable @typescript-eslint/no-non-null-assertion */ /**
 * A function that should never be called unless we messed something up.
 */ const throwFatalError = ()=>{
    throw new Error('Something went wrong. Please submit an issue at https://github.com/trpc/trpc/issues/new');
};
/**
 * Dataloader that's very inspired by https://github.com/graphql/dataloader
 * Less configuration, no caching, and allows you to cancel requests
 * When cancelling a single fetch the whole batch will be cancelled only when _all_ items are cancelled
 */ function dataLoader(batchLoader) {
    let pendingItems = null;
    let dispatchTimer = null;
    const destroyTimerAndPendingItems = ()=>{
        clearTimeout(dispatchTimer);
        dispatchTimer = null;
        pendingItems = null;
    };
    /**
   * Iterate through the items and split them into groups based on the `batchLoader`'s validate function
   */ function groupItems(items) {
        const groupedItems = [
            []
        ];
        let index = 0;
        while(true){
            const item = items[index];
            if (!item) break;
            const lastGroup = groupedItems[groupedItems.length - 1];
            if (item.aborted) {
                // Item was aborted before it was dispatched
                item.reject(new Error('Aborted'));
                index++;
                continue;
            }
            const isValid = batchLoader.validate(lastGroup.concat(item).map((it)=>it.key));
            if (isValid) {
                lastGroup.push(item);
                index++;
                continue;
            }
            if (lastGroup.length === 0) {
                item.reject(new Error('Input is too big for a single dispatch'));
                index++;
                continue;
            }
            // Create new group, next iteration will try to add the item to that
            groupedItems.push([]);
        }
        return groupedItems;
    }
    function dispatch() {
        const groupedItems = groupItems(pendingItems);
        destroyTimerAndPendingItems();
        // Create batches for each group of items
        for (const items of groupedItems){
            if (!items.length) continue;
            const batch = {
                items,
                cancel: throwFatalError
            };
            for (const item of items)item.batch = batch;
            const { promise, cancel } = batchLoader.fetch(batch.items.map((_item)=>_item.key));
            batch.cancel = cancel;
            promise.then((result)=>{
                for(let i = 0; i < result.length; i++){
                    const value = result[i];
                    const item = batch.items[i];
                    item.resolve(value);
                    item.batch = null;
                }
            }).catch((cause)=>{
                for (const item of batch.items){
                    item.reject(cause);
                    item.batch = null;
                }
            });
        }
    }
    function load(key) {
        const item = {
            aborted: false,
            key,
            batch: null,
            resolve: throwFatalError,
            reject: throwFatalError
        };
        const promise = new Promise((resolve, reject)=>{
            item.reject = reject;
            item.resolve = resolve;
            if (!pendingItems) pendingItems = [];
            pendingItems.push(item);
        });
        if (!dispatchTimer) dispatchTimer = setTimeout(dispatch);
        const cancel = ()=>{
            item.aborted = true;
            if (item.batch?.items.every((item)=>item.aborted)) {
                // All items in the batch have been cancelled
                item.batch.cancel();
                item.batch = null;
            }
        };
        return {
            promise,
            cancel
        };
    }
    return {
        load
    };
}
function httpBatchLink(opts) {
    const resolvedOpts = (0, _httpUtilsD1885508Mjs.r)(opts);
    // initialized config
    return (runtime)=>{
        const maxURLLength = opts.maxURLLength || Infinity;
        const batchLoader = (type)=>{
            const validate = (batchOps)=>{
                if (maxURLLength === Infinity) // escape hatch for quick calcs
                return true;
                const path = batchOps.map((op)=>op.path).join(',');
                const inputs = batchOps.map((op)=>op.input);
                const url = (0, _httpUtilsD1885508Mjs.a)({
                    ...resolvedOpts,
                    runtime,
                    type,
                    path,
                    inputs
                });
                return url.length <= maxURLLength;
            };
            const fetch = (batchOps)=>{
                const path = batchOps.map((op)=>op.path).join(',');
                const inputs = batchOps.map((op)=>op.input);
                const { promise, cancel } = (0, _httpUtilsD1885508Mjs.h)({
                    ...resolvedOpts,
                    runtime,
                    type,
                    path,
                    inputs
                });
                return {
                    promise: promise.then((res)=>{
                        const resJSON = Array.isArray(res.json) ? res.json : batchOps.map(()=>res.json);
                        const result = resJSON.map((item)=>({
                                meta: res.meta,
                                json: item
                            }));
                        return result;
                    }),
                    cancel
                };
            };
            return {
                validate,
                fetch
            };
        };
        const query = dataLoader(batchLoader('query'));
        const mutation = dataLoader(batchLoader('mutation'));
        const subscription = dataLoader(batchLoader('subscription'));
        const loaders = {
            query,
            subscription,
            mutation
        };
        return ({ op })=>{
            return (0, _observable.observable)((observer)=>{
                const loader = loaders[op.type];
                const { promise, cancel } = loader.load(op);
                promise.then((res)=>{
                    const transformed = (0, _transformResult106791D7Mjs.t)(res.json, runtime);
                    if (!transformed.ok) {
                        observer.error((0, _transformResult106791D7Mjs.T).from(transformed.error, {
                            meta: res.meta
                        }));
                        return;
                    }
                    observer.next({
                        context: res.meta,
                        result: transformed.result
                    });
                    observer.complete();
                }).catch((err)=>observer.error((0, _transformResult106791D7Mjs.T).from(err)));
                return ()=>{
                    cancel();
                };
            });
        };
    };
}

},{"@trpc/server/observable":"4dKlj","../transformResult-106791d7.mjs":"d5w2o","../httpUtils-d1885508.mjs":"8HSNX","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8HSNX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>getUrl);
parcelHelpers.export(exports, "g", ()=>getFetch);
parcelHelpers.export(exports, "h", ()=>httpRequest);
parcelHelpers.export(exports, "r", ()=>resolveHTTPLinkOptions);
function getWindow() {
    if (typeof window !== 'undefined') return window;
    return globalThis;
}
function getAbortController(ac) {
    return ac ?? getWindow().AbortController ?? null;
}
function getFetch(f) {
    if (f) return f;
    const win = getWindow();
    const globalFetch = win.fetch;
    if (globalFetch) return typeof globalFetch.bind === 'function' ? globalFetch.bind(win) : globalFetch;
    throw new Error('No fetch implementation found');
}
function resolveHTTPLinkOptions(opts) {
    const headers = opts.headers || (()=>({}));
    return {
        url: opts.url,
        fetch: getFetch(opts.fetch),
        AbortController: getAbortController(opts.AbortController),
        headers: typeof headers === 'function' ? headers : ()=>headers
    };
}
// https://github.com/trpc/trpc/pull/669
function arrayToDict(array) {
    const dict = {};
    for(let index = 0; index < array.length; index++){
        const element = array[index];
        dict[index] = element;
    }
    return dict;
}
const METHOD = {
    query: 'GET',
    mutation: 'POST'
};
function getInput(opts) {
    return 'input' in opts ? opts.runtime.transformer.serialize(opts.input) : arrayToDict(opts.inputs.map((_input)=>opts.runtime.transformer.serialize(_input)));
}
function getUrl(opts) {
    let url = opts.url + '/' + opts.path;
    const queryParts = [];
    if ('inputs' in opts) queryParts.push('batch=1');
    if (opts.type === 'query') {
        const input = getInput(opts);
        if (input !== undefined) queryParts.push(`input=${encodeURIComponent(JSON.stringify(input))}`);
    }
    if (queryParts.length) url += '?' + queryParts.join('&');
    return url;
}
function getBody(opts) {
    if (opts.type === 'query') return undefined;
    const input = getInput(opts);
    return input !== undefined ? JSON.stringify(input) : undefined;
}
function httpRequest(opts) {
    const { type } = opts;
    const ac = opts.AbortController ? new opts.AbortController() : null;
    const promise = new Promise((resolve, reject)=>{
        const url = getUrl(opts);
        const body = getBody(opts);
        const meta = {};
        Promise.resolve(opts.headers()).then((headers)=>{
            if (type === 'subscription') throw new Error('Subscriptions should use wsLink');
            return opts.fetch(url, {
                method: METHOD[type],
                signal: ac?.signal,
                body: body,
                headers: {
                    'content-type': 'application/json',
                    ...headers
                }
            });
        }).then((_res)=>{
            meta.response = _res;
            return _res.json();
        }).then((json)=>{
            resolve({
                json,
                meta
            });
        }).catch(reject);
    });
    const cancel = ()=>{
        ac?.abort();
    };
    return {
        promise,
        cancel
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"96Vy9":[function(require,module,exports,__globalThis) {
module.exports = require("41e5f59482d6b3cb");

},{"41e5f59482d6b3cb":"ersfo"}],"ersfo":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var index = require("af66ffbda3805f27");
exports.createFlatProxy = index.createFlatProxy;
exports.createRecursiveProxy = index.createRecursiveProxy;

},{"af66ffbda3805f27":"aJ7tQ"}],"aJ7tQ":[function(require,module,exports,__globalThis) {
'use strict';
const noop = ()=>{
// noop
};
function createInnerProxy(callback, path) {
    const proxy = new Proxy(noop, {
        get (_obj, key) {
            if (typeof key !== 'string' || key === 'then') // special case for if the proxy is accidentally treated
            // like a PromiseLike (like in `Promise.resolve(proxy)`)
            return undefined;
            return createInnerProxy(callback, [
                ...path,
                key
            ]);
        },
        apply (_1, _2, args) {
            return callback({
                args,
                path
            });
        }
    });
    return proxy;
}
/**
 * Creates a proxy that calls the callback with the path and arguments
 *
 * @internal
 */ const createRecursiveProxy = (callback)=>createInnerProxy(callback, []);
/**
 * Used in place of `new Proxy` where each handler will map 1 level deep to another value.
 *
 * @internal
 */ const createFlatProxy = (callback)=>{
    return new Proxy(noop, {
        get (_obj, name) {
            if (typeof name !== 'string' || name === 'then') // special case for if the proxy is accidentally treated
            // like a PromiseLike (like in `Promise.resolve(proxy)`)
            return undefined;
            return callback(name);
        }
    });
};
exports.createFlatProxy = createFlatProxy;
exports.createRecursiveProxy = createRecursiveProxy;

},{}],"jxkGD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "httpLink", ()=>httpLink);
var _observable = require("@trpc/server/observable");
var _transformResult106791D7Mjs = require("../transformResult-106791d7.mjs");
var _httpUtilsD1885508Mjs = require("../httpUtils-d1885508.mjs");
function httpLink(opts) {
    const resolvedOpts = (0, _httpUtilsD1885508Mjs.r)(opts);
    return (runtime)=>({ op })=>(0, _observable.observable)((observer)=>{
                const { path, input, type } = op;
                const { promise, cancel } = (0, _httpUtilsD1885508Mjs.h)({
                    ...resolvedOpts,
                    runtime,
                    type,
                    path,
                    input
                });
                promise.then((res)=>{
                    const transformed = (0, _transformResult106791D7Mjs.t)(res.json, runtime);
                    if (!transformed.ok) {
                        observer.error((0, _transformResult106791D7Mjs.T).from(transformed.error, {
                            meta: res.meta
                        }));
                        return;
                    }
                    observer.next({
                        context: res.meta,
                        result: transformed.result
                    });
                    observer.complete();
                }).catch((cause)=>observer.error((0, _transformResult106791D7Mjs.T).from(cause)));
                return ()=>{
                    cancel();
                };
            });
}

},{"@trpc/server/observable":"4dKlj","../transformResult-106791d7.mjs":"d5w2o","../httpUtils-d1885508.mjs":"8HSNX","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3eNOA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerLink", ()=>loggerLink);
var _observable = require("@trpc/server/observable");
const palette = {
    query: [
        '72e3ff',
        '3fb0d8'
    ],
    mutation: [
        'c5a3fc',
        '904dfc'
    ],
    subscription: [
        'ff49e1',
        'd83fbe'
    ]
};
// maybe this should be moved to it's own package
const defaultLogger = (c = console)=>(props)=>{
        const { direction, input, type, path, context, id } = props;
        const [light, dark] = palette[type];
        const css = `
    background-color: #${direction === 'up' ? light : dark}; 
    color: ${direction === 'up' ? 'black' : 'white'};
    padding: 2px;
  `;
        const parts = [
            '%c',
            direction === 'up' ? '>>' : '<<',
            type,
            `#${id}`,
            `%c${path}%c`,
            '%O'
        ];
        const args = [
            css,
            `${css}; font-weight: bold;`,
            `${css}; font-weight: normal;`
        ];
        if (props.direction === 'up') args.push({
            input,
            context: context
        });
        else args.push({
            input,
            result: props.result,
            elapsedMs: props.elapsedMs,
            context
        });
        const fn = props.direction === 'down' && props.result && (props.result instanceof Error || 'error' in props.result.result) ? 'error' : 'log';
        c[fn].apply(null, [
            parts.join(' ')
        ].concat(args));
    };
function loggerLink(opts = {}) {
    const { enabled = ()=>true } = opts;
    const { logger = defaultLogger(opts.console) } = opts;
    return ()=>{
        return ({ op, next })=>{
            return (0, _observable.observable)((observer)=>{
                // ->
                enabled({
                    ...op,
                    direction: 'up'
                }) && logger({
                    ...op,
                    direction: 'up'
                });
                const requestStartTime = Date.now();
                function logResult(result) {
                    const elapsedMs = Date.now() - requestStartTime;
                    enabled({
                        ...op,
                        direction: 'down',
                        result
                    }) && logger({
                        ...op,
                        direction: 'down',
                        elapsedMs,
                        result
                    });
                }
                return next(op).pipe((0, _observable.tap)({
                    next (result) {
                        logResult(result);
                    },
                    error (result) {
                        logResult(result);
                    }
                })).subscribe(observer);
            });
        };
    };
}

},{"@trpc/server/observable":"4dKlj","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1AZOu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createWSClient", ()=>createWSClient);
parcelHelpers.export(exports, "wsLink", ()=>wsLink);
var _observable = require("@trpc/server/observable");
var _transformResult106791D7Mjs = require("../transformResult-106791d7.mjs");
/* istanbul ignore next */ const retryDelay = (attemptIndex)=>attemptIndex === 0 ? 0 : Math.min(1000 * 2 ** attemptIndex, 30000);
function createWSClient(opts) {
    const { url, WebSocket: WebSocketImpl = WebSocket, retryDelayMs: retryDelayFn = retryDelay, onOpen, onClose } = opts;
    /* istanbul ignore next */ if (!WebSocketImpl) throw new Error("No WebSocket implementation found - you probably don't want to use this on the server, but if you do you need to pass a `WebSocket`-ponyfill");
    /**
   * outgoing messages buffer whilst not open
   */ let outgoing = [];
    const pendingRequests = Object.create(null);
    let connectAttempt = 0;
    let dispatchTimer = null;
    let connectTimer = null;
    let activeConnection = createWS();
    let state = 'connecting';
    /**
   * tries to send the list of messages
   */ function dispatch() {
        if (state !== 'open' || dispatchTimer) return;
        dispatchTimer = setTimeout(()=>{
            dispatchTimer = null;
            if (outgoing.length === 1) // single send
            activeConnection.send(JSON.stringify(outgoing.pop()));
            else // batch send
            activeConnection.send(JSON.stringify(outgoing));
            // clear
            outgoing = [];
        });
    }
    function tryReconnect() {
        if (connectTimer || state === 'closed') return;
        const timeout = retryDelayFn(connectAttempt++);
        reconnectInMs(timeout);
    }
    function reconnect() {
        state = 'connecting';
        const oldConnection = activeConnection;
        activeConnection = createWS();
        closeIfNoPending(oldConnection);
    }
    function reconnectInMs(ms) {
        if (connectTimer) return;
        state = 'connecting';
        connectTimer = setTimeout(reconnect, ms);
    }
    function closeIfNoPending(conn) {
        // disconnect as soon as there are are no pending result
        const hasPendingRequests = Object.values(pendingRequests).some((p)=>p.ws === conn);
        if (!hasPendingRequests) conn.close();
    }
    function resumeSubscriptionOnReconnect(req) {
        if (outgoing.some((r)=>r.id === req.op.id)) return;
        request(req.op, req.callbacks);
    }
    function createWS() {
        const conn = new WebSocketImpl(url);
        clearTimeout(connectTimer);
        connectTimer = null;
        conn.addEventListener('open', ()=>{
            /* istanbul ignore next */ if (conn !== activeConnection) return;
            connectAttempt = 0;
            state = 'open';
            onOpen?.();
            dispatch();
        });
        conn.addEventListener('error', ()=>{
            if (conn === activeConnection) tryReconnect();
        });
        const handleIncomingRequest = (req)=>{
            if (req.method === 'reconnect' && conn === activeConnection) {
                if (state === 'open') onClose?.();
                reconnect();
                // notify subscribers
                for (const pendingReq of Object.values(pendingRequests))if (pendingReq.type === 'subscription') resumeSubscriptionOnReconnect(pendingReq);
            }
        };
        const handleIncomingResponse = (data)=>{
            const req = data.id !== null && pendingRequests[data.id];
            if (!req) // do something?
            return;
            req.callbacks.next?.(data);
            if (req.ws !== activeConnection && conn === activeConnection) {
                const oldWs = req.ws;
                // gracefully replace old connection with this
                req.ws = activeConnection;
                closeIfNoPending(oldWs);
            }
            if ('result' in data && data.result.type === 'stopped' && conn === activeConnection) req.callbacks.complete();
        };
        conn.addEventListener('message', ({ data })=>{
            const msg = JSON.parse(data);
            if ('method' in msg) handleIncomingRequest(msg);
            else handleIncomingResponse(msg);
            if (conn !== activeConnection || state === 'closed') // when receiving a message, we close old connection that has no pending requests
            closeIfNoPending(conn);
        });
        conn.addEventListener('close', ({ code })=>{
            if (state === 'open') onClose?.({
                code
            });
            if (activeConnection === conn) // connection might have been replaced already
            tryReconnect();
            for (const [key, req] of Object.entries(pendingRequests)){
                if (req.ws !== conn) continue;
                req.callbacks.error?.((0, _transformResult106791D7Mjs.T).from(new TRPCWebSocketClosedError('WebSocket closed prematurely')));
                if (req.type !== 'subscription') {
                    delete pendingRequests[key];
                    req.callbacks.complete?.();
                } else if (state !== 'closed') // request restart of sub with next connection
                resumeSubscriptionOnReconnect(req);
            }
        });
        return conn;
    }
    function request(op, callbacks) {
        const { type, input, path, id } = op;
        const envelope = {
            id,
            method: type,
            params: {
                input,
                path
            }
        };
        pendingRequests[id] = {
            ws: activeConnection,
            type,
            callbacks,
            op
        };
        // enqueue message
        outgoing.push(envelope);
        dispatch();
        return ()=>{
            const callbacks = pendingRequests[id]?.callbacks;
            delete pendingRequests[id];
            outgoing = outgoing.filter((msg)=>msg.id !== id);
            callbacks?.complete?.();
            if (op.type === 'subscription') {
                outgoing.push({
                    id,
                    method: 'subscription.stop'
                });
                dispatch();
            }
        };
    }
    return {
        close: ()=>{
            state = 'closed';
            onClose?.();
            closeIfNoPending(activeConnection);
            clearTimeout(connectTimer);
            connectTimer = null;
        },
        request,
        getConnection () {
            return activeConnection;
        }
    };
}
class TRPCWebSocketClosedError extends Error {
    constructor(message){
        super(message);
        this.name = 'TRPCWebSocketClosedError';
        Object.setPrototypeOf(this, TRPCWebSocketClosedError.prototype);
    }
}
class TRPCSubscriptionEndedError extends Error {
    constructor(message){
        super(message);
        this.name = 'TRPCSubscriptionEndedError';
        Object.setPrototypeOf(this, TRPCSubscriptionEndedError.prototype);
    }
}
function wsLink(opts) {
    return (runtime)=>{
        const { client } = opts;
        return ({ op })=>{
            return (0, _observable.observable)((observer)=>{
                const { type, path, id, context } = op;
                const input = runtime.transformer.serialize(op.input);
                let isDone = false;
                const unsub = client.request({
                    type,
                    path,
                    input,
                    id,
                    context
                }, {
                    error (err) {
                        isDone = true;
                        observer.error(err);
                        unsub();
                    },
                    complete () {
                        if (!isDone) {
                            isDone = true;
                            observer.error((0, _transformResult106791D7Mjs.T).from(new TRPCSubscriptionEndedError('Operation ended prematurely')));
                        } else observer.complete();
                    },
                    next (message) {
                        const transformed = (0, _transformResult106791D7Mjs.t)(message, runtime);
                        if (!transformed.ok) {
                            observer.error((0, _transformResult106791D7Mjs.T).from(transformed.error));
                            return;
                        }
                        observer.next({
                            result: transformed.result
                        });
                        if (op.type !== 'subscription') {
                            // if it isn't a subscription we don't care about next response
                            isDone = true;
                            unsub();
                            observer.complete();
                        }
                    }
                });
                return ()=>{
                    isDone = true;
                    unsub();
                };
            });
        };
    };
}

},{"@trpc/server/observable":"4dKlj","../transformResult-106791d7.mjs":"d5w2o","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ikoge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>createReactQueryUtilsProxy);
parcelHelpers.export(exports, "b", ()=>createReactProxyDecoration);
parcelHelpers.export(exports, "c", ()=>createHooksInternal);
var _shared = require("@trpc/server/shared");
var _reactQuery = require("@tanstack/react-query");
var _client = require("@trpc/client");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _getArrayQueryKey062214E0Mjs = require("./getArrayQueryKey-062214e0.mjs");
/**
 * We treat `undefined` as an input the same as omitting an `input`
 * https://github.com/trpc/trpc/issues/2290
 */ function getQueryKey(path, input) {
    return input === undefined ? [
        path
    ] : [
        path,
        input
    ];
}
/**
 * Create proxy for decorating procedures
 * @internal
 */ function createReactProxyDecoration(name, hooks) {
    return (0, _shared.createRecursiveProxy)((opts)=>{
        const args = opts.args;
        const pathCopy = [
            name,
            ...opts.path
        ];
        // The last arg is for instance `.useMutation` or `.useQuery()`
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const lastArg = pathCopy.pop();
        // The `path` ends up being something like `post.byId`
        const path = pathCopy.join('.');
        if (lastArg === 'useMutation') return hooks[lastArg](path, ...args);
        const [input, ...rest] = args;
        const queryKey = getQueryKey(path, input);
        return hooks[lastArg](queryKey, ...rest);
    });
}
const contextProps = [
    'client',
    'ssrContext',
    'ssrState',
    'abortOnUnmount'
];
const TRPCContext = /*#__PURE__*/ (0, _react.createContext)(null);
/**
 * @internal
 */ function createReactQueryUtilsProxy(context) {
    return (0, _shared.createFlatProxy)((key)=>{
        const contextName = key;
        if (contextProps.includes(contextName)) return context[contextName];
        return (0, _shared.createRecursiveProxy)(({ path, args })=>{
            const pathCopy = [
                key,
                ...path
            ];
            const utilName = pathCopy.pop();
            const fullPath = pathCopy.join('.');
            const getOpts = (name)=>{
                if ([
                    'setData',
                    'setInfiniteData'
                ].includes(name)) {
                    const [updater, input, ...rest] = args;
                    const queryKey = getQueryKey(fullPath, input);
                    return {
                        queryKey,
                        updater,
                        rest
                    };
                }
                const [input1, ...rest1] = args;
                const queryKey1 = getQueryKey(fullPath, input1);
                return {
                    queryKey: queryKey1,
                    rest: rest1
                };
            };
            const { queryKey, rest, updater } = getOpts(utilName);
            const contextMap = {
                fetch: ()=>context.fetchQuery(queryKey, ...rest),
                fetchInfinite: ()=>context.fetchInfiniteQuery(queryKey, ...rest),
                prefetch: ()=>context.prefetchQuery(queryKey, ...rest),
                prefetchInfinite: ()=>context.prefetchInfiniteQuery(queryKey, ...rest),
                invalidate: ()=>context.invalidateQueries(queryKey, ...rest),
                refetch: ()=>context.refetchQueries(queryKey, ...rest),
                cancel: ()=>context.cancelQuery(queryKey, ...rest),
                setData: ()=>context.setQueryData(queryKey, updater, ...rest),
                setInfiniteData: ()=>context.setInfiniteQueryData(queryKey, updater, ...rest),
                getData: ()=>context.getQueryData(queryKey),
                getInfiniteData: ()=>context.getInfiniteQueryData(queryKey)
            };
            return contextMap[utilName]();
        });
    });
}
function getClientArgs(pathAndInput, opts) {
    const [path, input] = pathAndInput;
    return [
        path,
        input,
        opts?.trpc
    ];
}
/**
 * Makes a stable reference of the `trpc` prop
 */ function useHookResult(value) {
    const ref = (0, _react.useRef)(value);
    ref.current.path = value.path;
    return ref.current;
}
/**
 * Create strongly typed react hooks
 * @internal
 */ function createHooksInternal(config) {
    const mutationSuccessOverride = config?.unstable_overrides?.useMutation?.onSuccess ?? ((options)=>options.originalFn());
    const Context = TRPCContext;
    const createClient = (opts)=>{
        return (0, _client.createTRPCClient)(opts);
    };
    const TRPCProvider = (props)=>{
        const { abortOnUnmount = false, client, queryClient, ssrContext } = props;
        const [ssrState, setSSRState] = (0, _react.useState)(props.ssrState ?? false);
        (0, _react.useEffect)(()=>{
            // Only updating state to `mounted` if we are using SSR.
            // This makes it so we don't have an unnecessary re-render when opting out of SSR.
            setSSRState((state)=>state ? 'mounted' : false);
        }, []);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
            value: {
                abortOnUnmount,
                queryClient,
                client,
                ssrContext: ssrContext || null,
                ssrState,
                fetchQuery: (0, _react.useCallback)((pathAndInput, opts)=>{
                    return queryClient.fetchQuery((0, _getArrayQueryKey062214E0Mjs.g)(pathAndInput), ()=>client.query(...getClientArgs(pathAndInput, opts)), opts);
                }, [
                    client,
                    queryClient
                ]),
                fetchInfiniteQuery: (0, _react.useCallback)((pathAndInput, opts)=>{
                    return queryClient.fetchInfiniteQuery((0, _getArrayQueryKey062214E0Mjs.g)(pathAndInput), ({ pageParam })=>{
                        const [path, input] = pathAndInput;
                        const actualInput = {
                            ...input,
                            cursor: pageParam
                        };
                        return client.query(...getClientArgs([
                            path,
                            actualInput
                        ], opts));
                    }, opts);
                }, [
                    client,
                    queryClient
                ]),
                prefetchQuery: (0, _react.useCallback)((pathAndInput, opts)=>{
                    return queryClient.prefetchQuery((0, _getArrayQueryKey062214E0Mjs.g)(pathAndInput), ()=>client.query(...getClientArgs(pathAndInput, opts)), opts);
                }, [
                    client,
                    queryClient
                ]),
                prefetchInfiniteQuery: (0, _react.useCallback)((pathAndInput, opts)=>{
                    return queryClient.prefetchInfiniteQuery((0, _getArrayQueryKey062214E0Mjs.g)(pathAndInput), ({ pageParam })=>{
                        const [path, input] = pathAndInput;
                        const actualInput = {
                            ...input,
                            cursor: pageParam
                        };
                        return client.query(...getClientArgs([
                            path,
                            actualInput
                        ], opts));
                    }, opts);
                }, [
                    client,
                    queryClient
                ]),
                invalidateQueries: (0, _react.useCallback)((...args)=>{
                    const [queryKey, ...rest] = args;
                    return queryClient.invalidateQueries((0, _getArrayQueryKey062214E0Mjs.g)(queryKey), ...rest);
                }, [
                    queryClient
                ]),
                refetchQueries: (0, _react.useCallback)((...args)=>{
                    const [queryKey, ...rest] = args;
                    return queryClient.refetchQueries((0, _getArrayQueryKey062214E0Mjs.g)(queryKey), ...rest);
                }, [
                    queryClient
                ]),
                cancelQuery: (0, _react.useCallback)((pathAndInput)=>{
                    return queryClient.cancelQueries((0, _getArrayQueryKey062214E0Mjs.g)(pathAndInput));
                }, [
                    queryClient
                ]),
                setQueryData: (0, _react.useCallback)((...args)=>{
                    const [queryKey, ...rest] = args;
                    return queryClient.setQueryData((0, _getArrayQueryKey062214E0Mjs.g)(queryKey), ...rest);
                }, [
                    queryClient
                ]),
                getQueryData: (0, _react.useCallback)((...args)=>{
                    const [queryKey, ...rest] = args;
                    return queryClient.getQueryData((0, _getArrayQueryKey062214E0Mjs.g)(queryKey), ...rest);
                }, [
                    queryClient
                ]),
                setInfiniteQueryData: (0, _react.useCallback)((...args)=>{
                    const [queryKey, ...rest] = args;
                    return queryClient.setQueryData((0, _getArrayQueryKey062214E0Mjs.g)(queryKey), ...rest);
                }, [
                    queryClient
                ]),
                getInfiniteQueryData: (0, _react.useCallback)((...args)=>{
                    const [queryKey, ...rest] = args;
                    return queryClient.getQueryData((0, _getArrayQueryKey062214E0Mjs.g)(queryKey), ...rest);
                }, [
                    queryClient
                ])
            }
        }, props.children);
    };
    function useContext() {
        return (0, _reactDefault.default).useContext(Context);
    }
    /**
   * Hack to make sure errors return `status`='error` when doing SSR
   * @link https://github.com/trpc/trpc/pull/1645
   */ function useSSRQueryOptionsIfNeeded(pathAndInput, opts) {
        const { queryClient, ssrState } = useContext();
        return ssrState && ssrState !== 'mounted' && queryClient.getQueryCache().find((0, _getArrayQueryKey062214E0Mjs.g)(pathAndInput))?.state.status === 'error' ? {
            retryOnMount: false,
            ...opts
        } : opts;
    }
    function useQuery$1(pathAndInput, opts) {
        const { abortOnUnmount, client, ssrState, queryClient, prefetchQuery } = useContext();
        if (typeof window === 'undefined' && ssrState === 'prepass' && opts?.trpc?.ssr !== false && opts?.enabled !== false && !queryClient.getQueryCache().find((0, _getArrayQueryKey062214E0Mjs.g)(pathAndInput))) prefetchQuery(pathAndInput, opts);
        const ssrOpts = useSSRQueryOptionsIfNeeded(pathAndInput, opts);
        // request option should take priority over global
        const shouldAbortOnUnmount = opts?.trpc?.abortOnUnmount ?? abortOnUnmount;
        const hook = (0, _reactQuery.useQuery)((0, _getArrayQueryKey062214E0Mjs.g)(pathAndInput), (queryFunctionContext)=>{
            const actualOpts = {
                ...ssrOpts,
                trpc: {
                    ...ssrOpts?.trpc,
                    ...shouldAbortOnUnmount ? {
                        signal: queryFunctionContext.signal
                    } : {}
                }
            };
            return client.query(...getClientArgs(pathAndInput, actualOpts));
        }, ssrOpts);
        hook.trpc = useHookResult({
            path: pathAndInput[0]
        });
        return hook;
    }
    function useMutation$1(path, opts) {
        const { client } = useContext();
        const queryClient = (0, _reactQuery.useQueryClient)();
        const hook = (0, _reactQuery.useMutation)((input)=>{
            const actualPath = Array.isArray(path) ? path[0] : path;
            return client.mutation(...getClientArgs([
                actualPath,
                input
            ], opts));
        }, {
            ...opts,
            onSuccess (...args) {
                const originalFn = ()=>opts?.onSuccess?.(...args);
                return mutationSuccessOverride({
                    originalFn,
                    queryClient
                });
            }
        });
        hook.trpc = useHookResult({
            path: Array.isArray(path) ? path[0] : path
        });
        return hook;
    }
    /* istanbul ignore next */ /**
   * ⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️
   *  **Experimental.** API might change without major version bump
   * ⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠
   */ function useSubscription(pathAndInput, opts) {
        const enabled = opts?.enabled ?? true;
        const queryKey = (0, _reactQuery.hashQueryKey)(pathAndInput);
        const { client } = useContext();
        return (0, _react.useEffect)(()=>{
            if (!enabled) return;
            const [path, input] = pathAndInput;
            let isStopped = false;
            const subscription = client.subscription(path, input ?? undefined, {
                onStarted: ()=>{
                    if (!isStopped) opts.onStarted?.();
                },
                onData: (data)=>{
                    if (!isStopped) opts.onData(data);
                },
                onError: (err)=>{
                    if (!isStopped) opts.onError?.(err);
                }
            });
            return ()=>{
                isStopped = true;
                subscription.unsubscribe();
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            queryKey,
            enabled
        ]);
    }
    function useInfiniteQuery$1(pathAndInput, opts) {
        const [path, input] = pathAndInput;
        const { client, ssrState, prefetchInfiniteQuery, queryClient, abortOnUnmount } = useContext();
        if (typeof window === 'undefined' && ssrState === 'prepass' && opts?.trpc?.ssr !== false && opts?.enabled !== false && !queryClient.getQueryCache().find((0, _getArrayQueryKey062214E0Mjs.g)(pathAndInput))) prefetchInfiniteQuery(pathAndInput, opts);
        const ssrOpts = useSSRQueryOptionsIfNeeded(pathAndInput, opts);
        // request option should take priority over global
        const shouldAbortOnUnmount = opts?.trpc?.abortOnUnmount ?? abortOnUnmount;
        const hook = (0, _reactQuery.useInfiniteQuery)((0, _getArrayQueryKey062214E0Mjs.g)(pathAndInput), (queryFunctionContext)=>{
            const actualOpts = {
                ...ssrOpts,
                trpc: {
                    ...ssrOpts?.trpc,
                    ...shouldAbortOnUnmount ? {
                        signal: queryFunctionContext.signal
                    } : {}
                }
            };
            const actualInput = {
                ...input ?? {},
                cursor: queryFunctionContext.pageParam
            };
            return client.query(...getClientArgs([
                path,
                actualInput
            ], actualOpts));
        }, ssrOpts);
        hook.trpc = useHookResult({
            path
        });
        return hook;
    }
    const useDehydratedState = (client, trpcState)=>{
        const transformed = (0, _react.useMemo)(()=>{
            if (!trpcState) return trpcState;
            return client.runtime.transformer.deserialize(trpcState);
        }, [
            trpcState,
            client
        ]);
        return transformed;
    };
    return {
        Provider: TRPCProvider,
        createClient,
        useContext,
        useQuery: useQuery$1,
        useMutation: useMutation$1,
        useSubscription,
        useDehydratedState,
        useInfiniteQuery: useInfiniteQuery$1
    };
}

},{"@trpc/server/shared":"96Vy9","@tanstack/react-query":[["hashQueryKey","7vj9i"],["useInfiniteQuery","d3pfQ"],["useMutation","1pcEM"],["useQuery","cPIoK"],["useQueryClient","dHYz4"]],"@trpc/client":"98Zm4","react":"IMRgT","./getArrayQueryKey-062214e0.mjs":"dOzeP","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7vj9i":[function(require,module,exports,__globalThis) {
// TYPES
// UTILS
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "difference", ()=>difference);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "getAbortController", ()=>getAbortController);
parcelHelpers.export(exports, "hashQueryKey", ()=>hashQueryKey);
parcelHelpers.export(exports, "hashQueryKeyByOptions", ()=>hashQueryKeyByOptions);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "isPlainArray", ()=>isPlainArray);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isQueryKey", ()=>isQueryKey);
parcelHelpers.export(exports, "isServer", ()=>isServer);
parcelHelpers.export(exports, "isValidTimeout", ()=>isValidTimeout);
parcelHelpers.export(exports, "matchMutation", ()=>matchMutation);
parcelHelpers.export(exports, "matchQuery", ()=>matchQuery);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "parseFilterArgs", ()=>parseFilterArgs);
parcelHelpers.export(exports, "parseMutationArgs", ()=>parseMutationArgs);
parcelHelpers.export(exports, "parseMutationFilterArgs", ()=>parseMutationFilterArgs);
parcelHelpers.export(exports, "parseQueryArgs", ()=>parseQueryArgs);
parcelHelpers.export(exports, "partialDeepEqual", ()=>partialDeepEqual);
parcelHelpers.export(exports, "partialMatchKey", ()=>partialMatchKey);
parcelHelpers.export(exports, "replaceAt", ()=>replaceAt);
parcelHelpers.export(exports, "replaceData", ()=>replaceData);
parcelHelpers.export(exports, "replaceEqualDeep", ()=>replaceEqualDeep);
parcelHelpers.export(exports, "scheduleMicrotask", ()=>scheduleMicrotask);
parcelHelpers.export(exports, "shallowEqualObjects", ()=>shallowEqualObjects);
parcelHelpers.export(exports, "sleep", ()=>sleep);
parcelHelpers.export(exports, "timeUntilStale", ()=>timeUntilStale);
const isServer = typeof window === 'undefined';
function noop() {
    return undefined;
}
function functionalUpdate(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function difference(array1, array2) {
    return array1.filter((x)=>array2.indexOf(x) === -1);
}
function replaceAt(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function timeUntilStale(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
    if (!isQueryKey(arg1)) return arg1;
    if (typeof arg2 === 'function') return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function parseMutationArgs(arg1, arg2, arg3) {
    if (isQueryKey(arg1)) {
        if (typeof arg2 === 'function') return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === 'function') return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function parseFilterArgs(arg1, arg2, arg3) {
    return isQueryKey(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function parseMutationFilterArgs(arg1, arg2, arg3) {
    return isQueryKey(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function matchQuery(filters, query) {
    const { type = 'all', exact, fetchStatus, predicate, queryKey, stale } = filters;
    if (isQueryKey(queryKey)) {
        if (exact) {
            if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) return false;
        } else if (!partialMatchKey(query.queryKey, queryKey)) return false;
    }
    if (type !== 'all') {
        const isActive = query.isActive();
        if (type === 'active' && !isActive) return false;
        if (type === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function matchMutation(filters, mutation) {
    const { exact, fetching, predicate, mutationKey } = filters;
    if (isQueryKey(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) return false;
        } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function hashQueryKeyByOptions(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function hashQueryKey(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>isPlainObject(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function partialMatchKey(a, b) {
    return partialDeepEqual(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function partialDeepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some((key)=>!partialDeepEqual(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function replaceEqualDeep(a, b) {
    if (a === b) return a;
    const array = isPlainArray(a) && isPlainArray(b);
    if (array || isPlainObject(a) && isPlainObject(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = replaceEqualDeep(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function shallowEqualObjects(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isPlainArray(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function isPlainObject(o) {
    if (!hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function isQueryKey(value) {
    return Array.isArray(value);
}
function isError(value) {
    return value instanceof Error;
}
function sleep(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function scheduleMicrotask(callback) {
    sleep(0).then(callback);
}
function getAbortController() {
    if (typeof AbortController === 'function') return new AbortController();
}
function replaceData(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === 'function') return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return replaceEqualDeep(prevData, data);
    return data;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"d3pfQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInfiniteQuery", ()=>useInfiniteQuery);
var _queryCore = require("@tanstack/query-core");
var _useBaseQueryEsmJs = require("./useBaseQuery.esm.js");
function useInfiniteQuery(arg1, arg2, arg3) {
    const options = (0, _queryCore.parseQueryArgs)(arg1, arg2, arg3);
    return (0, _useBaseQueryEsmJs.useBaseQuery)(options, (0, _queryCore.InfiniteQueryObserver));
}

},{"@tanstack/query-core":[["InfiniteQueryObserver","gZ1rD"],["parseQueryArgs","7vj9i"]],"./useBaseQuery.esm.js":"iJORl","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gZ1rD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InfiniteQueryObserver", ()=>InfiniteQueryObserver);
var _queryObserverEsmJs = require("./queryObserver.esm.js");
var _infiniteQueryBehaviorEsmJs = require("./infiniteQueryBehavior.esm.js");
class InfiniteQueryObserver extends (0, _queryObserverEsmJs.QueryObserver) {
    // Type override
    // Type override
    // Type override
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(client, options){
        super(client, options);
    }
    bindMethods() {
        super.bindMethods();
        this.fetchNextPage = this.fetchNextPage.bind(this);
        this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    }
    setOptions(options, notifyOptions) {
        super.setOptions({
            ...options,
            behavior: (0, _infiniteQueryBehaviorEsmJs.infiniteQueryBehavior)()
        }, notifyOptions);
    }
    getOptimisticResult(options) {
        options.behavior = (0, _infiniteQueryBehaviorEsmJs.infiniteQueryBehavior)();
        return super.getOptimisticResult(options);
    }
    fetchNextPage({ pageParam, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                fetchMore: {
                    direction: 'forward',
                    pageParam
                }
            }
        });
    }
    fetchPreviousPage({ pageParam, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                fetchMore: {
                    direction: 'backward',
                    pageParam
                }
            }
        });
    }
    createResult(query, options) {
        var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;
        const { state } = query;
        const result = super.createResult(query, options);
        return {
            ...result,
            fetchNextPage: this.fetchNextPage,
            fetchPreviousPage: this.fetchPreviousPage,
            hasNextPage: (0, _infiniteQueryBehaviorEsmJs.hasNextPage)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
            hasPreviousPage: (0, _infiniteQueryBehaviorEsmJs.hasPreviousPage)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
            isFetchingNextPage: state.fetchStatus === 'fetching' && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
            isFetchingPreviousPage: state.fetchStatus === 'fetching' && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
        };
    }
}

},{"./queryObserver.esm.js":"lfMcg","./infiniteQueryBehavior.esm.js":"amkdl","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lfMcg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryObserver", ()=>QueryObserver);
var _utilsEsmJs = require("./utils.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
var _retryerEsmJs = require("./retryer.esm.js");
class QueryObserver extends (0, _subscribableEsmJs.Subscribable) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.length === 1) {
            this.currentQuery.addObserver(this);
            if (shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    }
    shouldFetchOnReconnect() {
        return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = [];
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, _utilsEsmJs.shallowEqualObjects)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: 'observerOptionsUpdated',
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        return this.createResult(query, options);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, _utilsEsmJs.noop));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, _utilsEsmJs.isServer) || this.currentResult.isStale || !(0, _utilsEsmJs.isValidTimeout)(this.options.staleTime)) return;
        const time = (0, _utilsEsmJs.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, _utilsEsmJs.isServer) || this.options.enabled === false || !(0, _utilsEsmJs.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, _focusManagerEsmJs.focusManager).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state } = query;
        let { dataUpdatedAt, error, errorUpdatedAt, fetchStatus, status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, _retryerEsmJs.canFetch)(query.options.networkMode) ? 'fetching' : 'paused';
                if (!dataUpdatedAt) status = 'loading';
            }
            if (options._optimisticResults === 'isRestoring') fetchStatus = 'idle';
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, _utilsEsmJs.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = (0, _utilsEsmJs.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        const isFetching = fetchStatus === 'fetching';
        const isLoading = status === 'loading';
        const isError = status === 'error';
        const result = {
            status,
            fetchStatus,
            isLoading,
            isSuccess: status === 'success',
            isError,
            isInitialLoading: isLoading && isFetching,
            data,
            dataUpdatedAt,
            error,
            errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === 'paused',
            isPlaceholderData,
            isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, _utilsEsmJs.shallowEqualObjects)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps } = this.options;
            if (notifyOnChangeProps === 'all' || !notifyOnChangeProps && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangeProps != null ? notifyOnChangeProps : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add('error');
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = !action.manual;
        else if (action.type === 'error' && !(0, _retryerEsmJs.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    }
}
function shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
    return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && isStale(query, options);
    }
    return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}
function isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}

},{"./utils.esm.js":"7vj9i","./notifyManager.esm.js":"gHeSt","./focusManager.esm.js":"bJODz","./subscribable.esm.js":"88oBp","./retryer.esm.js":"gZRdF","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gHeSt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNotifyManager", ()=>createNotifyManager);
parcelHelpers.export(exports, "notifyManager", ()=>notifyManager);
var _utilsEsmJs = require("./utils.esm.js");
function createNotifyManager() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, _utilsEsmJs.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, _utilsEsmJs.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch,
        batchCalls,
        schedule,
        setNotifyFunction,
        setBatchNotifyFunction
    };
} // SINGLETON
const notifyManager = createNotifyManager();

},{"./utils.esm.js":"7vj9i","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"bJODz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusManager", ()=>FocusManager);
parcelHelpers.export(exports, "focusManager", ()=>focusManager);
var _subscribableEsmJs = require("./subscribable.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
class FocusManager extends (0, _subscribableEsmJs.Subscribable) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, _utilsEsmJs.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === 'boolean') this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    }
    onFocus() {
        this.listeners.forEach((listener)=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    }
}
const focusManager = new FocusManager();

},{"./subscribable.esm.js":"88oBp","./utils.esm.js":"7vj9i","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"88oBp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscribable", ()=>Subscribable);
class Subscribable {
    constructor(){
        this.listeners = [];
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.push(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners = this.listeners.filter((x)=>x !== listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.length > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gZRdF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>CancelledError);
parcelHelpers.export(exports, "canFetch", ()=>canFetch);
parcelHelpers.export(exports, "createRetryer", ()=>createRetryer);
parcelHelpers.export(exports, "isCancelledError", ()=>isCancelledError);
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _onlineManagerEsmJs = require("./onlineManager.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
function defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function canFetch(networkMode) {
    return (networkMode != null ? networkMode : 'online') === 'online' ? (0, _onlineManagerEsmJs.onlineManager).isOnline() : true;
}
class CancelledError {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function isCancelledError(value) {
    return value instanceof CancelledError;
}
function createRetryer(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new CancelledError(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, _focusManagerEsmJs.focusManager).isFocused() || config.networkMode !== 'always' && !(0, _onlineManagerEsmJs.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved || !shouldPause()) return continueResolve(value);
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
            const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, _utilsEsmJs.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if (canFetch(config.networkMode)) run();
    else pause().then(run);
    return {
        promise,
        cancel,
        continue: ()=>{
            continueFn == null || continueFn();
        },
        cancelRetry,
        continueRetry
    };
}

},{"./focusManager.esm.js":"bJODz","./onlineManager.esm.js":"gFqOB","./utils.esm.js":"7vj9i","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gFqOB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnlineManager", ()=>OnlineManager);
parcelHelpers.export(exports, "onlineManager", ()=>onlineManager);
var _subscribableEsmJs = require("./subscribable.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
class OnlineManager extends (0, _subscribableEsmJs.Subscribable) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, _utilsEsmJs.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                window.addEventListener('online', listener, false);
                window.addEventListener('offline', listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('online', listener);
                    window.removeEventListener('offline', listener);
                };
            }
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === 'boolean') this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    }
    onOnline() {
        this.listeners.forEach((listener)=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    }
}
const onlineManager = new OnlineManager();

},{"./subscribable.esm.js":"88oBp","./utils.esm.js":"7vj9i","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"amkdl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNextPageParam", ()=>getNextPageParam);
parcelHelpers.export(exports, "getPreviousPageParam", ()=>getPreviousPageParam);
parcelHelpers.export(exports, "hasNextPage", ()=>hasNextPage);
parcelHelpers.export(exports, "hasPreviousPage", ()=>hasPreviousPage);
parcelHelpers.export(exports, "infiniteQueryBehavior", ()=>infiniteQueryBehavior);
function infiniteQueryBehavior() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, 'signal', {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener('abort', ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject('Missing queryFn'));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : getNextPageParam(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : getPreviousPageParam(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === 'undefined';
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function getNextPageParam(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function hasNextPage(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = getNextPageParam(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function hasPreviousPage(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = getPreviousPageParam(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iJORl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBaseQuery", ()=>useBaseQuery);
var _react = require("react");
var _useSyncExternalStoreEsmJs = require("./useSyncExternalStore.esm.js");
var _queryCore = require("@tanstack/query-core");
var _queryErrorResetBoundaryEsmJs = require("./QueryErrorResetBoundary.esm.js");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
var _isRestoringEsmJs = require("./isRestoring.esm.js");
var _errorBoundaryUtilsEsmJs = require("./errorBoundaryUtils.esm.js");
function useBaseQuery(options, Observer) {
    const queryClient = (0, _queryClientProviderEsmJs.useQueryClient)({
        context: options.context
    });
    const isRestoring = (0, _isRestoringEsmJs.useIsRestoring)();
    const errorResetBoundary = (0, _queryErrorResetBoundaryEsmJs.useQueryErrorResetBoundary)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, _queryCore.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, _queryCore.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, _queryCore.notifyManager).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
    }
    (0, _errorBoundaryUtilsEsmJs.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, _errorBoundaryUtilsEsmJs.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = _react.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, _useSyncExternalStoreEsmJs.useSyncExternalStore)(_react.useCallback((onStoreChange)=>isRestoring ? ()=>undefined : observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)), [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    _react.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if (defaultedOptions.suspense && result.isLoading && result.isFetching && !isRestoring) throw observer.fetchOptimistic(defaultedOptions).then(({ data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });
     // Handle error boundary
    if ((0, _errorBoundaryUtilsEsmJs.getHasError)({
        result,
        errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

},{"react":"IMRgT","./useSyncExternalStore.esm.js":"itJLV","@tanstack/query-core":"gHeSt","./QueryErrorResetBoundary.esm.js":"21JTM","./QueryClientProvider.esm.js":"dHYz4","./isRestoring.esm.js":"kGxG6","./errorBoundaryUtils.esm.js":"3b0Wd","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"itJLV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>useSyncExternalStore);
var _indexJs = require("use-sync-external-store/shim/index.js");
// Temporary workaround due to an issue with react-native uSES - https://github.com/TanStack/query/pull/3601
const useSyncExternalStore = (0, _indexJs.useSyncExternalStore);

},{"use-sync-external-store/shim/index.js":"cl2XL","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cl2XL":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("3e3e060a1c619377");

},{"3e3e060a1c619377":"41O0p"}],"41O0p":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("a18024ece7b3cd12");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    useEffect(function() {
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    useDebugValue(value);
    return value;
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;

},{"a18024ece7b3cd12":"IMRgT"}],"21JTM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>QueryErrorResetBoundary);
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>useQueryErrorResetBoundary);
var _react = require("react");
function createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const QueryErrorResetBoundaryContext = /*#__PURE__*/ _react.createContext(createValue()); // HOOK
const useQueryErrorResetBoundary = ()=>_react.useContext(QueryErrorResetBoundaryContext); // COMPONENT
const QueryErrorResetBoundary = ({ children })=>{
    const [value] = _react.useState(()=>createValue());
    return /*#__PURE__*/ _react.createElement(QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dHYz4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClientProvider", ()=>QueryClientProvider);
parcelHelpers.export(exports, "defaultContext", ()=>defaultContext);
parcelHelpers.export(exports, "useQueryClient", ()=>useQueryClient);
var _react = require("react");
const defaultContext = /*#__PURE__*/ _react.createContext(undefined);
const QueryClientSharingContext = /*#__PURE__*/ _react.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = defaultContext;
        return window.ReactQueryClientContext;
    }
    return defaultContext;
}
const useQueryClient = ({ context } = {})=>{
    const queryClient = _react.useContext(getQueryClientContext(context, _react.useContext(QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
const QueryClientProvider = ({ client, children, context, contextSharing = false })=>{
    _react.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ _react.createElement(QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ _react.createElement(Context.Provider, {
        value: client
    }, children));
};

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kGxG6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsRestoringProvider", ()=>IsRestoringProvider);
parcelHelpers.export(exports, "useIsRestoring", ()=>useIsRestoring);
var _react = require("react");
const IsRestoringContext = /*#__PURE__*/ _react.createContext(false);
const useIsRestoring = ()=>_react.useContext(IsRestoringContext);
const IsRestoringProvider = IsRestoringContext.Provider;

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3b0Wd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensurePreventErrorBoundaryRetry", ()=>ensurePreventErrorBoundaryRetry);
parcelHelpers.export(exports, "getHasError", ()=>getHasError);
parcelHelpers.export(exports, "useClearResetErrorBoundary", ()=>useClearResetErrorBoundary);
var _react = require("react");
var _utilsEsmJs = require("./utils.esm.js");
const ensurePreventErrorBoundaryRetry = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const useClearResetErrorBoundary = (errorResetBoundary)=>{
    _react.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const getHasError = ({ result, errorResetBoundary, useErrorBoundary, query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, _utilsEsmJs.shouldThrowError)(useErrorBoundary, [
        result.error,
        query
    ]);
};

},{"react":"IMRgT","./utils.esm.js":"aGl5S","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"aGl5S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldThrowError", ()=>shouldThrowError);
function shouldThrowError(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1pcEM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMutation", ()=>useMutation);
var _react = require("react");
var _useSyncExternalStoreEsmJs = require("./useSyncExternalStore.esm.js");
var _queryCore = require("@tanstack/query-core");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
function useMutation(arg1, arg2, arg3) {
    const options = (0, _queryCore.parseMutationArgs)(arg1, arg2, arg3);
    const queryClient = (0, _queryClientProviderEsmJs.useQueryClient)({
        context: options.context
    });
    const [observer] = _react.useState(()=>new (0, _queryCore.MutationObserver)(queryClient, options));
    _react.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, _useSyncExternalStoreEsmJs.useSyncExternalStore)(_react.useCallback((onStoreChange)=>observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = _react.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch(noop);
    }, [
        observer
    ]);
    if (result.error && (0, _utilsEsmJs.shouldThrowError)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() {}

},{"react":"IMRgT","./useSyncExternalStore.esm.js":"itJLV","@tanstack/query-core":[["MutationObserver","11SkN"],["notifyManager","gHeSt"],["parseMutationArgs","7vj9i"]],"./QueryClientProvider.esm.js":"dHYz4","./utils.esm.js":"aGl5S","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"11SkN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationObserver", ()=>MutationObserver);
var _mutationEsmJs = require("./mutation.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
// CLASS
class MutationObserver extends (0, _subscribableEsmJs.Subscribable) {
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, _utilsEsmJs.shallowEqualObjects)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: 'observerOptionsUpdated',
            mutation: this.currentMutation,
            observer: this
        });
    }
    onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error') notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== 'undefined' ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, _mutationEsmJs.getDefaultState)();
        const result = {
            ...state,
            isLoading: state.status === 'loading',
            isSuccess: state.status === 'success',
            isError: state.status === 'error',
            isIdle: state.status === 'idle',
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach((listener)=>{
                listener(this.currentResult);
            });
        });
    }
}

},{"./mutation.esm.js":"hpP7c","./notifyManager.esm.js":"gHeSt","./subscribable.esm.js":"88oBp","./utils.esm.js":"7vj9i","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hpP7c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mutation", ()=>Mutation);
parcelHelpers.export(exports, "getDefaultState", ()=>getDefaultState);
var _loggerEsmJs = require("./logger.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _removableEsmJs = require("./removable.esm.js");
var _retryerEsmJs = require("./retryer.esm.js");
// CLASS
class Mutation extends (0, _removableEsmJs.Removable) {
    constructor(config){
        super();
        this.options = {
            ...config.defaultOptions,
            ...config.options
        };
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, _loggerEsmJs.defaultLogger);
        this.observers = [];
        this.state = config.state || getDefaultState();
        this.meta = config.meta;
        this.updateCacheTime(this.options.cacheTime);
        this.scheduleGc();
    }
    setState(state) {
        this.dispatch({
            type: 'setState',
            state
        });
    }
    addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: 'observerAdded',
                mutation: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: 'observerRemoved',
            mutation: this,
            observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === 'loading') this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, _retryerEsmJs.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject('No mutationFn found');
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: 'failed',
                        failureCount,
                        error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: 'pause'
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: 'continue'
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === 'loading';
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: 'loading',
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: 'loading',
                    context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: 'success',
                data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onError, _this$options4, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: 'error',
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        isPaused: true
                    };
                case 'continue':
                    return {
                        ...state,
                        isPaused: false
                    };
                case 'loading':
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, _retryerEsmJs.canFetch)(this.options.networkMode),
                        status: 'loading',
                        variables: action.variables
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: 'success',
                        isPaused: false
                    };
                case 'error':
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: 'error'
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: 'updated',
                action
            });
        });
    }
}
function getDefaultState() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}

},{"./logger.esm.js":"9IkI2","./notifyManager.esm.js":"gHeSt","./removable.esm.js":"4w8Xr","./retryer.esm.js":"gZRdF","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9IkI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultLogger", ()=>defaultLogger);
const defaultLogger = console;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4w8Xr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Removable", ()=>Removable);
var _utilsEsmJs = require("./utils.esm.js");
class Removable {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, _utilsEsmJs.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, _utilsEsmJs.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}

},{"./utils.esm.js":"7vj9i","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cPIoK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQuery", ()=>useQuery);
var _queryCore = require("@tanstack/query-core");
var _useBaseQueryEsmJs = require("./useBaseQuery.esm.js");
function useQuery(arg1, arg2, arg3) {
    const parsedOptions = (0, _queryCore.parseQueryArgs)(arg1, arg2, arg3);
    return (0, _useBaseQueryEsmJs.useBaseQuery)(parsedOptions, (0, _queryCore.QueryObserver));
}

},{"@tanstack/query-core":[["parseQueryArgs","7vj9i"],["QueryObserver","lfMcg"]],"./useBaseQuery.esm.js":"iJORl","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dOzeP":[function(require,module,exports,__globalThis) {
/**
 * To allow easy interactions with groups of related queries, such as
 * invalidating all queries of a router, we use an array as the path when
 * storing in tanstack query. This function converts from the `.` separated
 * path passed around internally by both the legacy and proxy implementation.
 * https://github.com/trpc/trpc/issues/2611
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "g", ()=>getArrayQueryKey);
function getArrayQueryKey(queryKey) {
    const queryKeyArrayed = Array.isArray(queryKey) ? queryKey : [
        queryKey
    ];
    const [path, ...input] = queryKeyArrayed;
    const arrayPath = typeof path !== 'string' || path === '' ? [] : path.split('.');
    return [
        arrayPath,
        ...input
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"dh3yw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueries", ()=>(0, _useQueriesEsmJs.useQueries));
parcelHelpers.export(exports, "useQuery", ()=>(0, _useQueryEsmJs.useQuery));
parcelHelpers.export(exports, "QueryClientProvider", ()=>(0, _queryClientProviderEsmJs.QueryClientProvider));
parcelHelpers.export(exports, "defaultContext", ()=>(0, _queryClientProviderEsmJs.defaultContext));
parcelHelpers.export(exports, "useQueryClient", ()=>(0, _queryClientProviderEsmJs.useQueryClient));
parcelHelpers.export(exports, "Hydrate", ()=>(0, _hydrateEsmJs.Hydrate));
parcelHelpers.export(exports, "useHydrate", ()=>(0, _hydrateEsmJs.useHydrate));
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryEsmJs.QueryErrorResetBoundary));
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryEsmJs.useQueryErrorResetBoundary));
parcelHelpers.export(exports, "useIsFetching", ()=>(0, _useIsFetchingEsmJs.useIsFetching));
parcelHelpers.export(exports, "useIsMutating", ()=>(0, _useIsMutatingEsmJs.useIsMutating));
parcelHelpers.export(exports, "useMutation", ()=>(0, _useMutationEsmJs.useMutation));
parcelHelpers.export(exports, "useInfiniteQuery", ()=>(0, _useInfiniteQueryEsmJs.useInfiniteQuery));
parcelHelpers.export(exports, "IsRestoringProvider", ()=>(0, _isRestoringEsmJs.IsRestoringProvider));
parcelHelpers.export(exports, "useIsRestoring", ()=>(0, _isRestoringEsmJs.useIsRestoring));
var _setBatchUpdatesFnEsmJs = require("./setBatchUpdatesFn.esm.js");
var _queryCore = require("@tanstack/query-core");
parcelHelpers.exportAll(_queryCore, exports);
var _useQueriesEsmJs = require("./useQueries.esm.js");
var _useQueryEsmJs = require("./useQuery.esm.js");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
var _hydrateEsmJs = require("./Hydrate.esm.js");
var _queryErrorResetBoundaryEsmJs = require("./QueryErrorResetBoundary.esm.js");
var _useIsFetchingEsmJs = require("./useIsFetching.esm.js");
var _useIsMutatingEsmJs = require("./useIsMutating.esm.js");
var _useMutationEsmJs = require("./useMutation.esm.js");
var _useInfiniteQueryEsmJs = require("./useInfiniteQuery.esm.js");
var _isRestoringEsmJs = require("./isRestoring.esm.js");

},{"./setBatchUpdatesFn.esm.js":"b8HAc","@tanstack/query-core":"9gAUq","./useQueries.esm.js":"eumNo","./useQuery.esm.js":"cPIoK","./QueryClientProvider.esm.js":"dHYz4","./Hydrate.esm.js":"lUbVC","./QueryErrorResetBoundary.esm.js":"21JTM","./useIsFetching.esm.js":"4dDbf","./useIsMutating.esm.js":"8J7CR","./useMutation.esm.js":"1pcEM","./useInfiniteQuery.esm.js":"d3pfQ","./isRestoring.esm.js":"kGxG6","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"b8HAc":[function(require,module,exports,__globalThis) {
var _queryCore = require("@tanstack/query-core");
var _reactBatchedUpdatesEsmJs = require("./reactBatchedUpdates.esm.js");
(0, _queryCore.notifyManager).setBatchNotifyFunction((0, _reactBatchedUpdatesEsmJs.unstable_batchedUpdates));

},{"@tanstack/query-core":"gHeSt","./reactBatchedUpdates.esm.js":"kxNZp"}],"kxNZp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>unstable_batchedUpdates);
var _reactDom = require("react-dom");
const unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

},{"react-dom":"fODdr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"9gAUq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>(0, _retryerEsmJs.CancelledError));
parcelHelpers.export(exports, "isCancelledError", ()=>(0, _retryerEsmJs.isCancelledError));
parcelHelpers.export(exports, "QueryCache", ()=>(0, _queryCacheEsmJs.QueryCache));
parcelHelpers.export(exports, "QueryClient", ()=>(0, _queryClientEsmJs.QueryClient));
parcelHelpers.export(exports, "QueryObserver", ()=>(0, _queryObserverEsmJs.QueryObserver));
parcelHelpers.export(exports, "QueriesObserver", ()=>(0, _queriesObserverEsmJs.QueriesObserver));
parcelHelpers.export(exports, "InfiniteQueryObserver", ()=>(0, _infiniteQueryObserverEsmJs.InfiniteQueryObserver));
parcelHelpers.export(exports, "MutationCache", ()=>(0, _mutationCacheEsmJs.MutationCache));
parcelHelpers.export(exports, "MutationObserver", ()=>(0, _mutationObserverEsmJs.MutationObserver));
parcelHelpers.export(exports, "notifyManager", ()=>(0, _notifyManagerEsmJs.notifyManager));
parcelHelpers.export(exports, "focusManager", ()=>(0, _focusManagerEsmJs.focusManager));
parcelHelpers.export(exports, "onlineManager", ()=>(0, _onlineManagerEsmJs.onlineManager));
parcelHelpers.export(exports, "hashQueryKey", ()=>(0, _utilsEsmJs.hashQueryKey));
parcelHelpers.export(exports, "isError", ()=>(0, _utilsEsmJs.isError));
parcelHelpers.export(exports, "isServer", ()=>(0, _utilsEsmJs.isServer));
parcelHelpers.export(exports, "parseFilterArgs", ()=>(0, _utilsEsmJs.parseFilterArgs));
parcelHelpers.export(exports, "parseMutationArgs", ()=>(0, _utilsEsmJs.parseMutationArgs));
parcelHelpers.export(exports, "parseMutationFilterArgs", ()=>(0, _utilsEsmJs.parseMutationFilterArgs));
parcelHelpers.export(exports, "parseQueryArgs", ()=>(0, _utilsEsmJs.parseQueryArgs));
parcelHelpers.export(exports, "replaceEqualDeep", ()=>(0, _utilsEsmJs.replaceEqualDeep));
parcelHelpers.export(exports, "dehydrate", ()=>(0, _hydrationEsmJs.dehydrate));
parcelHelpers.export(exports, "hydrate", ()=>(0, _hydrationEsmJs.hydrate));
var _retryerEsmJs = require("./retryer.esm.js");
var _queryCacheEsmJs = require("./queryCache.esm.js");
var _queryClientEsmJs = require("./queryClient.esm.js");
var _queryObserverEsmJs = require("./queryObserver.esm.js");
var _queriesObserverEsmJs = require("./queriesObserver.esm.js");
var _infiniteQueryObserverEsmJs = require("./infiniteQueryObserver.esm.js");
var _mutationCacheEsmJs = require("./mutationCache.esm.js");
var _mutationObserverEsmJs = require("./mutationObserver.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _onlineManagerEsmJs = require("./onlineManager.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
var _hydrationEsmJs = require("./hydration.esm.js");

},{"./retryer.esm.js":"gZRdF","./queryCache.esm.js":"fYi1C","./queryClient.esm.js":"jC0Ps","./queryObserver.esm.js":"lfMcg","./queriesObserver.esm.js":"kFCYB","./infiniteQueryObserver.esm.js":"gZ1rD","./mutationCache.esm.js":"daGxX","./mutationObserver.esm.js":"11SkN","./notifyManager.esm.js":"gHeSt","./focusManager.esm.js":"bJODz","./onlineManager.esm.js":"gFqOB","./utils.esm.js":"7vj9i","./hydration.esm.js":"fia7A","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fYi1C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryCache", ()=>QueryCache);
var _utilsEsmJs = require("./utils.esm.js");
var _queryEsmJs = require("./query.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
// CLASS
class QueryCache extends (0, _subscribableEsmJs.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, _utilsEsmJs.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, _queryEsmJs.Query)({
                cache: this,
                logger: client.getLogger(),
                queryKey,
                queryHash,
                options: client.defaultQueryOptions(options),
                state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'added',
                query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'removed',
                query
            });
        }
    }
    clear() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find((query)=>(0, _utilsEsmJs.matchQuery)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, _utilsEsmJs.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}

},{"./utils.esm.js":"7vj9i","./query.esm.js":"4Ybjs","./notifyManager.esm.js":"gHeSt","./subscribable.esm.js":"88oBp","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4Ybjs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Query", ()=>Query);
var _utilsEsmJs = require("./utils.esm.js");
var _loggerEsmJs = require("./logger.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _retryerEsmJs = require("./retryer.esm.js");
var _removableEsmJs = require("./removable.esm.js");
// CLASS
class Query extends (0, _removableEsmJs.Removable) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, _loggerEsmJs.defaultLogger);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.meta = options == null ? void 0 : options.meta;
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === 'idle') this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, _utilsEsmJs.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state,
            setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, _utilsEsmJs.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== 'idle') {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        Array.isArray(this.options.queryKey);
        const abortController = (0, _utilsEsmJs.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, 'signal', {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject('Missing queryFn');
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn,
            meta: this.meta
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, _retryerEsmJs.isCancelledError)(error) && error.silent)) this.dispatch({
                type: 'error',
                error: error
            });
            if (!(0, _retryerEsmJs.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, _retryerEsmJs.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on2, _this$cache$config2;
                if (typeof data === 'undefined') {
                    onError(new Error('undefined'));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSuccess) == null || _this$cache$config$on2.call(_this$cache$config2, data, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: 'failed',
                    failureCount,
                    error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: 'pause'
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        fetchStatus: 'paused'
                    };
                case 'continue':
                    return {
                        ...state,
                        fetchStatus: 'fetching'
                    };
                case 'fetch':
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, _retryerEsmJs.canFetch)(this.options.networkMode) ? 'fetching' : 'paused',
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: 'loading'
                        }
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: 'success',
                        ...!action.manual && {
                            fetchStatus: 'idle',
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case 'error':
                    const error = action.error;
                    if ((0, _retryerEsmJs.isCancelledError)(error) && error.revert && this.revertState) return {
                        ...this.revertState
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: 'idle',
                        status: 'error'
                    };
                case 'invalidate':
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: 'updated',
                action
            });
        });
    }
}
function getDefaultState(options) {
    const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    const hasData = typeof data !== 'undefined';
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? 'success' : 'loading',
        fetchStatus: 'idle'
    };
}

},{"./utils.esm.js":"7vj9i","./logger.esm.js":"9IkI2","./notifyManager.esm.js":"gHeSt","./retryer.esm.js":"gZRdF","./removable.esm.js":"4w8Xr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jC0Ps":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClient", ()=>QueryClient);
var _utilsEsmJs = require("./utils.esm.js");
var _queryCacheEsmJs = require("./queryCache.esm.js");
var _mutationCacheEsmJs = require("./mutationCache.esm.js");
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _onlineManagerEsmJs = require("./onlineManager.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _infiniteQueryBehaviorEsmJs = require("./infiniteQueryBehavior.esm.js");
var _loggerEsmJs = require("./logger.esm.js");
// CLASS
class QueryClient {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, _queryCacheEsmJs.QueryCache)();
        this.mutationCache = config.mutationCache || new (0, _mutationCacheEsmJs.MutationCache)();
        this.logger = config.logger || (0, _loggerEsmJs.defaultLogger);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    mount() {
        this.unsubscribeFocus = (0, _focusManagerEsmJs.focusManager).subscribe(()=>{
            if ((0, _focusManagerEsmJs.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, _onlineManagerEsmJs.onlineManager).subscribe(()=>{
            if ((0, _onlineManagerEsmJs.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = 'fetching';
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey, state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, _utilsEsmJs.functionalUpdate)(updater, prevData);
        if (typeof data === 'undefined') return undefined;
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, _notifyManagerEsmJs.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: 'active',
            ...filters
        };
        return (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        const promises = (0, _notifyManagerEsmJs.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        return (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === 'none') return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, _notifyManagerEsmJs.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, _utilsEsmJs.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, _utilsEsmJs.noop));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, _infiniteQueryBehaviorEsmJs.infiniteQueryBehavior)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, _utilsEsmJs.hashQueryKey)(queryKey) === (0, _utilsEsmJs.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, _utilsEsmJs.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, _utilsEsmJs.hashQueryKey)(mutationKey) === (0, _utilsEsmJs.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, _utilsEsmJs.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, _utilsEsmJs.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === 'undefined') defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
        if (typeof defaultedOptions.useErrorBoundary === 'undefined') defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}

},{"./utils.esm.js":"7vj9i","./queryCache.esm.js":"fYi1C","./mutationCache.esm.js":"daGxX","./focusManager.esm.js":"bJODz","./onlineManager.esm.js":"gFqOB","./notifyManager.esm.js":"gHeSt","./infiniteQueryBehavior.esm.js":"amkdl","./logger.esm.js":"9IkI2","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"daGxX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationCache", ()=>MutationCache);
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _mutationEsmJs = require("./mutation.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
// CLASS
class MutationCache extends (0, _subscribableEsmJs.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, _mutationEsmJs.Mutation)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: 'added',
            mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: 'removed',
            mutation
        });
    }
    clear() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find((mutation)=>(0, _utilsEsmJs.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, _utilsEsmJs.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
        return (0, _notifyManagerEsmJs.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, _utilsEsmJs.noop))), Promise.resolve()));
    }
}

},{"./notifyManager.esm.js":"gHeSt","./mutation.esm.js":"hpP7c","./utils.esm.js":"7vj9i","./subscribable.esm.js":"88oBp","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kFCYB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueriesObserver", ()=>QueriesObserver);
var _utilsEsmJs = require("./utils.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _queryObserverEsmJs = require("./queryObserver.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
class QueriesObserver extends (0, _subscribableEsmJs.Subscribable) {
    constructor(client, queries){
        super();
        this.client = client;
        this.queries = [];
        this.result = [];
        this.observers = [];
        this.observersMap = {};
        if (queries) this.setQueries(queries);
    }
    onSubscribe() {
        if (this.listeners.length === 1) this.observers.forEach((observer)=>{
            observer.subscribe((result)=>{
                this.onUpdate(observer, result);
            });
        });
    }
    onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    }
    destroy() {
        this.listeners = [];
        this.observers.forEach((observer)=>{
            observer.destroy();
        });
    }
    setQueries(queries, notifyOptions) {
        this.queries = queries;
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            const prevObservers = this.observers;
            const newObserverMatches = this.findMatchingObservers(this.queries); // set options for the new observers to notify of changes
            newObserverMatches.forEach((match)=>match.observer.setOptions(match.defaultedQueryOptions, notifyOptions));
            const newObservers = newObserverMatches.map((match)=>match.observer);
            const newObserversMap = Object.fromEntries(newObservers.map((observer)=>[
                    observer.options.queryHash,
                    observer
                ]));
            const newResult = newObservers.map((observer)=>observer.getCurrentResult());
            const hasIndexChange = newObservers.some((observer, index)=>observer !== prevObservers[index]);
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            this.observers = newObservers;
            this.observersMap = newObserversMap;
            this.result = newResult;
            if (!this.hasListeners()) return;
            (0, _utilsEsmJs.difference)(prevObservers, newObservers).forEach((observer)=>{
                observer.destroy();
            });
            (0, _utilsEsmJs.difference)(newObservers, prevObservers).forEach((observer)=>{
                observer.subscribe((result)=>{
                    this.onUpdate(observer, result);
                });
            });
            this.notify();
        });
    }
    getCurrentResult() {
        return this.result;
    }
    getQueries() {
        return this.observers.map((observer)=>observer.getCurrentQuery());
    }
    getOptimisticResult(queries) {
        return this.findMatchingObservers(queries).map((match)=>match.observer.getOptimisticResult(match.defaultedQueryOptions));
    }
    findMatchingObservers(queries) {
        const prevObservers = this.observers;
        const defaultedQueryOptions = queries.map((options)=>this.client.defaultQueryOptions(options));
        const matchingObservers = defaultedQueryOptions.flatMap((defaultedOptions)=>{
            const match = prevObservers.find((observer)=>observer.options.queryHash === defaultedOptions.queryHash);
            if (match != null) return [
                {
                    defaultedQueryOptions: defaultedOptions,
                    observer: match
                }
            ];
            return [];
        });
        const matchedQueryHashes = matchingObservers.map((match)=>match.defaultedQueryOptions.queryHash);
        const unmatchedQueries = defaultedQueryOptions.filter((defaultedOptions)=>!matchedQueryHashes.includes(defaultedOptions.queryHash));
        const unmatchedObservers = prevObservers.filter((prevObserver)=>!matchingObservers.some((match)=>match.observer === prevObserver));
        const getObserver = (options)=>{
            const defaultedOptions = this.client.defaultQueryOptions(options);
            const currentObserver = this.observersMap[defaultedOptions.queryHash];
            return currentObserver != null ? currentObserver : new (0, _queryObserverEsmJs.QueryObserver)(this.client, defaultedOptions);
        };
        const newOrReusedObservers = unmatchedQueries.map((options, index)=>{
            if (options.keepPreviousData) {
                // return previous data from one of the observers that no longer match
                const previouslyUsedObserver = unmatchedObservers[index];
                if (previouslyUsedObserver !== undefined) return {
                    defaultedQueryOptions: options,
                    observer: previouslyUsedObserver
                };
            }
            return {
                defaultedQueryOptions: options,
                observer: getObserver(options)
            };
        });
        const sortMatchesByOrderOfQueries = (a, b)=>defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
        return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
    }
    onUpdate(observer, result) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.result = (0, _utilsEsmJs.replaceAt)(this.result, index, result);
            this.notify();
        }
    }
    notify() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(this.result);
            });
        });
    }
}

},{"./utils.esm.js":"7vj9i","./notifyManager.esm.js":"gHeSt","./queryObserver.esm.js":"lfMcg","./subscribable.esm.js":"88oBp","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"fia7A":[function(require,module,exports,__globalThis) {
// TYPES
// FUNCTIONS
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dehydrate", ()=>dehydrate);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
function dehydrateMutation(mutation) {
    return {
        mutationKey: mutation.options.mutationKey,
        state: mutation.state
    };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.
function dehydrateQuery(query) {
    return {
        state: query.state,
        queryKey: query.queryKey,
        queryHash: query.queryHash
    };
}
function defaultShouldDehydrateMutation(mutation) {
    return mutation.state.isPaused;
}
function defaultShouldDehydrateQuery(query) {
    return query.state.status === 'success';
}
function dehydrate(client, options = {}) {
    const mutations = [];
    const queries = [];
    if (options.dehydrateMutations !== false) {
        const shouldDehydrateMutation = options.shouldDehydrateMutation || defaultShouldDehydrateMutation;
        client.getMutationCache().getAll().forEach((mutation)=>{
            if (shouldDehydrateMutation(mutation)) mutations.push(dehydrateMutation(mutation));
        });
    }
    if (options.dehydrateQueries !== false) {
        const shouldDehydrateQuery = options.shouldDehydrateQuery || defaultShouldDehydrateQuery;
        client.getQueryCache().getAll().forEach((query)=>{
            if (shouldDehydrateQuery(query)) queries.push(dehydrateQuery(query));
        });
    }
    return {
        mutations,
        queries
    };
}
function hydrate(client, dehydratedState, options) {
    if (typeof dehydratedState !== 'object' || dehydratedState === null) return;
    const mutationCache = client.getMutationCache();
    const queryCache = client.getQueryCache(); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const mutations = dehydratedState.mutations || []; // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const queries = dehydratedState.queries || [];
    mutations.forEach((dehydratedMutation)=>{
        var _options$defaultOptio;
        mutationCache.build(client, {
            ...options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations,
            mutationKey: dehydratedMutation.mutationKey
        }, dehydratedMutation.state);
    });
    queries.forEach((dehydratedQuery)=>{
        var _options$defaultOptio2;
        const query = queryCache.get(dehydratedQuery.queryHash); // Do not hydrate if an existing query exists with newer data
        if (query) {
            if (query.state.dataUpdatedAt < dehydratedQuery.state.dataUpdatedAt) query.setState(dehydratedQuery.state);
            return;
        } // Restore query
        queryCache.build(client, {
            ...options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries,
            queryKey: dehydratedQuery.queryKey,
            queryHash: dehydratedQuery.queryHash
        }, dehydratedQuery.state);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"eumNo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueries", ()=>useQueries);
var _react = require("react");
var _useSyncExternalStoreEsmJs = require("./useSyncExternalStore.esm.js");
var _queryCore = require("@tanstack/query-core");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
var _isRestoringEsmJs = require("./isRestoring.esm.js");
var _queryErrorResetBoundaryEsmJs = require("./QueryErrorResetBoundary.esm.js");
var _errorBoundaryUtilsEsmJs = require("./errorBoundaryUtils.esm.js");
// - `context` is omitted as it is passed as a root-level option to `useQueries` instead.
function useQueries({ queries, context }) {
    const queryClient = (0, _queryClientProviderEsmJs.useQueryClient)({
        context
    });
    const isRestoring = (0, _isRestoringEsmJs.useIsRestoring)();
    const defaultedQueries = _react.useMemo(()=>queries.map((options)=>{
            const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure the results are already in fetching state before subscribing or updating options
            defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic';
            return defaultedOptions;
        }), [
        queries,
        queryClient,
        isRestoring
    ]);
    const [observer] = _react.useState(()=>new (0, _queryCore.QueriesObserver)(queryClient, defaultedQueries));
    const result = observer.getOptimisticResult(defaultedQueries);
    (0, _useSyncExternalStoreEsmJs.useSyncExternalStore)(_react.useCallback((onStoreChange)=>isRestoring ? ()=>undefined : observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)), [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    _react.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setQueries(defaultedQueries, {
            listeners: false
        });
    }, [
        defaultedQueries,
        observer
    ]);
    const errorResetBoundary = (0, _queryErrorResetBoundaryEsmJs.useQueryErrorResetBoundary)();
    defaultedQueries.forEach((query)=>{
        (0, _errorBoundaryUtilsEsmJs.ensurePreventErrorBoundaryRetry)(query, errorResetBoundary);
    });
    (0, _errorBoundaryUtilsEsmJs.useClearResetErrorBoundary)(errorResetBoundary);
    const firstSingleResultWhichShouldThrow = result.find((singleResult, index)=>{
        var _defaultedQueries$ind, _defaultedQueries$ind2;
        return (0, _errorBoundaryUtilsEsmJs.getHasError)({
            result: singleResult,
            errorResetBoundary,
            useErrorBoundary: (_defaultedQueries$ind = (_defaultedQueries$ind2 = defaultedQueries[index]) == null ? void 0 : _defaultedQueries$ind2.useErrorBoundary) != null ? _defaultedQueries$ind : false,
            query: observer.getQueries()[index]
        });
    });
    if (firstSingleResultWhichShouldThrow != null && firstSingleResultWhichShouldThrow.error) throw firstSingleResultWhichShouldThrow.error;
    return result;
}

},{"react":"IMRgT","./useSyncExternalStore.esm.js":"itJLV","@tanstack/query-core":[["notifyManager","gHeSt"],["QueriesObserver","kFCYB"]],"./QueryClientProvider.esm.js":"dHYz4","./isRestoring.esm.js":"kGxG6","./QueryErrorResetBoundary.esm.js":"21JTM","./errorBoundaryUtils.esm.js":"3b0Wd","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lUbVC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hydrate", ()=>Hydrate);
parcelHelpers.export(exports, "useHydrate", ()=>useHydrate);
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
function useHydrate(state, options = {}) {
    const queryClient = (0, _queryClientProviderEsmJs.useQueryClient)({
        context: options.context
    });
    const optionsRef = _react.useRef(options);
    optionsRef.current = options; // Running hydrate again with the same queries is safe,
    // it wont overwrite or initialize existing queries,
    // relying on useMemo here is only a performance optimization.
    // hydrate can and should be run *during* render here for SSR to work properly
    _react.useMemo(()=>{
        if (state) (0, _queryCore.hydrate)(queryClient, state, optionsRef.current);
    }, [
        queryClient,
        state
    ]);
}
const Hydrate = ({ children, options, state })=>{
    useHydrate(state, options);
    return children;
};

},{"react":"IMRgT","@tanstack/query-core":"fia7A","./QueryClientProvider.esm.js":"dHYz4","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4dDbf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsFetching", ()=>useIsFetching);
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _useSyncExternalStoreEsmJs = require("./useSyncExternalStore.esm.js");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
function useIsFetching(arg1, arg2, arg3) {
    const [filters, options = {}] = (0, _queryCore.parseFilterArgs)(arg1, arg2, arg3);
    const queryClient = (0, _queryClientProviderEsmJs.useQueryClient)({
        context: options.context
    });
    const queryCache = queryClient.getQueryCache();
    return (0, _useSyncExternalStoreEsmJs.useSyncExternalStore)(_react.useCallback((onStoreChange)=>queryCache.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)), [
        queryCache
    ]), ()=>queryClient.isFetching(filters), ()=>queryClient.isFetching(filters));
}

},{"react":"IMRgT","@tanstack/query-core":[["notifyManager","gHeSt"],["parseFilterArgs","7vj9i"]],"./useSyncExternalStore.esm.js":"itJLV","./QueryClientProvider.esm.js":"dHYz4","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8J7CR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMutating", ()=>useIsMutating);
var _react = require("react");
var _useSyncExternalStoreEsmJs = require("./useSyncExternalStore.esm.js");
var _queryCore = require("@tanstack/query-core");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
function useIsMutating(arg1, arg2, arg3) {
    const [filters, options = {}] = (0, _queryCore.parseMutationFilterArgs)(arg1, arg2, arg3);
    const queryClient = (0, _queryClientProviderEsmJs.useQueryClient)({
        context: options.context
    });
    const mutationCache = queryClient.getMutationCache();
    return (0, _useSyncExternalStoreEsmJs.useSyncExternalStore)(_react.useCallback((onStoreChange)=>mutationCache.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)), [
        mutationCache
    ]), ()=>queryClient.isMutating(filters), ()=>queryClient.isMutating(filters));
}

},{"react":"IMRgT","./useSyncExternalStore.esm.js":"itJLV","@tanstack/query-core":[["notifyManager","gHeSt"],["parseMutationFilterArgs","7vj9i"]],"./QueryClientProvider.esm.js":"dHYz4","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ir5yO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserContext", ()=>UserContext);
parcelHelpers.export(exports, "GuildRolesAndChannelContext", ()=>GuildRolesAndChannelContext);
parcelHelpers.export(exports, "GuildListContext", ()=>GuildListContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const UserContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(undefined);
const GuildRolesAndChannelContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(undefined);
const GuildListContext = /*#__PURE__*/ (0, _reactDefault.default).createContext([]);

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"l4wGc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tag", ()=>Tag);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function Tag(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...props,
        className: (0, _classnamesDefault.default)(props.className, "flex h-fit w-fit flex-col justify-center rounded-sm p-1 text-xs", {
            "bg-base-dark text-sesh-primary": props.type === "Dark",
            "bg-sesh-primary text-black": props.type === "Light"
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"pd6di":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeshAddonInput", ()=>SeshAddonInput);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function SeshAddonInput(props) {
    const size = props.size ?? "md";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            props.label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "label",
                children: props.label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex",
                children: props.buttons.map((val, index)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        ...val.props,
                        className: (0, _classnamesDefault.default)("border border-sesh-dark font-bold", {
                            "bg-sesh-dark text-base-dark": val.value === props.value && !val.disable_selected_state,
                            "bg-base-dark text-white hover:bg-base-light": val.value !== props.value || val.disable_selected_state,
                            "rounded-l-md": index === 0,
                            "rounded-r-md": index === props.buttons.length - 1,
                            "input-disabled": props.is_disabled,
                            "h-fit p-2 text-sm": size === "sm",
                            "px-2 py-2 text-sm sm:h-10 sm:px-4 sm:text-base": size === "md"
                        }),
                        type: "button",
                        onClick: ()=>!props.is_disabled && props.setValue(val.value),
                        children: val.label
                    }, index);
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"NLcok":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaymentInterval", ()=>PaymentInterval);
parcelHelpers.export(exports, "PaymentIntervalToActiveName", ()=>PaymentIntervalToActiveName);
parcelHelpers.export(exports, "DEV_STRIPE_TIERS", ()=>DEV_STRIPE_TIERS);
parcelHelpers.export(exports, "PRODUCTION_TIERS", ()=>PRODUCTION_TIERS);
parcelHelpers.export(exports, "getTiersWithoutPrices", ()=>getTiersWithoutPrices);
parcelHelpers.export(exports, "getRawProductWithoutPrices", ()=>getRawProductWithoutPrices);
parcelHelpers.export(exports, "isSeshProProduct", ()=>isSeshProProduct);
parcelHelpers.export(exports, "getSeshProAddonProductId", ()=>getSeshProAddonProductId);
parcelHelpers.export(exports, "isSeshProAddonProduct", ()=>isSeshProAddonProduct);
parcelHelpers.export(exports, "getSeshProUpgradeCoupon", ()=>getSeshProUpgradeCoupon);
parcelHelpers.export(exports, "getBundleProUpgradeCoupon", ()=>getBundleProUpgradeCoupon);
parcelHelpers.export(exports, "isBundleProduct", ()=>isBundleProduct);
parcelHelpers.export(exports, "isSinglePremiumProduct", ()=>isSinglePremiumProduct);
parcelHelpers.export(exports, "getBundleProductId", ()=>getBundleProductId);
/**
 * Get the actual Stripe product ID for sesh Pro (not the "sesh_pro" identifier)
 */ parcelHelpers.export(exports, "getSeshProStripeProductId", ()=>getSeshProStripeProductId);
var PaymentInterval = /*#__PURE__*/ function(PaymentInterval) {
    PaymentInterval[PaymentInterval["Month"] = 0] = "Month";
    PaymentInterval[PaymentInterval["Year"] = 1] = "Year";
    PaymentInterval[PaymentInterval["OneTime"] = 2] = "OneTime";
    return PaymentInterval;
}({});
const PaymentIntervalToActiveName = {
    [0]: "Monthly",
    [1]: "Yearly",
    [2]: "One-Time"
};
const DEV_STRIPE_TIERS = {
    prod_TrihB6bwfDU85I: {
        activations: 1,
        title: "sesh Pro",
        prices: {
            [0]: undefined,
            [1]: undefined,
            [2]: undefined
        },
        description: "Premium features plus API access and custom branding",
        features: [
            "Premium for 1 server",
            "API Access",
            "Custom Branding",
            "Priority Support"
        ],
        is_best_deal: false
    },
    prod_NC6XOKwwTNZ4GD: {
        activations: 1,
        title: "Premium",
        prices: {
            [0]: undefined,
            [1]: undefined,
            [2]: undefined
        },
        description: "Fully unlock sesh! Get repeating events, ",
        features: [
            "Repeating events",
            "Custom RSVP options",
            "Full GCal sync",
            "Unlimited server logs",
            "Unlimited event templates",
            "Close RSVPs early",
            "Priority support",
            "...and much more!"
        ],
        is_best_deal: false
    },
    prod_NC6iPVmx2SkRzQ: {
        activations: 3,
        title: "Premium Bundle",
        prices: {
            [0]: undefined,
            [1]: undefined,
            [2]: undefined
        },
        description: "Description goes here",
        features: [
            "Repeating events",
            "Custom RSVP options",
            "Full GCal sync",
            "Unlimited server logs",
            "Unlimited event templates",
            "Close RSVPs early",
            "Priority support",
            "...and much more!"
        ],
        is_best_deal: true
    }
};
const PRODUCTION_TIERS = {
    prod_TuH95vKgizbWdz: {
        activations: 1,
        title: "sesh Pro",
        prices: {
            [0]: undefined,
            [1]: undefined,
            [2]: undefined
        },
        description: "Premium features plus API access and custom branding",
        features: [
            "Premium for 1 server",
            "API Access",
            "Custom Branding",
            "Priority Support"
        ],
        is_best_deal: false
    },
    prod_NCrwD9OIe8q3ep: {
        activations: 1,
        title: "Premium",
        prices: {
            [0]: undefined,
            [1]: undefined,
            [2]: undefined
        },
        description: "Fully unlock sesh! Get repeating events, ",
        features: [
            "Repeating events",
            "Custom RSVP options",
            "Full GCal sync",
            "Unlimited server logs",
            "Unlimited event templates",
            "Priority support",
            "...and much more!"
        ],
        is_best_deal: false
    },
    prod_NCrxDlEHuriMPU: {
        activations: 3,
        title: "Premium Bundle",
        prices: {
            [0]: undefined,
            [1]: undefined,
            [2]: undefined
        },
        description: "Description goes here",
        features: [
            "Repeating events",
            "Custom RSVP options",
            "Full GCal sync",
            "Unlimited server logs",
            "Unlimited event templates",
            "Priority support",
            "...and much more!"
        ],
        is_best_deal: true
    }
};
function getTiersWithoutPrices() {
    let is_on_production = false;
    if (typeof window !== "undefined") // web
    is_on_production = window?.location?.host?.includes("sesh.fyi") && !window?.location?.host?.includes("beta");
    else is_on_production = true;
    return is_on_production ? PRODUCTION_TIERS : DEV_STRIPE_TIERS;
}
function getRawProductWithoutPrices(product_id) {
    return getTiersWithoutPrices()[product_id];
}
const SESH_PRO_PRODUCT_IDS = [
    "prod_TrihB6bwfDU85I",
    "prod_TuH95vKgizbWdz"
];
function isSeshProProduct(product_id) {
    return SESH_PRO_PRODUCT_IDS.includes(product_id);
}
// Helper to determine if we're in dev mode (used by product ID helpers below)
function isDevMode() {
    if (typeof window !== "undefined") // web
    return !window?.location?.host?.includes("sesh.fyi") || window?.location?.host?.includes("beta");
    return false;
}
// sesh Pro addon product IDs (for bundle upgrades - adds Pro to existing bundle subscription)
const DEV_SESH_PRO_ADDON_PRODUCT_ID = "prod_TrihB6bwfDU85I"; // TODO: Replace with actual Stripe product ID
const PROD_SESH_PRO_ADDON_PRODUCT_ID = "prod_TuH95vKgizbWdz"; // TODO: Replace with actual Stripe product ID
function getSeshProAddonProductId() {
    return isDevMode() ? DEV_SESH_PRO_ADDON_PRODUCT_ID : PROD_SESH_PRO_ADDON_PRODUCT_ID;
}
function isSeshProAddonProduct(product_id) {
    return product_id === DEV_SESH_PRO_ADDON_PRODUCT_ID || product_id === PROD_SESH_PRO_ADDON_PRODUCT_ID;
}
// Upgrade discount coupons for one-time purchases ($150 per slot)
// Create these coupons in both Stripe test mode and live mode
const DEV_SESH_PRO_UPGRADE_COUPONS = {
    1: "UEDW7EUt",
    2: "vjwxfxb2",
    3: "dccOCpGx"
};
const PROD_SESH_PRO_UPGRADE_COUPONS = {
    1: "8gEgDzFB",
    2: "dI0oT6ft",
    3: "wwKQIUxq"
};
function getSeshProUpgradeCoupon(slotCount) {
    const coupons = isDevMode() ? DEV_SESH_PRO_UPGRADE_COUPONS : PROD_SESH_PRO_UPGRADE_COUPONS;
    return coupons[slotCount];
}
// Recurring subscription coupons for bundle Pro upgrades
// These coupons give a recurring discount equal to (slots * bundle_price / 3)
// For a $99.99 bundle: 1 slot = $33.33/cycle, 2 slots = $66.66/cycle
// Create these in Stripe as:
//   - duration: forever
//   - amount_off: 3333 (1 slot), 6666 (2 slots) in cents
//   - currency: usd
const DEV_BUNDLE_PRO_UPGRADE_COUPONS = {
    1: "IvHlH9S5",
    2: "v2jl0det"
};
const PROD_BUNDLE_PRO_UPGRADE_COUPONS = {
    1: "QzlGxVy2",
    2: "7bdLIwl4"
};
function getBundleProUpgradeCoupon(slotCount) {
    const coupons = isDevMode() ? DEV_BUNDLE_PRO_UPGRADE_COUPONS : PROD_BUNDLE_PRO_UPGRADE_COUPONS;
    return coupons[slotCount];
}
// Bundle product IDs (3-server bundles)
const DEV_BUNDLE_PRODUCT_ID = "prod_NC6iPVmx2SkRzQ"; // From DEV_STRIPE_TIERS
const PROD_BUNDLE_PRODUCT_ID = "prod_NCrxDlEHuriMPU"; // From PRODUCTION_TIERS
function isBundleProduct(product_id) {
    return product_id === DEV_BUNDLE_PRODUCT_ID || product_id === PROD_BUNDLE_PRODUCT_ID;
}
// Single Premium product IDs (1-server Premium, non-bundle)
const DEV_SINGLE_PREMIUM_PRODUCT_ID = "prod_NC6XOKwwTNZ4GD"; // From DEV_STRIPE_TIERS
const PROD_SINGLE_PREMIUM_PRODUCT_ID = "prod_NCrwD9OIe8q3ep"; // From PRODUCTION_TIERS
function isSinglePremiumProduct(product_id) {
    return product_id === DEV_SINGLE_PREMIUM_PRODUCT_ID || product_id === PROD_SINGLE_PREMIUM_PRODUCT_ID;
}
function getBundleProductId() {
    return isDevMode() ? DEV_BUNDLE_PRODUCT_ID : PROD_BUNDLE_PRODUCT_ID;
}
// Explicit sesh Pro Stripe product IDs
const DEV_SESH_PRO_PRODUCT_ID = "prod_TrihB6bwfDU85I";
const PROD_SESH_PRO_PRODUCT_ID = "prod_TuH95vKgizbWdz"; // TODO: Replace with actual Stripe product ID
function getSeshProStripeProductId() {
    return isDevMode() ? DEV_SESH_PRO_PRODUCT_ID : PROD_SESH_PRO_PRODUCT_ID;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2kgi1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManualButton", ()=>ManualButton);
var _jsxRuntime = require("react/jsx-runtime");
function ManualButton(props) {
    const { children, ...otherProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        ...otherProps,
        href: "/manual",
        suppressHydrationWarning: true,
        children: children || "Manual"
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cxd2x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NavbarBase", ()=>NavbarBase);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function NavbarBase(props) {
    const logoSrc = props.customLogoUrl || "/static/logo2transparent.png";
    const isCustomLogo = Boolean(props.customLogoUrl);
    const logoHref = isCustomLogo && props.customLogoServerId ? `/dashboard/${props.customLogoServerId}` : "/";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
                className: (0, _classnamesDefault.default)({
                    "topnav--static": !props.is_fixed,
                    topnav: props.is_fixed
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "columns is-vcentered is-centered is-mobile",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-11",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "columns is-vcentered is-mobile",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-narrow",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: logoHref,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: logoSrc,
                                            alt: isCustomLogo ? "Server Logo" : "Sesh Logo",
                                            className: (0, _classnamesDefault.default)("header-logo", {
                                                "rounded-full": isCustomLogo
                                            }),
                                            style: isCustomLogo ? {
                                                objectFit: "cover"
                                            } : undefined
                                        })
                                    })
                                }),
                                props.children
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "p-6"
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lITN2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StaticNavbar", ()=>StaticNavbar);
var _jsxRuntime = require("react/jsx-runtime");
var _manualButton = require("./navbar/manual_button");
var _navbarBase = require("./NavbarBase");
function StaticNavbar() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _navbarBase.NavbarBase), {
                is_fixed: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-narrow topnav-right hidden sm:block",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "columns is-vcentered is-mobile",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-narrow is-hidden-mobile",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _manualButton.ManualButton), {
                                        className: "manual-link"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-narrow is-hidden-mobile",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "/premium",
                                        children: "Premium"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-narrow is-hidden-mobile",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "/blog",
                                        children: "Blog"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-narrow is-hidden-mobile",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "/dashboard",
                                        children: "Dashboard"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "block px-3 sm:hidden",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "/manual",
                                        suppressHydrationWarning: true,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "icon fas fa-book",
                                            suppressHydrationWarning: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "/premium",
                                        suppressHydrationWarning: true,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "icon fas fa-gem",
                                            suppressHydrationWarning: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "/blog",
                                        suppressHydrationWarning: true,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: "icon fas fa-newspaper",
                                            suppressHydrationWarning: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "/dashboard",
                                        children: "Dashboard"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
                className: "topnav mock-bar !hidden sm:!block",
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "columns is-vcentered is-centered",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "column is-10",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "columns is-vcentered",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-narrow",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: "/static/logo2transparent.png",
                                        alt: "Sesh Logo",
                                        className: "header-logo"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "column is-narrow topnav-right",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "columns",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "column is-narrow",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                    className: "manual-link",
                                                    children: "Manual"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "column is-narrow",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                    children: "Premium"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "column is-narrow",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                    children: "Dashboard"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","./navbar/manual_button":"2kgi1","./NavbarBase":"cxd2x","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iyQuU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PricingTable", ()=>PricingTable);
parcelHelpers.export(exports, "centsToDollars", ()=>centsToDollars);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _premiumTiers = require("../../../../../../common/premium_tiers");
var _commonUtils = require("../../../../../../common/common_utils");
var _seshAddonInput = require("../base_components/sesh_addon_input");
var _pricingTier = require("./pricing_tier");
var _withTooltip = require("../tooltips/with_tooltip");
var _trpc = require("../../../utils/trpc");
var _contexts = require("../../../contexts");
var _upgradeChoiceModal = require("./upgrade_choice_modal");
var _proQuantityModal = require("./pro_quantity_modal");
var _subscriptionUpgradeModal = require("./subscription_upgrade_modal");
var _proAssignmentModal = require("./pro_assignment_modal");
var _featureFlags = require("../../../../../../src/feature_flags");
function PricingTable(props) {
    const [selected_span, setSpan] = (0, _react.useState)((0, _premiumTiers.PaymentInterval).Month);
    const history = (0, _reactRouterDom.useHistory)();
    const guild_list = (0, _react.useContext)((0, _contexts.GuildListContext));
    // Upgrade flow state
    const [showUpgradeChoice, setShowUpgradeChoice] = (0, _react.useState)(false);
    const [showQuantityPicker, setShowQuantityPicker] = (0, _react.useState)(false);
    const [showSubscriptionConfirm, setShowSubscriptionConfirm] = (0, _react.useState)(false);
    const [showActivationModal, setShowActivationModal] = (0, _react.useState)(false);
    const [activationType, setActivationType] = (0, _react.useState)("premium");
    const [selectedLicense, setSelectedLicense] = (0, _react.useState)(null);
    const [selectedProCount, setSelectedProCount] = (0, _react.useState)(1);
    // Track pending unassigned count from just-completed upgrade (before webhook processes)
    const [pendingUnassignedCount, setPendingUnassignedCount] = (0, _react.useState)(null);
    // Loading state for one-time upgrade checkout redirect
    const [isUpgradeLoading, setIsUpgradeLoading] = (0, _react.useState)(false);
    // Only fetch user-specific data on the dashboard (when link_type is "Link")
    // On the static premium page (link_type "anchor"), user is not authenticated
    const isOnDashboard = props.link_type === "Link";
    // Query for upgradeable licenses
    const upgradeableLicensesQuery = (0, _trpc.trpc).premium.getUpgradeableLicenses.useQuery(undefined, {
        enabled: isOnDashboard
    });
    // Query for premium details (needed for Pro assignment modal)
    const premiumDetailsQuery = (0, _trpc.trpc).premium.getUserPremiumDetails.useQuery(undefined, {
        enabled: isOnDashboard
    });
    // Get trpc context for direct API calls with fresh parameters
    const trpcContext = (0, _trpc.trpc).useContext();
    // Mutation for assigning Premium to guilds
    const assignPremiumMutation = (0, _trpc.trpc).premium.assignPremiumToGuilds.useMutation({
        onSuccess: ()=>{
            setShowActivationModal(false);
            setPendingUnassignedCount(null);
            trpcContext.premium.invalidate();
        }
    });
    // Mutation for assigning Pro to guilds
    const assignProMutation = (0, _trpc.trpc).premium.assignSeshProToGuilds.useMutation({
        onSuccess: ()=>{
            setShowActivationModal(false);
            setPendingUnassignedCount(null);
            trpcContext.premium.invalidate();
        }
    });
    const { current_pricing } = props;
    // Detect success redirect and show activation modal if needed
    (0, _react.useEffect)(()=>{
        const params = new URLSearchParams(window.location.search);
        if (params.get("success") === "true") {
            // Clean up URL
            window.history.replaceState({}, "", window.location.pathname);
            // Refetch premium details to check for unassigned activations
            premiumDetailsQuery.refetch().then((result)=>{
                if (result.data) {
                    // Check for unassigned Pro first (higher priority)
                    const unassignedPro = result.data.max_sesh_pro_activations - result.data.sesh_pro_activated_servers_count;
                    if (unassignedPro > 0) {
                        setActivationType("pro");
                        setShowActivationModal(true);
                        return;
                    }
                    // Check for unassigned Premium
                    const unassignedPremium = result.data.max_activated_servers - result.data.transferrable_activated_servers_count;
                    if (unassignedPremium > 0) {
                        setActivationType("premium");
                        setShowActivationModal(true);
                    }
                }
            });
        }
    }, []);
    // Handle sesh Pro purchase click
    const handleSeshProPurchaseClick = ()=>{
        const licenses = upgradeableLicensesQuery.data?.licenses ?? [];
        if (licenses.length > 0) // User has upgradeable licenses - show upgrade choice modal
        setShowUpgradeChoice(true);
        else {
            // No upgradeable licenses - proceed to normal checkout
            const url = (0, _commonUtils.common_utils).getStripeRedirectURL({
                type: "checkout",
                product_id: (0, _premiumTiers.getSeshProStripeProductId)(),
                subscription_span: selected_span.toString(),
                should_force_no_coupon: "false"
            });
            if (props.link_type === "Link") history.push(url);
            else window.location.href = url;
        }
    };
    // Handle upgrade selected from the choice modal
    const handleUpgradeSelected = (license)=>{
        // Find the corresponding upgradeable license with full info
        const upgradeableLicense = upgradeableLicensesQuery.data?.licenses.find((l)=>l.id === license.id);
        if (!upgradeableLicense) return;
        setSelectedLicense(upgradeableLicense);
        if (upgradeableLicense.is_bundle && upgradeableLicense.available_pro_slots > 1) {
            // Bundle with multiple slots - show quantity picker
            setShowUpgradeChoice(false);
            setShowQuantityPicker(true);
        } else if (upgradeableLicense.is_subscription) {
            // Single subscription - go straight to confirmation
            setShowUpgradeChoice(false);
            setSelectedProCount(1);
            setShowSubscriptionConfirm(true);
        } else // One-time purchase - redirect to checkout (keep modal open, show loading)
        handleOneTimeUpgrade(upgradeableLicense, 1);
    };
    // Handle quantity confirmed from the quantity picker
    const handleQuantityConfirmed = (count)=>{
        setSelectedProCount(count);
        if (selectedLicense?.is_subscription) {
            // Subscription - close quantity picker and show confirmation modal
            setShowQuantityPicker(false);
            setShowSubscriptionConfirm(true);
        } else // One-time - keep modal open, show loading, redirect to checkout
        handleOneTimeUpgrade(selectedLicense, count);
    };
    // Handle one-time upgrade checkout
    const handleOneTimeUpgrade = async (license, count)=>{
        setIsUpgradeLoading(true);
        try {
            // Use trpcContext.fetch() with explicit parameters to avoid stale closure issues
            // (React state updates are async, so selectedLicense may not be updated yet)
            const result = await trpcContext.premium.getOneTimeUpgradeCheckout.fetch({
                entitlement_id: license.id,
                pro_count: count
            });
            if (result?.url) window.location.href = result.url;
            else setIsUpgradeLoading(false);
        } catch (error) {
            console.error("Failed to get upgrade checkout URL:", error);
            setIsUpgradeLoading(false);
        }
    };
    // Handle buy new license from the choice modal
    const handleBuyNew = ()=>{
        setShowUpgradeChoice(false);
        const url = (0, _commonUtils.common_utils).getStripeRedirectURL({
            type: "checkout",
            product_id: (0, _premiumTiers.getSeshProStripeProductId)(),
            subscription_span: selected_span.toString(),
            should_force_no_coupon: "false"
        });
        if (props.link_type === "Link") history.push(url);
        else window.location.href = url;
    };
    // Handle subscription upgrade success
    const handleSubscriptionUpgradeSuccess = ()=>{
        setShowSubscriptionConfirm(false);
        setSelectedLicense(null);
        // Immediately show Pro activation modal with the selected count
        // (don't wait for webhook to process - use the count we just upgraded)
        setPendingUnassignedCount(selectedProCount);
        setActivationType("pro");
        setShowActivationModal(true);
        // Invalidate all premium queries to ensure fresh data
        // This is more reliable than refetch() as it clears the cache
        trpcContext.premium.invalidate();
    };
    // Handle server activation assignment
    const handleActivationAssignment = (guildIds)=>{
        console.log("handleActivationAssignment called with:", guildIds);
        console.log("activationType:", activationType);
        if (activationType === "pro") assignProMutation.mutate({
            guild_ids: guildIds
        });
        else assignPremiumMutation.mutate({
            guild_ids: guildIds
        });
    };
    // Convert upgradeable licenses to the format expected by UpgradeChoiceModal
    const licensesForUpgradeModal = (upgradeableLicensesQuery.data?.licenses ?? []).map((license)=>({
            id: license.id,
            product_id: license.product_id,
            payment_interval: license.payment_interval,
            activations: license.is_bundle ? 3 : 1
        }));
    const tiers = [];
    const tier_descriptors = (0, _premiumTiers.getTiersWithoutPrices)();
    for(const product_id in tier_descriptors){
        const casted_product_id = product_id;
        const current_product = tier_descriptors[casted_product_id];
        // Skip all sesh Pro products - we render sesh Pro separately at the end
        if ((0, _premiumTiers.isSeshProProduct)(product_id) || current_product.title === "sesh Pro") continue;
        for(const current_span in current_product.prices){
            const span_enum = Number.parseInt(current_span);
            if ((0, _premiumTiers.PaymentInterval)[span_enum] !== (0, _premiumTiers.PaymentInterval)[selected_span]) continue;
            tiers.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricingTier.PricingTier), {
                type: "regular",
                has_used_free_trial: props.has_used_free_trial,
                product_id: casted_product_id,
                span: span_enum,
                link_type: props.link_type,
                price: current_pricing?.prices[product_id][span_enum],
                active_coupon: current_pricing?.active_coupon,
                title: current_product.title,
                features: [
                    span_enum === (0, _premiumTiers.PaymentInterval).OneTime ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withTooltip.WithTooltip), {
                                style: "Info",
                                tooltip: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "max-w-[15rem] whitespace-normal",
                                    children: "By purchasing a one-time payment membership, you will receive premium benefits for the lifetime of sesh. We intend to continue running sesh indefinitely, but there could be a (very unlikely) point at which we no longer can due to issues with third party services (e.g. Discord, Google Calendar, Stripe, etc) or other unforeseen circumstances."
                                }),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "border-b border-dotted border-current",
                                    children: "Lifetime"
                                })
                            }),
                            " ",
                            "premium for ",
                            current_product.activations,
                            " server",
                            current_product.activations > 1 ? "s" : ""
                        ]
                    }) : `Premium for ${current_product.activations} server${current_product.activations > 1 ? "s" : ""}`,
                    ...current_product.features
                ],
                is_best_deal: current_product.is_best_deal,
                tag_type: current_product.is_best_deal ? "Best deal" : undefined
            }, product_id));
        }
    }
    // Add sesh Pro tier at the end (rightmost position)
    const sesh_pro_product_id = (0, _premiumTiers.getSeshProStripeProductId)();
    const sesh_pro_price = current_pricing?.prices[sesh_pro_product_id]?.[selected_span];
    // Determine sesh Pro button text based on existing licenses and trial status
    const hasUpgradeableLicenses = (upgradeableLicensesQuery.data?.licenses.length ?? 0) > 0;
    const seshProButtonText = hasUpgradeableLicenses ? "Upgrade" : selected_span === (0, _premiumTiers.PaymentInterval).OneTime ? "Get Access Now" : props.has_used_free_trial || !(0, _featureFlags.isFeatureEnabled)("FreeTrial") ? "Subscribe Now" : "Start Free Trial";
    tiers.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricingTier.PricingTier), {
        type: "regular",
        has_used_free_trial: props.has_used_free_trial,
        product_id: sesh_pro_product_id,
        span: selected_span,
        link_type: props.link_type,
        price: sesh_pro_price,
        active_coupon: current_pricing?.active_coupon,
        title: "sesh Pro",
        features: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-semibold text-white",
                        children: "Premium for 1 server"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-xs text-slate-400",
                        children: "All features included, plus more"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-semibold text-white",
                        children: "API Access"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-xs text-slate-400",
                        children: "Automate events and integrations"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                        href: "/manual#bot_customization",
                        className: "inline-flex items-center gap-1 font-semibold text-white underline decoration-white/30 underline-offset-2 transition-colors hover:text-sesh-primary hover:decoration-sesh-primary/50",
                        children: [
                            "Custom Branding",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-external-link-alt text-[10px] opacity-50"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-xs text-slate-400",
                        children: "Your own bot name and avatar"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-semibold text-white",
                        children: "Webhooks"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-xs text-slate-400",
                        children: "Real-time notifications to your services"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-semibold text-white",
                        children: "Priority Support"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-xs text-slate-400",
                        children: "Direct access via Discord and email"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-semibold text-white",
                        children: "Business License"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-xs text-slate-400",
                        children: "Commercial use fully permitted"
                    })
                ]
            })
        ],
        onPurchaseClick: handleSeshProPurchaseClick,
        buttonText: seshProButtonText
    }, "sesh_pro"));
    // Calculate unassigned counts for activation modal
    const unassignedProCount = premiumDetailsQuery.data ? premiumDetailsQuery.data.max_sesh_pro_activations - premiumDetailsQuery.data.sesh_pro_activated_servers_count : 0;
    const unassignedPremiumCount = premiumDetailsQuery.data ? premiumDetailsQuery.data.max_activated_servers - premiumDetailsQuery.data.transferrable_activated_servers_count : 0;
    // Use pending count if set (from just-completed upgrade), otherwise use query data
    const unassignedCount = pendingUnassignedCount !== null ? pendingUnassignedCount : activationType === "pro" ? unassignedProCount : unassignedPremiumCount;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col items-center gap-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshAddonInput.SeshAddonInput), {
                        value: selected_span,
                        setValue: setSpan,
                        buttons: [
                            {
                                label: (0, _premiumTiers.PaymentIntervalToActiveName)[(0, _premiumTiers.PaymentInterval).Month],
                                value: (0, _premiumTiers.PaymentInterval).Month
                            },
                            {
                                label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: (0, _premiumTiers.PaymentIntervalToActiveName)[(0, _premiumTiers.PaymentInterval).Year]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: `text-[10px] ${selected_span === (0, _premiumTiers.PaymentInterval).Year ? "text-slate-600" : "text-green-400"}`,
                                            children: "(save 30%)"
                                        })
                                    ]
                                }),
                                value: (0, _premiumTiers.PaymentInterval).Year
                            },
                            {
                                label: (0, _premiumTiers.PaymentIntervalToActiveName)[(0, _premiumTiers.PaymentInterval).OneTime],
                                value: (0, _premiumTiers.PaymentInterval).OneTime
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "mt-3 flex w-full flex-wrap justify-center gap-2",
                        children: tiers
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                            href: "#faq",
                            className: "inline-flex items-center gap-2 text-sm text-slate-300 transition-colors hover:text-sesh-primary",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-question-circle"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "View FAQ for info on transfers, commercial use & more"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "mt-4 flex w-full justify-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "w-full max-w-[800px] rounded-lg border border-slate-700 bg-slate-800/30 p-4 text-center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center justify-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-robot text-lg text-sesh-primary/70"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "text-sm",
                                        children: [
                                            "Looking for custom features or a completely custom bot?",
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "#custom-bot",
                                                className: "text-sesh-primary hover:underline",
                                                children: "See details"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _upgradeChoiceModal.UpgradeChoiceModal), {
                open: showUpgradeChoice,
                onClose: ()=>{
                    if (!isUpgradeLoading) setShowUpgradeChoice(false);
                },
                licenses: licensesForUpgradeModal,
                onUpgrade: handleUpgradeSelected,
                onBuyNew: handleBuyNew,
                isLoading: isUpgradeLoading
            }),
            selectedLicense && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _proQuantityModal.ProQuantityModal), {
                open: showQuantityPicker,
                onClose: ()=>{
                    if (!isUpgradeLoading) {
                        setShowQuantityPicker(false);
                        setSelectedLicense(null);
                    }
                },
                availableSlots: selectedLicense.available_pro_slots,
                currentProCount: selectedLicense.current_pro_addon_count,
                onConfirm: handleQuantityConfirmed,
                isLoading: isUpgradeLoading
            }),
            selectedLicense && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscriptionUpgradeModal.SubscriptionUpgradeModal), {
                open: showSubscriptionConfirm,
                onClose: ()=>{
                    setShowSubscriptionConfirm(false);
                    setSelectedLicense(null);
                },
                entitlementId: selectedLicense.id,
                proCount: selectedProCount,
                isBundle: selectedLicense.is_bundle,
                onSuccess: handleSubscriptionUpgradeSuccess
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _proAssignmentModal.ServerActivationModal), {
                open: showActivationModal,
                onClose: ()=>{
                    setShowActivationModal(false);
                    setPendingUnassignedCount(null);
                },
                unassignedCount: unassignedCount,
                guilds: guild_list,
                onAssign: handleActivationAssignment,
                type: activationType
            })
        ]
    });
}
function centsToDollars(cents) {
    return (cents / 100).toFixed(2);
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-router-dom":"djWTS","../../../../../../common/premium_tiers":"NLcok","../../../../../../common/common_utils":"gACUC","../base_components/sesh_addon_input":"pd6di","./pricing_tier":"cpfF8","../tooltips/with_tooltip":"bOdAf","../../../utils/trpc":"dyYvM","../../../contexts":"ir5yO","./upgrade_choice_modal":"gHSoZ","./pro_quantity_modal":"8PJa8","./subscription_upgrade_modal":"iN0DN","./pro_assignment_modal":"6Ll0c","../../../../../../src/feature_flags":"jss8q","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cpfF8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PricingTier", ()=>PricingTier);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactRouterDom = require("react-router-dom");
var _commonUtils = require("../../../../../../common/common_utils");
var _premiumTiers = require("../../../../../../common/premium_tiers");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _tag = require("../base_components/tag");
var _pricingTable = require("./pricing_table");
var _featureFlags = require("../../../../../../src/feature_flags");
// Helper to check if a coupon applies to a specific product
function couponAppliesToProduct(coupon, productId) {
    if (!coupon) return false;
    // Check our stored applies_to_products field
    if (coupon.applies_to_products && coupon.applies_to_products.length > 0) return coupon.applies_to_products.includes(productId);
    // If no applies_to specified, coupon applies to all products (legacy behavior)
    return true;
}
// Helper to format discount text
function getDiscountText(coupon) {
    if (coupon.api_data.percent_off) return `${coupon.api_data.percent_off}% off`;
    if (coupon.api_data.amount_off) return `$${(coupon.api_data.amount_off / 100).toFixed(0)} off`;
    return "Sale";
}
function PricingTier(props) {
    const is_best_deal = props.is_best_deal ?? false;
    // Check if coupon applies to this product
    const couponApplies = props.type === "regular" && couponAppliesToProduct(props.active_coupon, props.product_id);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("flex w-full max-w-[17rem] flex-shrink-0 flex-col gap-4 rounded-lg border-2 px-4 pb-8 pt-4 shadow-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl sm:max-w-[20rem] sm:whitespace-nowrap", {
            "border-sesh-primary bg-gradient-to-b from-base-light via-base-light to-base-dark": is_best_deal && !props.is_glowing,
            "border-content-secondary bg-gradient-to-b from-base-light to-base-light": !is_best_deal && !props.is_glowing,
            "border-sesh-primary bg-gradient-to-b from-cyan-950/40 via-base-light to-purple-950/30 ring-4 ring-sesh-primary/50 ring-offset-2 ring-offset-base-dark": props.is_glowing
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex min-h-[2rem] w-full",
                children: [
                    couponApplies && props.active_coupon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tag.Tag), {
                        type: "Light",
                        className: "font-semibold",
                        children: getDiscountText(props.active_coupon)
                    }),
                    props.tag_type && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tag.Tag), {
                        type: "Dark",
                        className: (0, _classnamesDefault.default)("ml-auto", {
                            "animate-pulse bg-premium font-bold !text-base-dark": props.tag_type === "Best deal",
                            "animate-pulse bg-sesh-primary px-2 py-1 text-sm font-bold !text-base-dark": props.tag_type === "Exclusive"
                        }),
                        children: props.tag_type
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mx-2 flex h-full flex-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _classnamesDefault.default)("mb-1 flex h-[4rem] flex-col items-center justify-center text-center"),
                        children: [
                            props.title === "Premium Bundle" ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-col items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: (0, _classnamesDefault.default)("fas fa-gem text-sm sm:text-base", {
                                            "text-sesh-primary": true,
                                            "text-content-primary": false
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "-mt-0.5 flex gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: (0, _classnamesDefault.default)("fas fa-gem text-sm sm:text-base", {
                                                    "text-sesh-primary": true,
                                                    "text-content-primary": false
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: (0, _classnamesDefault.default)("fas fa-gem text-sm sm:text-base", {
                                                    "text-sesh-primary": true,
                                                    "text-content-primary": false
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }) : props.title === "sesh Pro" || props.type === "custom" || props.type === "custom-contact" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-crown text-xl text-amber-300 sm:text-2xl"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-gem text-xl text-sesh-primary sm:text-2xl"
                            }),
                            props.title === "sesh Pro" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mt-1 bg-gradient-to-r from-amber-200 via-yellow-300 to-amber-400 bg-clip-text text-xl font-extrabold text-transparent sm:text-2xl",
                                children: props.title
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _classnamesDefault.default)("mt-1 text-xl font-extrabold sm:text-2xl", {
                                    "text-sesh-primary": props.title === "Premium Bundle",
                                    "text-content-primary": props.title !== "Premium Bundle"
                                }),
                                children: props.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _classnamesDefault.default)("mb-2 border-b pb-1", {
                            "border-sesh-primary": is_best_deal,
                            "border-content-secondary": !is_best_deal
                        }),
                        children: [
                            props.type === "regular" && props.price && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FullPriceDisplay, {
                                price: props.price,
                                span: props.span,
                                coupon: couponApplies ? props.active_coupon : undefined,
                                is_best_deal: is_best_deal,
                                type: "regular",
                                is_sesh_pro: props.title === "sesh Pro"
                            }),
                            props.type === "custom" && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FullPriceDisplay, {
                                price: props.price,
                                span: props.span,
                                is_best_deal: is_best_deal,
                                type: "custom"
                            }),
                            props.type === "custom-contact" && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContactPriceDisplay, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-grow text-sm sm:text-base",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                            className: "min-h-[16rem]",
                            children: props.features.map((feature, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                    className: "mt-2 flex items-start gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: (0, _classnamesDefault.default)("fas fa-check-circle mt-0.5 text-lg", {
                                                "text-success-primary": is_best_deal,
                                                "text-content-primary": !is_best_deal
                                            }),
                                            title: "Active",
                                            suppressHydrationWarning: true
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-content-primary",
                                            children: feature
                                        })
                                    ]
                                }, index))
                        })
                    }),
                    props.type === "regular" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mt-auto pt-8",
                            children: props.onPurchaseClick ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                onClick: props.onPurchaseClick,
                                className: (0, _classnamesDefault.default)("justify-center font-extrabold", {
                                    "bg-sesh-primary !text-base-dark transition-all duration-300 hover:bg-opacity-90 hover:!text-white": is_best_deal,
                                    "border-2 border-content-primary !text-content-primary transition-all duration-300 hover:bg-content-primary hover:!text-base-dark": !is_best_deal
                                }),
                                children: props.buttonText ?? (props.span === (0, _premiumTiers.PaymentInterval).OneTime ? "Get Access Now" : props.has_used_free_trial || !(0, _featureFlags.isFeatureEnabled)("FreeTrial") ? "Subscribe Now" : "Start Free Trial")
                            }) : props.link_type === "Link" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: (0, _commonUtils.common_utils).getStripeRedirectURL({
                                    type: "checkout",
                                    product_id: props.product_id,
                                    subscription_span: props.span.toString(),
                                    should_force_no_coupon: "false"
                                }),
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                    className: (0, _classnamesDefault.default)("justify-center font-extrabold", {
                                        "bg-sesh-primary !text-base-dark transition-all duration-300 hover:bg-opacity-90 hover:!text-white": is_best_deal,
                                        "border-2 border-content-primary !text-content-primary transition-all duration-300 hover:bg-content-primary hover:!text-base-dark": !is_best_deal
                                    }),
                                    children: props.span === (0, _premiumTiers.PaymentInterval).OneTime ? "Get Access Now" : props.has_used_free_trial || !(0, _featureFlags.isFeatureEnabled)("FreeTrial") ? "Subscribe Now" : "Start Free Trial"
                                })
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: (0, _commonUtils.common_utils).getStripeRedirectURL({
                                    type: "checkout",
                                    product_id: props.product_id,
                                    subscription_span: props.span.toString(),
                                    should_force_no_coupon: "false"
                                }),
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                    className: (0, _classnamesDefault.default)("justify-center font-extrabold", {
                                        "bg-sesh-primary !text-base-dark transition-all duration-300 hover:bg-opacity-90 hover:!text-white": is_best_deal,
                                        "border-2 border-content-primary !text-content-primary transition-all duration-300 hover:bg-content-primary hover:!text-base-dark": !is_best_deal
                                    }),
                                    children: props.span === (0, _premiumTiers.PaymentInterval).OneTime ? "Get Access Now" : props.has_used_free_trial || !(0, _featureFlags.isFeatureEnabled)("FreeTrial") ? "Subscribe Now" : "Start Free Trial"
                                })
                            })
                        })
                    }) : props.type === "custom-contact" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mt-auto pt-8",
                            children: props.onContactClick ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                onClick: props.onContactClick,
                                className: (0, _classnamesDefault.default)("justify-center font-extrabold", {
                                    "bg-sesh-primary !text-base-dark transition-all duration-300 hover:bg-opacity-90 hover:!text-white": is_best_deal,
                                    "border-2 border-content-primary !text-content-primary transition-all duration-300 hover:bg-content-primary hover:!text-base-dark": !is_best_deal
                                }),
                                children: props.buttonText ?? "Contact Us"
                            }) : props.link_type === "Link" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/dashboard/contact-us",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                    className: (0, _classnamesDefault.default)("justify-center font-extrabold", {
                                        "bg-sesh-primary !text-base-dark transition-all duration-300 hover:bg-opacity-90 hover:!text-white": is_best_deal,
                                        "border-2 border-content-primary !text-content-primary transition-all duration-300 hover:bg-content-primary hover:!text-base-dark": !is_best_deal
                                    }),
                                    children: props.buttonText ?? "Contact Us"
                                })
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: "/dashboard/contact-us",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                    className: (0, _classnamesDefault.default)("justify-center font-extrabold", {
                                        "bg-sesh-primary !text-base-dark transition-all duration-300 hover:bg-opacity-90 hover:!text-white": is_best_deal,
                                        "border-2 border-content-primary !text-content-primary transition-all duration-300 hover:bg-content-primary hover:!text-base-dark": !is_best_deal
                                    }),
                                    children: props.buttonText ?? "Contact Us"
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mt-auto pt-8",
                            children: props.link_type === "Link" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: (0, _commonUtils.common_utils).getStripeRedirectURL({
                                    type: "checkout",
                                    product_id: props.product_id,
                                    guild_id: props.guild_id,
                                    subscription_span: props.span.toString(),
                                    should_force_no_coupon: "true"
                                }),
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                    className: (0, _classnamesDefault.default)("justify-center font-extrabold", {
                                        "bg-sesh-primary !text-base-dark transition-all duration-300 hover:bg-cyan-300": props.is_glowing,
                                        "bg-sesh-primary !text-base-dark transition-all duration-300 hover:bg-opacity-90 hover:!text-white": is_best_deal && !props.is_glowing,
                                        "border-2 border-content-primary !text-content-primary transition-all duration-300 hover:bg-content-primary hover:!text-base-dark": !is_best_deal && !props.is_glowing
                                    }),
                                    children: "Get sesh Pro"
                                })
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: (0, _commonUtils.common_utils).getStripeRedirectURL({
                                    type: "checkout",
                                    product_id: props.product_id,
                                    guild_id: props.guild_id,
                                    subscription_span: props.span.toString(),
                                    should_force_no_coupon: "true"
                                }),
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshPrimaryButton.SeshPrimaryButton), {
                                    className: (0, _classnamesDefault.default)("justify-center font-extrabold", {
                                        "bg-sesh-primary !text-base-dark transition-all duration-300 hover:bg-cyan-300": props.is_glowing,
                                        "bg-sesh-primary !text-base-dark transition-all duration-300 hover:bg-opacity-90 hover:!text-white": is_best_deal && !props.is_glowing,
                                        "border-2 border-content-primary !text-content-primary transition-all duration-300 hover:bg-content-primary hover:!text-base-dark": !is_best_deal && !props.is_glowing
                                    }),
                                    children: "Get sesh Pro"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}
function FullPriceDisplay(props) {
    const { price, coupon, span, is_best_deal, type, is_sesh_pro } = props;
    // Calculate discounted price based on coupon type
    let discountedCents = null;
    if (coupon) {
        if (coupon.api_data.percent_off) discountedCents = price.cents * (1 - coupon.api_data.percent_off / 100);
        else if (coupon.api_data.amount_off) // amount_off is in cents
        discountedCents = Math.max(0, price.cents - coupon.api_data.amount_off);
    }
    // For annual plans, calculate monthly cost
    const displayCents = span === (0, _premiumTiers.PaymentInterval).Year ? price.cents / 12 : price.cents;
    const displayDiscountedCents = discountedCents !== null ? span === (0, _premiumTiers.PaymentInterval).Year ? discountedCents / 12 : discountedCents : null;
    // If there's a coupon, show both prices inline
    if (coupon && displayDiscountedCents !== null) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mb-2 flex flex-col items-center justify-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center justify-center gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: (0, _classnamesDefault.default)("text-xl font-normal line-through decoration-1 opacity-50", {
                            "text-sesh-primary": is_best_deal,
                            "text-content-primary": !is_best_deal
                        }),
                        children: [
                            "$",
                            (0, _pricingTable.centsToDollars)(displayCents)
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: (0, _classnamesDefault.default)("text-4xl font-extrabold", {
                            "bg-gradient-to-r from-amber-200 via-yellow-300 to-amber-400 bg-clip-text text-transparent": is_sesh_pro,
                            "text-sesh-primary": is_best_deal && !is_sesh_pro,
                            "text-content-primary": !is_best_deal && !is_sesh_pro
                        }),
                        children: [
                            "$",
                            (0, _pricingTable.centsToDollars)(displayDiscountedCents)
                        ]
                    }),
                    span !== (0, _premiumTiers.PaymentInterval).OneTime && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _classnamesDefault.default)("text-xs font-bold", {
                            "bg-gradient-to-r from-amber-200 via-yellow-300 to-amber-400 bg-clip-text text-transparent": is_sesh_pro,
                            "text-sesh-primary": is_best_deal && !is_sesh_pro,
                            "text-content-primary": !is_best_deal && !is_sesh_pro
                        }),
                        children: span === (0, _premiumTiers.PaymentInterval).Year ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                "per",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "month"
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                "per",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                (0, _premiumTiers.PaymentInterval)[span].toLowerCase()
                            ]
                        })
                    }),
                    span === (0, _premiumTiers.PaymentInterval).OneTime && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: (0, _classnamesDefault.default)("text-xs font-bold", {
                            "bg-gradient-to-r from-amber-200 via-yellow-300 to-amber-400 bg-clip-text text-transparent": is_sesh_pro,
                            "text-sesh-primary": is_best_deal && !is_sesh_pro,
                            "text-content-primary": !is_best_deal && !is_sesh_pro
                        }),
                        children: [
                            "one",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            "time"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _classnamesDefault.default)("text-xs", {
                    invisible: span !== (0, _premiumTiers.PaymentInterval).Year || type === "custom",
                    "text-content-secondary": span === (0, _premiumTiers.PaymentInterval).Year && type !== "custom"
                }),
                "aria-hidden": span !== (0, _premiumTiers.PaymentInterval).Year || type === "custom",
                children: "Billed Annually"
            })
        ]
    });
    // No coupon - show regular price display
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PriceDisplay, {
        cents: price.cents,
        span: span,
        is_best_deal: is_best_deal,
        type: type
    });
}
function PriceDisplay(props) {
    const { cents, span, type } = props;
    // For annual plans, calculate and show monthly cost
    const displayCents = span === (0, _premiumTiers.PaymentInterval).Year ? cents / 12 : cents;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("mb-2 flex flex-col items-center justify-center", {
            "opacity-25": props.striked_through,
            "text-sesh-primary": props.is_best_deal && !props.striked_through,
            "text-content-primary": !props.is_best_deal && !props.striked_through
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex items-center justify-center gap-1",
                children: type === "custom" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "text-4xl font-extrabold text-content-primary",
                    children: "Contact Us"
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _classnamesDefault.default)("text-4xl font-extrabold", {
                                "font-normal line-through decoration-2": props.striked_through
                            }),
                            children: [
                                "$",
                                (0, _pricingTable.centsToDollars)(displayCents)
                            ]
                        }),
                        span !== (0, _premiumTiers.PaymentInterval).OneTime && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _classnamesDefault.default)("text-xs font-bold", {
                                "line-through": props.striked_through
                            }),
                            children: span === (0, _premiumTiers.PaymentInterval).Year ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    "per",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                    "month"
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    "per",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                    (0, _premiumTiers.PaymentInterval)[span].toLowerCase()
                                ]
                            })
                        }) || /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _classnamesDefault.default)("text-xs font-bold", {
                                "line-through": props.striked_through
                            }),
                            children: [
                                "one",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "time"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _classnamesDefault.default)("text-xs", {
                    invisible: span !== (0, _premiumTiers.PaymentInterval).Year || type === "custom",
                    "text-content-secondary": span === (0, _premiumTiers.PaymentInterval).Year && type !== "custom"
                }),
                "aria-hidden": span !== (0, _premiumTiers.PaymentInterval).Year || type === "custom",
                children: "Billed Annually"
            })
        ]
    });
}
function ContactPriceDisplay() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mb-2 flex flex-col items-center justify-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex items-center justify-center gap-1",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "inline-block bg-gradient-to-r from-amber-200 via-yellow-300 to-amber-400 bg-clip-text text-3xl font-extrabold text-transparent sm:text-4xl",
                    style: {
                        paddingBottom: "0.1em",
                        marginBottom: "-0.1em"
                    },
                    children: "Contact Us"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "invisible text-xs",
                children: "Billed Annually"
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react-router-dom":"3XSn5","../../../../../../common/common_utils":"gACUC","../../../../../../common/premium_tiers":"NLcok","../base_components/sesh_primary_button":"3QyI2","../base_components/tag":"l4wGc","./pricing_table":"iyQuU","../../../../../../src/feature_flags":"jss8q","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"jss8q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FEATURE_FLAGS", ()=>FEATURE_FLAGS);
parcelHelpers.export(exports, "isFeatureEnabled", ()=>isFeatureEnabled);
const FEATURE_FLAGS = {
    FreeTrial: true
};
function isFeatureEnabled(feature) {
    return FEATURE_FLAGS[feature];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gHSoZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpgradeChoiceModal", ()=>UpgradeChoiceModal);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _premiumTiers = require("../../../../../../common/premium_tiers");
var _dashboardUtils = require("../../../dashboard_utils");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
function UpgradeChoiceModal(props) {
    const { open, onClose, licenses, onUpgrade, onBuyNew, isLoading } = props;
    const [selectedLicenseId, setSelectedLicenseId] = (0, _react.useState)(licenses.length === 1 ? licenses[0].id : null);
    // Auto-select when there's exactly 1 license (handles async loading)
    (0, _react.useEffect)(()=>{
        if (licenses.length === 1 && !selectedLicenseId) setSelectedLicenseId(licenses[0].id);
    }, [
        licenses,
        selectedLicenseId
    ]);
    if (!open) return null;
    const selectedLicense = licenses.find((l)=>l.id === selectedLicenseId);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
        is_active: open,
        onClose: onClose,
        title: "Upgrade to sesh Pro",
        subtitle: "Choose how you'd like to get sesh Pro",
        content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "mt-4 flex flex-col gap-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "rounded-lg border border-slate-600 bg-slate-800/50 p-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-3 flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-arrow-up text-sesh-primary"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "text-lg font-semibold text-white",
                                    children: "Upgrade Existing License"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "mb-4 text-sm text-slate-300",
                            children: "Upgrade one of your current Premium licenses to sesh Pro. You'll keep your current billing cycle and only pay the price difference."
                        }),
                        licenses.length > 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-4 flex flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "text-sm font-medium text-slate-200",
                                    children: "Select a license to upgrade:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-col gap-2",
                                    children: licenses.map((license)=>{
                                        const product = (0, _premiumTiers.getRawProductWithoutPrices)(license.product_id);
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            className: (0, _classnamesDefault.default)("flex cursor-pointer items-center gap-3 rounded-md border p-3 transition-colors", {
                                                "border-sesh-primary bg-sesh-primary/10": selectedLicenseId === license.id,
                                                "border-slate-600 hover:border-slate-500": selectedLicenseId !== license.id
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "radio",
                                                    name: "license",
                                                    value: license.id,
                                                    checked: selectedLicenseId === license.id,
                                                    onChange: ()=>setSelectedLicenseId(license.id),
                                                    className: "h-4 w-4 text-sesh-primary focus:ring-sesh-primary"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-1 items-center justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex flex-col",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "font-medium text-white",
                                                                    children: product?.title || "Premium"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "text-xs text-slate-400",
                                                                    children: [
                                                                        license.activations,
                                                                        " ",
                                                                        "activation",
                                                                        license.activations > 1 ? "s" : ""
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "rounded bg-amber-600/80 px-2 py-1 text-xs font-bold text-white",
                                                            children: (0, _premiumTiers.PaymentIntervalToActiveName)[license.payment_interval]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, license.id);
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mb-4 rounded-md border border-slate-600 bg-slate-900/50 p-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center justify-between gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-check-circle text-green-400"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-white",
                                                children: (0, _premiumTiers.getRawProductWithoutPrices)(licenses[0].product_id)?.title || "Premium"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "rounded bg-amber-600/80 px-2 py-1 text-xs font-bold text-white",
                                        children: (0, _premiumTiers.PaymentIntervalToActiveName)[licenses[0].payment_interval]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            onClick: ()=>{
                                if (selectedLicense) onUpgrade(selectedLicense);
                            },
                            disabled: !selectedLicense || isLoading,
                            is_loading: isLoading,
                            className: (0, _classnamesDefault.default)("w-full justify-center", {
                                "bg-sesh-primary font-semibold !text-base-dark hover:bg-cyan-300": selectedLicense && !isLoading,
                                "opacity-50": !selectedLicense || isLoading
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-arrow-up mr-2"
                                }),
                                isLoading ? "Redirecting to checkout..." : "Upgrade Selected License"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "h-px flex-1 bg-slate-600"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "text-sm text-slate-400",
                            children: "or"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "h-px flex-1 bg-slate-600"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "rounded-lg border border-slate-600 bg-slate-800/50 p-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-3 flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-plus text-amber-400"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "text-lg font-semibold text-white",
                                    children: "Buy New sesh Pro License"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "mb-4 text-sm text-slate-300",
                            children: "Purchase a separate sesh Pro license. This will be a new subscription independent of your existing Premium license(s)."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            onClick: onBuyNew,
                            className: "w-full justify-center border-2 border-amber-400 font-semibold !text-amber-400 hover:bg-amber-400/10",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-shopping-cart mr-2"
                                }),
                                "Buy New License"
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","../../../../../../common/premium_tiers":"NLcok","../../../dashboard_utils":"jvA8A","../base_components/sesh_primary_button":"3QyI2","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8PJa8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProQuantityModal", ()=>ProQuantityModal);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _dashboardUtils = require("../../../dashboard_utils");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
function ProQuantityModal(props) {
    const { open, onClose, availableSlots, currentProCount, onConfirm, isLoading } = props;
    const [selectedCount, setSelectedCount] = (0, _react.useState)(1);
    if (!open) return null;
    // Calculate how many Pro licenses can be added (max is availableSlots)
    const maxAddable = Math.min(availableSlots, 3);
    const options = Array.from({
        length: maxAddable
    }, (_, i)=>i + 1);
    // Calculate final counts after upgrade
    const finalProCount = currentProCount + selectedCount;
    const finalPremiumCount = availableSlots - selectedCount;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
        is_active: open,
        onClose: onClose,
        title: "Select Pro License Count",
        subtitle: "Choose how many of your Premium slots to upgrade to sesh Pro",
        content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "mt-4 flex flex-col gap-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "rounded-lg border border-slate-600 bg-slate-900/50 p-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2 text-sm text-slate-300",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-info-circle text-sesh-primary"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    "Your Premium Bundle has",
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-semibold text-white",
                                        children: availableSlots
                                    }),
                                    " ",
                                    "server slots. You can upgrade some or all of them to sesh Pro."
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            className: "text-sm font-medium text-slate-200",
                            children: "Number of Pro licenses:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-wrap gap-2",
                            children: options.map((count)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    onClick: ()=>setSelectedCount(count),
                                    className: (0, _classnamesDefault.default)("flex min-w-[4rem] flex-col items-center rounded-lg border-2 px-4 py-3 transition-all", {
                                        "border-sesh-primary bg-sesh-primary/10 text-white": selectedCount === count,
                                        "border-slate-600 text-slate-300 hover:border-slate-500": selectedCount !== count
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-2xl font-bold",
                                            children: count
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "text-xs",
                                            children: [
                                                "Pro",
                                                count > 1 ? " licenses" : " license"
                                            ]
                                        })
                                    ]
                                }, count))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "rounded-lg border border-slate-600 bg-slate-800/50 p-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                            className: "mb-3 text-sm font-medium text-slate-200",
                            children: "After upgrade:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "fas fa-crown text-amber-300"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-white",
                                                    children: "sesh Pro servers"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-semibold text-amber-300",
                                            children: finalProCount
                                        })
                                    ]
                                }),
                                finalPremiumCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "fas fa-gem text-sesh-primary"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-white",
                                                    children: "Premium servers"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-semibold text-sesh-primary",
                                            children: finalPremiumCount
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _seshPrimaryButton.SeshPrimaryButton), {
                    onClick: ()=>onConfirm(selectedCount),
                    disabled: isLoading,
                    is_loading: isLoading,
                    className: (0, _classnamesDefault.default)("w-full justify-center font-semibold", isLoading ? "opacity-50" : "bg-sesh-primary !text-base-dark hover:bg-cyan-300"),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-arrow-right mr-2"
                        }),
                        isLoading ? "Redirecting to checkout..." : `Continue with ${selectedCount} Pro License${selectedCount > 1 ? "s" : ""}`
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","../../../dashboard_utils":"jvA8A","../base_components/sesh_primary_button":"3QyI2","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iN0DN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscriptionUpgradeModal", ()=>SubscriptionUpgradeModal);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _dashboardUtils = require("../../../dashboard_utils");
var _trpc = require("../../../utils/trpc");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
var _loadingThrobber = require("../base_components/loading_throbber");
var _premiumTiers = require("../../../../../../common/premium_tiers");
/**
 * Format cents to a currency string using Intl.NumberFormat
 */ function formatCurrency(cents, currency = "usd") {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency.toUpperCase()
    }).format(cents / 100);
}
/**
 * Format payment interval to a readable string
 */ function formatInterval(interval) {
    switch(interval){
        case (0, _premiumTiers.PaymentInterval).Month:
            return "Monthly";
        case (0, _premiumTiers.PaymentInterval).Year:
            return "Yearly";
        default:
            return "";
    }
}
function SubscriptionUpgradeModal(props) {
    const { open, onClose, entitlementId, proCount, isBundle, onSuccess } = props;
    const [isUpgrading, setIsUpgrading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    // Fetch upgrade preview
    const previewQuery = (0, _trpc.trpc).premium.getSubscriptionUpgradePreview.useQuery({
        entitlement_id: entitlementId,
        pro_count: proCount
    }, {
        enabled: open
    });
    // Execute upgrade mutation
    const upgradeMutation = (0, _trpc.trpc).premium.executeSubscriptionUpgrade.useMutation({
        onSuccess: ()=>{
            setIsUpgrading(false);
            onSuccess();
        },
        onError: (err)=>{
            setIsUpgrading(false);
            setError(err.message || "Failed to process upgrade");
        }
    });
    if (!open) return null;
    const handleConfirmUpgrade = ()=>{
        setIsUpgrading(true);
        setError(null);
        upgradeMutation.mutate({
            entitlement_id: entitlementId,
            pro_count: proCount
        });
    };
    const preview = previewQuery.data;
    const isLoading = previewQuery.isLoading;
    const previewError = previewQuery.error;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
        is_active: open,
        onClose: onClose,
        title: "Confirm Upgrade",
        subtitle: isBundle ? `Upgrade ${proCount} slot${proCount > 1 ? "s" : ""} to sesh Pro` : "Upgrade to sesh Pro",
        content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "mt-4 flex flex-col gap-6",
            children: [
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingThrobber.LoadingThrobber), {
                    loading_text: "Calculating upgrade price...",
                    vertical_spaces: 2
                }),
                previewError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "rounded-lg border border-red-500/50 bg-red-500/10 p-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2 text-red-400",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-exclamation-circle"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: previewError.message || "Failed to load upgrade preview"
                            })
                        ]
                    })
                }),
                preview && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "rounded-lg border border-slate-600 bg-slate-800/50 p-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    className: "mb-4 text-sm font-medium text-slate-200",
                                    children: "Subscription Changes"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "grid grid-cols-[1fr_auto_1fr] items-center gap-3 text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "rounded bg-slate-700/50 p-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mb-1 text-xs font-medium text-slate-400",
                                                            children: "Current"
                                                        }),
                                                        preview.current_premium_count > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "text-slate-300",
                                                            children: [
                                                                preview.current_premium_count,
                                                                " Premium license",
                                                                preview.current_premium_count > 1 ? "s" : ""
                                                            ]
                                                        }),
                                                        preview.current_pro_count > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "text-amber-400",
                                                            children: [
                                                                preview.current_pro_count,
                                                                " Pro license",
                                                                preview.current_pro_count > 1 ? "s" : ""
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "text-slate-500",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fas fa-arrow-right"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "rounded bg-slate-700/50 p-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mb-1 text-xs font-medium text-slate-400",
                                                            children: "After Upgrade"
                                                        }),
                                                        preview.resulting_premium_count > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "text-slate-300",
                                                            children: [
                                                                preview.resulting_premium_count,
                                                                " Premium license",
                                                                preview.resulting_premium_count > 1 ? "s" : ""
                                                            ]
                                                        }),
                                                        preview.resulting_pro_count > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "text-amber-400",
                                                            children: [
                                                                preview.resulting_pro_count,
                                                                " Pro license",
                                                                preview.resulting_pro_count > 1 ? "s" : ""
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-xs text-slate-400",
                                            children: isBundle ? `Converting ${proCount} of your Premium license${proCount > 1 ? "s" : ""} to Pro. Pro includes all Premium features plus API access, custom branding, and more.` : "Your Premium license will be converted to Pro, which includes all Premium features plus API access, custom branding, and more."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "rounded-lg border border-slate-600 bg-slate-800/50 p-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mb-4 flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                            className: "text-sm font-medium text-slate-200",
                                            children: preview.is_trialing ? "Amount Due When Trial Ends" : "Prorated Amount Due Today"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "rounded bg-amber-600/80 px-2 py-1 text-xs font-bold text-white",
                                            children: [
                                                formatInterval(preview.payment_interval),
                                                " Billing"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col gap-2",
                                    children: [
                                        preview.line_items?.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex items-start justify-between gap-4 text-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: (0, _classnamesDefault.default)("flex-1", item.amount < 0 ? "text-green-400" : "text-slate-300"),
                                                        children: [
                                                            item.description,
                                                            item.proration && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "ml-1 text-xs text-slate-500",
                                                                children: "(prorated)"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: (0, _classnamesDefault.default)("whitespace-nowrap font-medium", item.amount < 0 ? "text-green-400" : "text-slate-200"),
                                                        children: [
                                                            item.amount < 0 ? "-" : "",
                                                            formatCurrency(Math.abs(item.amount), preview.currency)
                                                        ]
                                                    })
                                                ]
                                            }, index)),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "my-2 border-t border-slate-600"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium text-slate-200",
                                                    children: "Total"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-lg font-bold text-sesh-primary",
                                                    children: formatCurrency(preview.amount_due, preview.currency)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-xs text-slate-400",
                                            children: preview.is_trialing ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    "Your trial ends on",
                                                    " ",
                                                    new Date((preview.trial_end ?? preview.current_period_end) * 1000).toLocaleDateString(),
                                                    "\u2014you won't be charged until then."
                                                ]
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    "Prorated for the remainder of your",
                                                    " ",
                                                    preview.payment_interval === (0, _premiumTiers.PaymentInterval).Month ? "monthly" : "yearly",
                                                    " ",
                                                    "billing period (until",
                                                    " ",
                                                    new Date(preview.current_period_end * 1000).toLocaleDateString(),
                                                    ")."
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "rounded-lg border border-slate-600 bg-slate-800/50 p-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
                                    className: "mb-3 text-sm font-medium text-slate-200",
                                    children: [
                                        "Future",
                                        " ",
                                        preview.payment_interval === (0, _premiumTiers.PaymentInterval).Month ? "Monthly" : "Yearly",
                                        " ",
                                        "Charge"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "text-xs text-slate-400",
                                            children: [
                                                "Starting",
                                                " ",
                                                new Date(preview.current_period_end * 1000).toLocaleDateString()
                                            ]
                                        }),
                                        preview.global_coupon?.is_recurring && preview.global_coupon.future_discount_amount > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex items-center justify-between text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "text-slate-300",
                                                            children: "Subscription"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "text-slate-300",
                                                            children: [
                                                                formatCurrency(preview.future_recurring_amount + preview.global_coupon.future_discount_amount, preview.currency),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "ml-1 text-xs text-slate-400",
                                                                    children: [
                                                                        "/",
                                                                        preview.payment_interval === (0, _premiumTiers.PaymentInterval).Month ? "mo" : "yr"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex items-center justify-between text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "text-green-400",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                    className: "fas fa-tag mr-1"
                                                                }),
                                                                preview.global_coupon.name
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "text-green-400",
                                                            children: [
                                                                "-",
                                                                formatCurrency(preview.global_coupon.future_discount_amount, preview.currency),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "ml-1 text-xs text-green-400/70",
                                                                    children: [
                                                                        "/",
                                                                        preview.payment_interval === (0, _premiumTiers.PaymentInterval).Month ? "mo" : "yr"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "my-1 border-t border-slate-600"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex items-center justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "font-medium text-slate-200",
                                                            children: "Total"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "text-lg font-bold text-slate-200",
                                                            children: [
                                                                formatCurrency(preview.future_recurring_amount, preview.currency),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "ml-1 text-sm font-normal text-slate-400",
                                                                    children: [
                                                                        "/",
                                                                        preview.payment_interval === (0, _premiumTiers.PaymentInterval).Month ? "mo" : "yr"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /* No coupon - show simple total */ /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium text-slate-200",
                                                    children: "Total"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "text-lg font-bold text-slate-200",
                                                    children: [
                                                        formatCurrency(preview.future_recurring_amount, preview.currency),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "ml-1 text-sm font-normal text-slate-400",
                                                            children: [
                                                                "/",
                                                                preview.payment_interval === (0, _premiumTiers.PaymentInterval).Month ? "mo" : "yr"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rounded-lg border border-red-500/50 bg-red-500/10 p-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2 text-red-400",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-exclamation-circle"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: error
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            onClick: handleConfirmUpgrade,
                            disabled: isUpgrading,
                            is_loading: isUpgrading,
                            className: "w-full justify-center bg-sesh-primary font-semibold !text-base-dark hover:bg-cyan-300",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: "fas fa-crown mr-2 text-amber-300"
                                }),
                                preview.is_trialing ? "Confirm Upgrade" : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        "Confirm Upgrade -",
                                        " ",
                                        formatCurrency(preview.amount_due, preview.currency)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-center text-xs text-slate-400",
                            children: preview.is_trialing ? "Your subscription will be updated immediately. You'll be charged when your trial ends." : "Your card on file will be charged. You can manage your subscription in the Stripe billing portal."
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","../../../dashboard_utils":"jvA8A","../../../utils/trpc":"dyYvM","../base_components/sesh_primary_button":"3QyI2","../base_components/loading_throbber":"1I8d2","../../../../../../common/premium_tiers":"NLcok","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6Ll0c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerActivationModal", ()=>ServerActivationModal);
parcelHelpers.export(exports, "ProAssignmentModal", ()=>ProAssignmentModal);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _dashboardUtils = require("../../../dashboard_utils");
var _seshPrimaryButton = require("../base_components/sesh_primary_button");
// Config for different activation types
const typeConfig = {
    premium: {
        title: "Activate Premium",
        icon: "fas fa-gem",
        iconColor: "text-sesh-primary",
        bannerBorder: "border-sesh-primary/30",
        bannerBg: "bg-sesh-primary/10",
        bannerTextColor: "text-cyan-200",
        label: "Premium",
        buttonText: "Activate Premium"
    },
    pro: {
        title: "Activate sesh Pro",
        icon: "fas fa-crown",
        iconColor: "text-amber-300",
        bannerBorder: "border-amber-500/30",
        bannerBg: "bg-amber-500/10",
        bannerTextColor: "text-amber-200",
        label: "sesh Pro",
        buttonText: "Activate sesh Pro"
    }
};
function ServerActivationModal(props) {
    const { open, onClose, unassignedCount, guilds, onAssign, type } = props;
    const [selectedGuildIds, setSelectedGuildIds] = (0, _react.useState)(new Set());
    const [isAssigning, setIsAssigning] = (0, _react.useState)(false);
    const config = typeConfig[type];
    // Reset state when modal opens
    (0, _react.useEffect)(()=>{
        if (open) {
            setSelectedGuildIds(new Set());
            setIsAssigning(false);
        }
    }, [
        open
    ]);
    // Sort guilds based on activation type
    const sortedGuilds = (0, _react.useMemo)(()=>{
        return guilds.filter((g)=>g.has_sesh).map((guild)=>{
            let sortPriority;
            let statusLabel = null;
            let isDisabled = false;
            if (type === "pro") {
                // For Pro assignment
                if (guild.has_sesh_pro) {
                    sortPriority = 2;
                    statusLabel = "sesh Pro";
                    isDisabled = true;
                } else if (guild.is_premium || guild.is_discord_premium) {
                    sortPriority = 0;
                    statusLabel = "Premium";
                } else sortPriority = 1;
            } else // For Premium assignment
            if (guild.is_premium || guild.is_discord_premium) {
                sortPriority = 2;
                statusLabel = guild.has_sesh_pro ? "sesh Pro" : "Premium";
                isDisabled = true;
            } else sortPriority = 0;
            return {
                ...guild,
                sortPriority,
                statusLabel,
                isDisabled
            };
        }).sort((a, b)=>{
            if (a.sortPriority !== b.sortPriority) return a.sortPriority - b.sortPriority;
            return a.name.localeCompare(b.name);
        });
    }, [
        guilds,
        type
    ]);
    if (!open) return null;
    const handleToggleGuild = (guildId)=>{
        setSelectedGuildIds((prev)=>{
            const next = new Set(prev);
            if (next.has(guildId)) next.delete(guildId);
            else if (next.size < unassignedCount) next.add(guildId);
            return next;
        });
    };
    const handleAssign = ()=>{
        console.log("handleAssign - selectedGuildIds:", Array.from(selectedGuildIds));
        console.log("handleAssign - unassignedCount:", unassignedCount);
        setIsAssigning(true);
        onAssign(Array.from(selectedGuildIds));
    };
    const remainingSlots = unassignedCount - selectedGuildIds.size;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardUtils.DashboardUtils).SeshModal, {
        is_active: open,
        onClose: onClose,
        title: config.title,
        subtitle: `Select ${unassignedCount === 1 ? "a server" : `up to ${unassignedCount} servers`} to activate ${config.label}`,
        content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "mt-4 flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _classnamesDefault.default)("rounded-lg border p-3", config.bannerBorder, config.bannerBg),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _classnamesDefault.default)("flex items-center gap-2 text-sm", config.bannerTextColor),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: (0, _classnamesDefault.default)(config.icon, config.iconColor)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    "You have",
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-semibold",
                                        children: unassignedCount
                                    }),
                                    " ",
                                    config.label,
                                    " activation",
                                    unassignedCount > 1 ? "s" : "",
                                    " to assign"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center justify-between text-sm",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "text-slate-300",
                            children: [
                                "Selected: ",
                                selectedGuildIds.size,
                                " /",
                                " ",
                                unassignedCount
                            ]
                        }),
                        remainingSlots > 0 && selectedGuildIds.size > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "text-slate-400",
                            children: [
                                remainingSlots,
                                " slot",
                                remainingSlots > 1 ? "s" : "",
                                " remaining"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "max-h-[300px] overflow-y-auto rounded-lg border border-slate-600 bg-slate-900/50",
                    children: sortedGuilds.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "p-4 text-center text-slate-400",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-server mb-2 text-2xl"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "No servers with sesh found. Please invite sesh to a server first."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                        className: "divide-y divide-slate-700",
                        children: sortedGuilds.map((guild)=>{
                            const isSelected = selectedGuildIds.has(guild.id);
                            const canSelect = !guild.isDisabled && (isSelected || selectedGuildIds.size < unassignedCount);
                            const icon = (0, _dashboardUtils.DashboardUtils).GetGuildIconURI({
                                id: guild.id,
                                icon: guild.icon
                            }, 64);
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                onClick: ()=>{
                                    if (canSelect) handleToggleGuild(guild.id);
                                },
                                className: (0, _classnamesDefault.default)("flex cursor-pointer items-center gap-3 p-3 transition-colors", {
                                    "bg-sesh-primary/10": isSelected,
                                    "hover:bg-slate-800": canSelect && !isSelected,
                                    "cursor-not-allowed opacity-50": !canSelect
                                }),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _classnamesDefault.default)("flex h-5 w-5 flex-shrink-0 items-center justify-center rounded border", {
                                            "border-sesh-primary bg-sesh-primary": isSelected,
                                            "border-slate-500": !isSelected && canSelect,
                                            "border-slate-600": !canSelect
                                        }),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: (0, _classnamesDefault.default)("fas fa-check text-xs text-base-dark", {
                                                invisible: !isSelected
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: icon,
                                        alt: "",
                                        className: "h-10 w-10 rounded-full"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex min-w-0 flex-1 flex-col",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: (0, _classnamesDefault.default)("truncate font-medium", {
                                                    "text-white": canSelect,
                                                    "text-slate-400": !canSelect
                                                }),
                                                children: guild.name
                                            }),
                                            guild.statusLabel && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: (0, _classnamesDefault.default)("text-xs", {
                                                    "text-amber-300": guild.statusLabel === "sesh Pro",
                                                    "text-sesh-primary": guild.statusLabel === "Premium"
                                                }),
                                                children: [
                                                    guild.statusLabel,
                                                    guild.isDisabled && " (already active)"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, guild.id);
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _seshPrimaryButton.SeshPrimaryButton), {
                            onClick: handleAssign,
                            disabled: selectedGuildIds.size === 0 || isAssigning,
                            is_loading: isAssigning,
                            className: (0, _classnamesDefault.default)("w-full justify-center font-semibold", {
                                "bg-sesh-primary !text-base-dark hover:bg-cyan-300": selectedGuildIds.size > 0 && !isAssigning,
                                "opacity-50": selectedGuildIds.size === 0
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                    className: (0, _classnamesDefault.default)(config.icon, config.iconColor, "mr-2")
                                }),
                                config.buttonText,
                                selectedGuildIds.size > 0 && ` on ${selectedGuildIds.size} Server${selectedGuildIds.size > 1 ? "s" : ""}`
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: onClose,
                            className: "text-sm text-slate-400 hover:text-white",
                            children: "Skip for now (you can assign later)"
                        })
                    ]
                })
            ]
        })
    });
}
const ProAssignmentModal = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ServerActivationModal, {
        ...props,
        type: "pro"
    });

},{"react/jsx-runtime":"dpQXr","classnames":"7uztA","react":"IMRgT","../../../dashboard_utils":"jvA8A","../base_components/sesh_primary_button":"3QyI2","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"iYXGG":[function(require,module,exports,__globalThis) {
"use client";
"use strict";
var q = Object.create;
var O = Object.defineProperty;
var G = Object.getOwnPropertyDescriptor;
var J = Object.getOwnPropertyNames;
var K = Object.getPrototypeOf, X = Object.prototype.hasOwnProperty;
var Z = (e, t)=>{
    for(var o in t)O(e, o, {
        get: t[o],
        enumerable: !0
    });
}, H = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let a of J(t))!X.call(e, a) && a !== o && O(e, a, {
        get: ()=>t[a],
        enumerable: !(s = G(t, a)) || s.enumerable
    });
    return e;
};
var W = (e, t, o)=>(o = e != null ? q(K(e)) : {}, H(t || !e || !e.__esModule ? O(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), ee = (e)=>H(O({}, "__esModule", {
        value: !0
    }), e);
var Ve = {};
Z(Ve, {
    CheckmarkIcon: ()=>F,
    ErrorIcon: ()=>w,
    LoaderIcon: ()=>C,
    ToastBar: ()=>$,
    ToastIcon: ()=>U,
    Toaster: ()=>Y,
    default: ()=>ke,
    resolveValue: ()=>u,
    toast: ()=>n,
    useToaster: ()=>_,
    useToasterStore: ()=>V
});
module.exports = ee(Ve);
var te = (e)=>typeof e == "function", u = (e, t)=>te(e) ? e(t) : e;
var j = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), I = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();
var x = require("cff97412359109c"), oe = 20;
var Q = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, oe)
            };
        case 1:
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === t.toast.id ? {
                        ...r,
                        ...t.toast
                    } : r)
            };
        case 2:
            let { toast: o } = t;
            return Q(e, {
                type: e.toasts.find((r)=>r.id === o.id) ? 1 : 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === s || s === void 0 ? {
                        ...r,
                        dismissed: !0,
                        visible: !1
                    } : r)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((r)=>r.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let a = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((r)=>({
                        ...r,
                        pauseDuration: r.pauseDuration + a
                    }))
            };
    }
}, k = [], y = {
    toasts: [],
    pausedAt: void 0
}, l = (e)=>{
    y = Q(y, e), k.forEach((t)=>{
        t(y);
    });
}, re = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, V = (e = {})=>{
    let [t, o] = (0, x.useState)(y), s = (0, x.useRef)(y);
    (0, x.useEffect)(()=>(s.current !== y && o(y), k.push(o), ()=>{
            let r = k.indexOf(o);
            r > -1 && k.splice(r, 1);
        }), []);
    let a = t.toasts.map((r)=>{
        var c, i, p;
        return {
            ...e,
            ...e[r.type],
            ...r,
            removeDelay: r.removeDelay || ((c = e[r.type]) == null ? void 0 : c.removeDelay) || (e == null ? void 0 : e.removeDelay),
            duration: r.duration || ((i = e[r.type]) == null ? void 0 : i.duration) || (e == null ? void 0 : e.duration) || re[r.type],
            style: {
                ...e.style,
                ...(p = e[r.type]) == null ? void 0 : p.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: a
    };
};
var ae = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        dismissed: !1,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || j()
    }), R = (e)=>(t, o)=>{
        let s = ae(t, e, o);
        return l({
            type: 2,
            toast: s
        }), s.id;
    }, n = (e, t)=>R("blank")(e, t);
n.error = R("error");
n.success = R("success");
n.loading = R("loading");
n.custom = R("custom");
n.dismiss = (e)=>{
    l({
        type: 3,
        toastId: e
    });
};
n.remove = (e)=>l({
        type: 4,
        toastId: e
    });
n.promise = (e, t, o)=>{
    let s = n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return typeof e == "function" && (e = e()), e.then((a)=>{
        let r = t.success ? u(t.success, a) : void 0;
        return r ? n.success(r, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }) : n.dismiss(s), a;
    }).catch((a)=>{
        let r = t.error ? u(t.error, a) : void 0;
        r ? n.error(r, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        }) : n.dismiss(s);
    }), e;
};
var b = require("cff97412359109c");
var ie = (e, t)=>{
    l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, ne = ()=>{
    l({
        type: 5,
        time: Date.now()
    });
}, v = new Map, ce = 1e3, pe = (e, t = ce)=>{
    if (v.has(e)) return;
    let o = setTimeout(()=>{
        v.delete(e), l({
            type: 4,
            toastId: e
        });
    }, t);
    v.set(e, o);
}, _ = (e)=>{
    let { toasts: t, pausedAt: o } = V(e);
    (0, b.useEffect)(()=>{
        if (o) return;
        let r = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let p = (i.duration || 0) + i.pauseDuration - (r - i.createdAt);
            if (p < 0) {
                i.visible && n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>n.dismiss(i.id), p);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, b.useCallback)(()=>{
        o && l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), a = (0, b.useCallback)((r, c)=>{
        let { reverseOrder: i = !1, gutter: p = 8, defaultPosition: d } = c || {}, h = t.filter((m)=>(m.position || d) === (r.position || d) && m.height), z = h.findIndex((m)=>m.id === r.id), D = h.filter((m, B)=>B < z && m.visible).length;
        return h.filter((m)=>m.visible).slice(...i ? [
            D + 1
        ] : [
            0,
            D
        ]).reduce((m, B)=>m + (B.height || 0) + p, 0);
    }, [
        t
    ]);
    return (0, b.useEffect)(()=>{
        t.forEach((r)=>{
            if (r.dismissed) pe(r.id, r.removeDelay);
            else {
                let c = v.get(r.id);
                c && (clearTimeout(c), v.delete(r.id));
            }
        });
    }, [
        t
    ]), {
        toasts: t,
        handlers: {
            updateHeight: ie,
            startPause: ne,
            endPause: s,
            calculateOffset: a
        }
    };
};
var f = W(require("cff97412359109c")), P = require("eb1a85e6ba4f13eb");
var g = W(require("cff97412359109c")), A = require("eb1a85e6ba4f13eb");
var S = require("eb1a85e6ba4f13eb"), de = S.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, me = S.keyframes`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, ue = S.keyframes`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, w = (0, S.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${de} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${me} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${ue} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;
var M = require("eb1a85e6ba4f13eb"), le = M.keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, C = (0, M.styled)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${le} 1s linear infinite;
`;
var E = require("eb1a85e6ba4f13eb"), fe = E.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, Te = E.keyframes`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, F = (0, E.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${fe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${Te} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var ye = (0, A.styled)("div")`
  position: absolute;
`, ge = (0, A.styled)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, he = A.keyframes`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, xe = (0, A.styled)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${he} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? g.createElement(xe, null, t) : t : o === "blank" ? null : g.createElement(ge, null, g.createElement(C, {
        ...s
    }), o !== "loading" && g.createElement(ye, null, o === "error" ? g.createElement(w, {
        ...s
    }) : g.createElement(F, {
        ...s
    })));
};
var be = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, Se = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, Ae = "0%{opacity:0;} 100%{opacity:1;}", Pe = "0%{opacity:1;} 100%{opacity:0;}", Re = (0, P.styled)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, ve = (0, P.styled)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, Ee = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [a, r] = I() ? [
        Ae,
        Pe
    ] : [
        be(s),
        Se(s)
    ];
    return {
        animation: t ? `${(0, P.keyframes)(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, P.keyframes)(r)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $ = f.memo(({ toast: e, position: t, style: o, children: s })=>{
    let a = e.height ? Ee(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, r = f.createElement(U, {
        toast: e
    }), c = f.createElement(ve, {
        ...e.ariaProps
    }, u(e.message, e));
    return f.createElement(Re, {
        className: e.className,
        style: {
            ...a,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: r,
        message: c
    }) : f.createElement(f.Fragment, null, r, c));
});
var N = require("eb1a85e6ba4f13eb"), T = W(require("cff97412359109c"));
(0, N.setup)(T.createElement);
var De = ({ id: e, className: t, style: o, onHeightUpdate: s, children: a })=>{
    let r = T.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let p = c.getBoundingClientRect().height;
                s(e, p);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return T.createElement("div", {
        ref: r,
        className: t,
        style: o
    }, a);
}, Oe = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, a = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: I() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...a
    };
}, Ie = N.css`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, L = 16, Y = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: a, containerStyle: r, containerClassName: c })=>{
    let { toasts: i, handlers: p } = _(o);
    return T.createElement("div", {
        id: "_rht_toaster",
        style: {
            position: "fixed",
            zIndex: 9999,
            top: L,
            left: L,
            right: L,
            bottom: L,
            pointerEvents: "none",
            ...r
        },
        className: c,
        onMouseEnter: p.startPause,
        onMouseLeave: p.endPause
    }, i.map((d)=>{
        let h = d.position || t, z = p.calculateOffset(d, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), D = Oe(h, z);
        return T.createElement(De, {
            id: d.id,
            key: d.id,
            onHeightUpdate: p.updateHeight,
            className: d.visible ? Ie : "",
            style: D
        }, d.type === "custom" ? u(d.message, d) : a ? a(d) : T.createElement($, {
            toast: d,
            position: h
        }));
    }));
};
var ke = n;

},{"cff97412359109c":"IMRgT","eb1a85e6ba4f13eb":"3RPuW"}],"3RPuW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "css", ()=>u);
parcelHelpers.export(exports, "extractCss", ()=>r);
parcelHelpers.export(exports, "glob", ()=>b);
parcelHelpers.export(exports, "keyframes", ()=>h);
parcelHelpers.export(exports, "setup", ()=>m);
parcelHelpers.export(exports, "styled", ()=>j);
let e = {
    data: ""
}, t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || e, r = (e)=>{
    let r = t(e), l = r.data;
    return r.data = "", l;
}, l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, a = /\/\*[^]*?\*\/|  +/g, n = /\n+/g, o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? o(c, n) : n + "{" + o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += o.p ? o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, c = {}, s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + s(e[r]);
        return t;
    }
    return e;
}, i = (e, t, r, i, p)=>{
    let u = s(e), d = c[u] || (c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = l.exec(e.replace(a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace(n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace(n, " ").trim();
            return o[0];
        })(e);
        c[d] = o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && c.g ? c.g : null;
    return r && (c.g = c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })(c[d], t, i, f), d;
}, p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function u(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return i(l.unshift ? l.raw ? p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, t(r.target), r.g, r.o, r.k);
}
let d, f, g, b = u.bind({
    g: 1
}), h = u.bind({
    k: 1
});
function m(e, t, r, l) {
    o.p = t, d = e, f = r, g = l;
}
function j(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: f && f()
            }, c), r.o = / *go\d+/.test(s), c.className = u.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), g && i[0] && g(c), d(i, c);
        }
        return t ? t(a) : a;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1o5nb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GifFeatureSections", ()=>GifFeatureSections);
var _jsxRuntime = require("react/jsx-runtime");
const features = [
    {
        title: "Custom RSVP options",
        description: "Create custom RSVP options using your own emojis with attendee limits and waitlists.",
        media: {
            type: "video",
            src: "/static/premium1.mp4",
            alt: "Custom RSVP options with emojis"
        }
    },
    {
        title: "Recurring events",
        description: "Flexible repeat options - daily, weekly, monthly, yearly, by weekday.",
        media: {
            type: "video",
            src: "/static/premium2.mp4",
            alt: "Creating recurring events"
        }
    },
    {
        title: "Attendee Roles",
        description: "Add roles to users who sign up and grant access to private event channels.",
        media: {
            type: "video",
            src: "/static/premium5.mp4",
            alt: "Attendee roles being assigned"
        }
    },
    {
        title: "Two way GCal Sync",
        description: "Instantly sync events between Discord and Google Calendar - no more delays!",
        media: {
            type: "video",
            src: "/static/gcal_sync.mp4",
            alt: "Two way Google Calendar sync"
        }
    }
];
function GifFeatureSections() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mx-auto max-w-6xl px-4 py-16",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                className: "mb-16 text-center text-4xl font-bold tracking-tight text-white",
                children: [
                    "See ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "sesh-text",
                        children: "sesh"
                    }),
                    " premium in action"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "space-y-20",
                children: features.map((feature, index)=>{
                    const isEven = index % 2 === 0;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `flex flex-col items-center gap-8 lg:flex-row ${isEven ? "lg:flex-row" : "lg:flex-row-reverse"}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "w-full lg:w-1/2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "group overflow-hidden rounded-xl border border-slate-700 bg-slate-900/50 transition-all duration-300 hover:border-slate-600",
                                    children: feature.media.type === "video" ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("video", {
                                        className: "h-64 w-full object-cover transition-transform duration-300 group-hover:scale-105",
                                        autoPlay: true,
                                        loop: true,
                                        muted: true,
                                        playsInline: true,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                                                src: feature.media.src,
                                                type: "video/mp4"
                                            }),
                                            feature.media.alt
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: feature.media.src,
                                        alt: feature.media.alt,
                                        className: "h-64 w-full object-cover transition-transform duration-300 group-hover:scale-105"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "w-full text-center lg:w-1/2 lg:text-left",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "mb-4 text-3xl font-bold text-white",
                                        children: feature.title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-lg leading-relaxed text-slate-300",
                                        children: feature.description
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cs05g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FeatureComparisonTable", ()=>FeatureComparisonTable);
var _jsxRuntime = require("react/jsx-runtime");
const features = [
    // Features available in both Free and Premium (checked in Free)
    {
        name: "Create and manage events",
        free: true,
        premium: true,
        pro: true,
        manualLink: "/manual#events"
    },
    {
        name: "Event RSVPs and notifications",
        free: true,
        premium: true,
        pro: true,
        manualLink: "/manual#events"
    },
    {
        name: "Event editing and deletion",
        free: true,
        premium: true,
        pro: true,
        manualLink: "/manual#events"
    },
    {
        name: "Event reminders",
        free: true,
        premium: true,
        pro: true,
        manualLink: "/manual#events"
    },
    {
        name: "Event threads",
        free: true,
        premium: true,
        pro: true,
        manualLink: "/manual#event_threads"
    },
    {
        name: "Event and poll channels",
        free: true,
        premium: true,
        pro: true,
        manualLink: "/manual#event_and_poll_channels"
    },
    {
        name: "Create and manage polls",
        free: true,
        premium: true,
        pro: true,
        manualLink: "/manual#polls"
    },
    {
        name: "Anonymous voting",
        free: true,
        premium: true,
        pro: true,
        manualLink: "/manual#polls"
    },
    {
        name: "Personal reminders",
        free: true,
        premium: true,
        pro: true,
        manualLink: "/manual#remind"
    },
    {
        name: "User preferences",
        free: true,
        premium: true,
        pro: true,
        manualLink: "/manual#user_preferences"
    },
    {
        name: "Server notifications",
        free: true,
        premium: true,
        pro: true,
        manualLink: "/manual#server_notifications"
    },
    // Features with differences between Free and Premium
    {
        name: "Event templates",
        free: "3 favorites per server",
        premium: "Unlimited favorites",
        pro: "Unlimited favorites",
        manualLink: "/manual#event_templates"
    },
    {
        name: "Server logs",
        free: "24 hours",
        premium: "Unlimited history",
        pro: "Unlimited history",
        manualLink: "/manual#server_logs"
    },
    {
        name: "Outbound calendar sync",
        free: "1 per user/server",
        premium: "5 per user/server",
        pro: "30 per user/server",
        manualLink: "/manual#google_calendar_sync"
    },
    {
        name: "Google Calendar integration",
        free: "Basic",
        premium: "Full two-way sync",
        pro: "Full two-way sync",
        manualLink: "/manual#google_calendar_sync"
    },
    {
        name: "AI command usage",
        free: "Limited",
        premium: "Higher limits",
        pro: "Higher limits",
        manualLink: "/manual#ai"
    },
    // Premium-only features
    {
        name: "Recurring/repeating events",
        free: false,
        premium: true,
        pro: true,
        manualLink: "/manual#repeating_events"
    },
    {
        name: "Custom RSVP options with limits",
        free: false,
        premium: true,
        pro: true,
        manualLink: "/manual/#custom_rsvp_options"
    },
    {
        name: "Attendee role automation",
        free: false,
        premium: true,
        pro: true,
        manualLink: "/manual#attendee_roles"
    },
    {
        name: "Role-based RSVP restrictions",
        free: false,
        premium: true,
        pro: true,
        manualLink: "/manual#role_restrictions"
    },
    {
        name: "Close RSVPs early",
        free: false,
        premium: true,
        pro: true,
        manualLink: "/manual#close_rsvps_early"
    },
    {
        name: "Role-based poll restrictions",
        free: false,
        premium: true,
        pro: true,
        manualLink: "/manual#role_restrictions"
    },
    {
        name: "Unlimited live list",
        free: false,
        premium: true,
        pro: true,
        manualLink: "/manual#live_list"
    },
    {
        name: "Inbound calendar sync",
        free: false,
        premium: "5 per user/server",
        pro: "30 per user/server",
        manualLink: "/manual#google_calendar_sync"
    },
    {
        name: "Bidirectional calendar sync",
        free: false,
        premium: "5 per user/server",
        pro: "30 per user/server",
        manualLink: "/manual#google_calendar_sync"
    },
    {
        name: "Time Finder advanced settings",
        free: false,
        premium: true,
        pro: true
    },
    // Pro-only features
    {
        name: "Bot name customization",
        free: false,
        premium: false,
        pro: true,
        manualLink: "/manual#bot_name"
    },
    {
        name: "Bot profile customization",
        free: false,
        premium: false,
        pro: true,
        manualLink: "/manual#bot_profile"
    },
    {
        name: "API access",
        free: false,
        premium: false,
        pro: true,
        manualLink: "/manual/api"
    },
    {
        name: "Webhooks",
        free: false,
        premium: false,
        pro: true,
        manualLink: "/manual/api#webhooks"
    },
    {
        name: "Business license",
        free: false,
        premium: false,
        pro: true
    }
];
function FeatureValue({ value }) {
    if (typeof value === "boolean") return value ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-check text-green-400"
        })
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            className: "fas fa-times text-slate-500"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "text-center text-xs text-slate-300 md:text-sm",
        children: value
    });
}
function FeatureComparisonTable() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "py-16",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "mb-12 text-center text-4xl font-bold tracking-tight text-white",
                children: "Feature Comparison"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "-mx-4 overflow-x-auto px-4 sm:-mx-12 sm:px-12",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "mr-4 sm:mr-12",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mx-auto min-w-[480px] max-w-5xl overflow-hidden rounded-xl border border-slate-700 bg-slate-800/30",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-4 border-b border-slate-700 bg-slate-800/50",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "p-2 text-left md:p-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-sm font-semibold text-white md:text-lg",
                                            children: "Features"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "border-l border-slate-700 p-2 text-center md:p-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-sm font-semibold text-white md:text-lg",
                                            children: "Free"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "border-l border-slate-700 p-2 text-center md:p-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-sm font-semibold text-sesh-primary md:text-lg",
                                            children: "Premium"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "border-l border-slate-700 p-2 text-center md:p-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "bg-gradient-to-r from-amber-200 via-yellow-300 to-amber-400 bg-clip-text text-sm font-semibold text-transparent md:text-lg",
                                            children: "Pro"
                                        })
                                    })
                                ]
                            }),
                            features.map((feature, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: `grid grid-cols-4 border-b border-slate-700/50 last:border-b-0 ${index % 2 === 0 ? "bg-slate-800/20" : "bg-slate-800/40"}`,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "p-2 text-left md:p-4",
                                            children: feature.manualLink ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                href: feature.manualLink,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "flex items-center gap-1 text-xs text-slate-200 transition-colors duration-150 hover:text-slate-100 md:gap-2 md:text-base",
                                                title: "Learn more",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: feature.name
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                        className: "fas fa-info-circle text-xs text-slate-400"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-xs text-slate-200 md:text-base",
                                                children: feature.name
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "border-l border-slate-700/50 p-2 md:p-4",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FeatureValue, {
                                                value: feature.free
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "border-l border-slate-700/50 p-2 md:p-4",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FeatureValue, {
                                                value: feature.premium
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "border-l border-slate-700/50 p-2 md:p-4",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FeatureValue, {
                                                value: feature.pro
                                            })
                                        })
                                    ]
                                }, index))
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-8 text-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-sm text-slate-400",
                    children: "Each tier includes everything from the previous tier, plus additional capabilities."
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lWy2J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CustomBotCard", ()=>CustomBotCard);
var _jsxRuntime = require("react/jsx-runtime");
function CustomBotCard({ onContactClick }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mx-auto mt-8 max-w-2xl",
        id: "custom-bot",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "relative overflow-hidden rounded-xl border border-slate-600 bg-gradient-to-br from-slate-800/60 to-slate-900/60 p-8 text-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "absolute inset-0 bg-gradient-to-br from-sesh-primary/5 to-transparent"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "relative mb-8",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                className: "mb-4 text-3xl font-bold text-white",
                                children: [
                                    "Custom ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "sesh-text",
                                        children: "sesh"
                                    }),
                                    " Instance"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "mx-auto max-w-lg text-lg leading-relaxed text-slate-300",
                                children: [
                                    "Need something beyond our premium features? Get your own custom version of",
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "sesh-text",
                                        children: "sesh"
                                    }),
                                    " with personalized branding and features tailored to your organization."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "relative mb-8 grid grid-cols-2 gap-4 sm:grid-cols-4",
                        children: [
                            {
                                icon: "fas fa-cogs",
                                text: "Custom sesh Features"
                            },
                            {
                                icon: "fas fa-plug",
                                text: "Custom Integrations"
                            },
                            {
                                icon: "fas fa-headset",
                                text: "Dedicated Support Channel"
                            },
                            {
                                icon: "fas fa-shield-alt",
                                text: "Enterprise-Grade Security"
                            }
                        ].map((feature, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-col items-center gap-2 text-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-sesh-primary/20",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                            className: `${feature.icon} text-sm text-sesh-primary`
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-sm text-slate-200",
                                        children: feature.text
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                onClick: onContactClick,
                                className: "group inline-flex items-center gap-2 rounded-lg bg-sesh-primary px-8 py-3 font-semibold text-slate-900 transition-all duration-200 hover:scale-105 hover:bg-sesh-primary/90 focus:outline-none focus:ring-2 focus:ring-sesh-primary/50",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Contact Us"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-arrow-right text-sm transition-transform duration-200 group-hover:translate-x-1"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mt-3 text-xs text-slate-400",
                                children: "Get a custom quote based on your needs"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-6 rounded-lg border border-slate-700 bg-slate-800/30 p-4 text-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center justify-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-robot text-lg text-sesh-primary/70"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "text-sm text-slate-300",
                            children: [
                                "Looking for a completely custom bot? Check out",
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "https://tunkslabs.com",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "text-sesh-primary hover:underline",
                                    children: "Tunks Labs"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1ki67":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimpleContactModal", ()=>SimpleContactModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactHotToast = require("react-hot-toast");
var _trpc = require("../../../dashboard/utils/trpc");
function SimpleContactModal(props) {
    const [name, setName] = (0, _react.useState)("");
    const [email, setEmail] = (0, _react.useState)("");
    const [businessName, setBusinessName] = (0, _react.useState)("");
    const [wantCustomFeatures, setWantCustomFeatures] = (0, _react.useState)(false);
    const [customFeatures, setCustomFeatures] = (0, _react.useState)("");
    const [isSubmitting, setIsSubmitting] = (0, _react.useState)(false);
    const mutation = (0, _trpc.trpc).email.contact.useMutation();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setIsSubmitting(true);
        try {
            await mutation.mutateAsync({
                name,
                email,
                businessName,
                wantCustomFeatures,
                customFeatures: wantCustomFeatures ? customFeatures : undefined
            });
            (0, _reactHotToast.toast).success("Message sent successfully!");
            props.onClose();
        } catch (error) {
            console.error("Failed to send email:", error);
            (0, _reactHotToast.toast).error("Failed to send message. Please try again later.");
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50",
        onClick: props.onClose,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "w-full max-w-lg rounded-lg bg-slate-800 border border-slate-700 p-6 shadow-xl",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "mb-4 flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "text-2xl font-bold text-white",
                            children: "Contact Us"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: props.onClose,
                            className: "text-slate-400 hover:text-white",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-times"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                    onSubmit: handleSubmit,
                    className: "flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "block text-sm font-medium text-slate-200 mb-2",
                                    children: "Your Name"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "text",
                                    value: name,
                                    onChange: (e)=>setName(e.target.value),
                                    required: true,
                                    disabled: isSubmitting,
                                    className: "w-full rounded-md border border-slate-600 bg-slate-700 px-3 py-2 text-white placeholder-slate-400 focus:border-sesh-primary focus:outline-none focus:ring-1 focus:ring-sesh-primary"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "block text-sm font-medium text-slate-200 mb-2",
                                    children: "Email Address"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "email",
                                    value: email,
                                    onChange: (e)=>setEmail(e.target.value),
                                    required: true,
                                    disabled: isSubmitting,
                                    className: "w-full rounded-md border border-slate-600 bg-slate-700 px-3 py-2 text-white placeholder-slate-400 focus:border-sesh-primary focus:outline-none focus:ring-1 focus:ring-sesh-primary"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "block text-sm font-medium text-slate-200 mb-2",
                                    children: "Company or Community Name"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "text",
                                    value: businessName,
                                    onChange: (e)=>setBusinessName(e.target.value),
                                    required: true,
                                    disabled: isSubmitting,
                                    className: "w-full rounded-md border border-slate-600 bg-slate-700 px-3 py-2 text-white placeholder-slate-400 focus:border-sesh-primary focus:outline-none focus:ring-1 focus:ring-sesh-primary"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-start gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    id: "customFeatures",
                                    checked: wantCustomFeatures,
                                    onChange: (e)=>setWantCustomFeatures(e.target.checked),
                                    disabled: isSubmitting,
                                    className: "mt-1 h-4 w-4 rounded border-slate-600 bg-slate-700 text-sesh-primary focus:ring-sesh-primary"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "customFeatures",
                                    className: "text-sm text-slate-200",
                                    children: "Do you want custom features for the bot in addition to having a custom avatar and name?"
                                })
                            ]
                        }),
                        wantCustomFeatures && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "block text-sm font-medium text-slate-200 mb-2",
                                    children: "Describe the custom features you'd like"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                    value: customFeatures,
                                    onChange: (e)=>setCustomFeatures(e.target.value),
                                    placeholder: "Tell us about the specific features you need...",
                                    rows: 4,
                                    disabled: isSubmitting,
                                    className: "w-full rounded-md border border-slate-600 bg-slate-700 px-3 py-2 text-white placeholder-slate-400 focus:border-sesh-primary focus:outline-none focus:ring-1 focus:ring-sesh-primary"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            disabled: isSubmitting,
                            className: "mt-4 w-full rounded-md bg-sesh-primary px-4 py-2 font-semibold text-slate-900 transition-colors hover:bg-sesh-primary/90 disabled:opacity-50 disabled:text-slate-900",
                            children: isSubmitting ? "Sending..." : "Submit"
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","react-hot-toast":"iYXGG","../../../dashboard/utils/trpc":"dyYvM","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hXKBx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PremiumFaq", ()=>PremiumFaq);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAccordion = require("@radix-ui/react-accordion");
var _react = require("react");
var _emblaCarouselReact = require("embla-carousel-react");
var _emblaCarouselReactDefault = parcelHelpers.interopDefault(_emblaCarouselReact);
const carouselImages = [
    {
        src: "/img/customization_server.webp",
        caption: "In your server"
    },
    {
        src: "/img/customization_commands.webp",
        caption: "Slash command menu"
    },
    {
        src: "/img/customization_dashboard.webp",
        caption: "Web dashboard"
    },
    {
        src: "/img/customization_dm.webp",
        caption: "Direct messages"
    }
];
function CustomBrandingAnswer() {
    const [emblaRef, emblaApi] = (0, _emblaCarouselReactDefault.default)({
        loop: true
    });
    const [selectedIndex, setSelectedIndex] = (0, _react.useState)(0);
    const scrollPrev = (0, _react.useCallback)(()=>emblaApi?.scrollPrev(), [
        emblaApi
    ]);
    const scrollNext = (0, _react.useCallback)(()=>emblaApi?.scrollNext(), [
        emblaApi
    ]);
    const scrollTo = (0, _react.useCallback)((index)=>emblaApi?.scrollTo(index), [
        emblaApi
    ]);
    const onSelect = (0, _react.useCallback)(()=>{
        if (!emblaApi) return;
        setSelectedIndex(emblaApi.selectedScrollSnap());
    }, [
        emblaApi
    ]);
    (0, _react.useEffect)(()=>{
        if (!emblaApi) return;
        onSelect();
        emblaApi.on("select", onSelect);
        return ()=>{
            emblaApi.off("select", onSelect);
        };
    }, [
        emblaApi,
        onSelect
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "With",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-semibold text-slate-100",
                        children: "sesh Pro"
                    }),
                    ", you can give sesh a custom identity in your server:"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                className: "mt-2 list-inside list-disc space-y-1 text-slate-300",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: "Custom bot name (up to 32 characters)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: "Custom bot avatar"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: "Custom branding in the web dashboard"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mt-4 text-slate-300",
                children: "See the screenshots below to see how your custom icon and name will appear in Discord and on the dashboard:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "overflow-hidden rounded-lg",
                        ref: emblaRef,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex touch-pan-y",
                            children: carouselImages.map((image, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "min-w-0 flex-[0_0_100%]",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: image.src,
                                        alt: image.caption,
                                        className: "block h-auto max-h-[400px] w-full cursor-pointer rounded-lg border border-white/10 object-contain transition-opacity hover:opacity-90",
                                        onClick: ()=>window.open(image.src, "_blank")
                                    })
                                }, index))
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mt-2 text-center text-sm font-semibold text-white",
                        children: carouselImages[selectedIndex].caption
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mt-3 flex items-center justify-center gap-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                className: "rounded border border-white/20 bg-white/10 px-3 py-1.5 text-sm text-white transition-all hover:border-sesh-primary/50 hover:bg-white/20",
                                onClick: scrollPrev,
                                "aria-label": "Previous slide",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-chevron-left mr-1"
                                    }),
                                    " Prev"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex items-center gap-2",
                                children: carouselImages.map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: `h-2 w-2 rounded-full border-none p-0 transition-colors ${index === selectedIndex ? "bg-sesh-primary" : "cursor-pointer bg-white/30 hover:bg-white/50"}`,
                                        onClick: ()=>scrollTo(index),
                                        "aria-label": `Go to slide ${index + 1}`
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                className: "rounded border border-white/20 bg-white/10 px-3 py-1.5 text-sm text-white transition-all hover:border-sesh-primary/50 hover:bg-white/20",
                                onClick: scrollNext,
                                "aria-label": "Next slide",
                                children: [
                                    "Next ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                        className: "fas fa-chevron-right ml-1"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-4 rounded-lg border border-slate-600 bg-slate-800/50 px-4 py-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-info-circle text-sm text-slate-400"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "text-sm text-slate-300",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-medium text-slate-200",
                                    children: "Note:"
                                }),
                                " ",
                                'The "sesh" bot name will still appear in a few places: in Direct Messages (your custom name is shown with "AKA"), in the slash command menu category header, in bot status, and in some places on the web dashboard and manual.'
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                    href: "/manual#bot_customization",
                    className: "inline-flex items-center gap-1.5 text-sesh-primary hover:underline",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "Learn more in the manual"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                            className: "fas fa-arrow-right text-xs"
                        })
                    ]
                })
            })
        ]
    });
}
const faqItems = [
    {
        id: "transferring",
        question: "Can I transfer my premium subscription between servers?",
        answer: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-semibold text-slate-100",
                            children: "Purchases made here (Premium, Premium Bundle, sesh Pro):"
                        }),
                        " ",
                        "Yes, you can transfer these subscriptions freely between any servers you manage. Visit the",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "/dashboard/premium",
                            className: "text-sesh-primary hover:underline",
                            children: "Premium dashboard"
                        }),
                        " ",
                        "to manage your active servers."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-semibold text-slate-100",
                            children: "Discord in-app purchases:"
                        }),
                        " ",
                        "These are tied to the server where they were purchased and cannot be transferred. If you need flexibility, we recommend purchasing here instead."
                    ]
                })
            ]
        })
    },
    {
        id: "commercial",
        question: "Do I need sesh Pro for commercial use?",
        answer: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    children: [
                        "Yes. Commercial use of sesh requires a",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-semibold text-slate-100",
                            children: "sesh Pro"
                        }),
                        " ",
                        "license. This includes:"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                    className: "mt-2 list-inside list-disc space-y-1 text-slate-300",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: "Servers that generate revenue directly or indirectly"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: "Servers that charge members for access"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: "Servers operated by or on behalf of a business"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: "Creator/influencer communities with monetization"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "mt-3",
                    children: [
                        "Not sure if you need Pro?",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "mailto:contact@tunks.games",
                            className: "text-sesh-primary hover:underline",
                            children: "Contact us"
                        }),
                        " ",
                        "and we'll help figure it out."
                    ]
                })
            ]
        })
    },
    {
        id: "upgrade-pricing",
        question: "How does upgrade pricing work?",
        answer: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-semibold text-slate-100",
                            children: "Subscriptions (monthly/yearly):"
                        }),
                        " ",
                        "Upgrade your existing subscription in-place with prorated pricing. You only pay the difference."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-semibold text-slate-100",
                            children: "Lifetime purchases:"
                        }),
                        " ",
                        "Get a $149.99 discount on sesh Pro (the value of your lifetime Premium)."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "mt-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-semibold text-slate-100",
                            children: "Bundles:"
                        }),
                        " ",
                        "You can upgrade some or all of your bundle servers to Pro. For example, upgrade 1 server to Pro while keeping 2 on Premium."
                    ]
                })
            ]
        })
    },
    {
        id: "custom-branding",
        question: "What is custom branding?",
        answer: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CustomBrandingAnswer, {})
    }
];
function PremiumFaq() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mx-auto max-w-4xl px-4 py-16",
        id: "faq",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mb-10 text-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mb-3 inline-flex items-center gap-2 rounded-full border border-sesh-primary/30 bg-sesh-primary/10 px-4 py-1.5",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                className: "fas fa-question-circle text-sm text-sesh-primary"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-sm font-medium text-sesh-primary",
                                children: "Common Questions"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: "text-3xl font-bold tracking-tight text-white sm:text-4xl",
                        children: "Frequently Asked Questions"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactAccordion.Root, {
                type: "multiple",
                className: "overflow-hidden rounded-xl border border-slate-700 bg-slate-800/30 shadow-lg shadow-black/20",
                children: faqItems.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactAccordion.Item, {
                        value: item.id,
                        className: "group border-b border-slate-700/50 last:border-b-0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactAccordion.Header, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactAccordion.Trigger, {
                                    className: "flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-200 hover:bg-slate-800/40 data-[state=open]:bg-slate-800/40",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-base font-medium text-slate-100 transition-colors duration-200 group-data-[state=open]:text-sesh-primary sm:text-lg",
                                            children: item.question
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-slate-700/50 text-slate-400 transition-all duration-300 group-hover:bg-slate-700 group-data-[state=open]:bg-sesh-primary/20 group-data-[state=open]:text-sesh-primary",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-chevron-down text-sm transition-transform duration-300 group-data-[state=open]:rotate-180"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactAccordion.Content, {
                                className: "overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "px-6 pt-2 pb-6 text-sm leading-relaxed text-slate-300 sm:text-base",
                                    children: item.answer
                                })
                            })
                        ]
                    }, item.id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-8 text-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "text-sm text-slate-400",
                    children: [
                        "Still have questions?",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "mailto:contact@tunks.games",
                            className: "text-sesh-primary hover:underline",
                            children: "Reach out directly"
                        }),
                        " ",
                        "or ask in our",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "https://discord.gg/RuTcRzm",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "text-sesh-primary hover:underline",
                            children: "Discord server"
                        }),
                        "."
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","@radix-ui/react-accordion":"kOecR","react":"IMRgT","embla-carousel-react":"4iCVt","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kOecR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Accordion", ()=>Accordion);
parcelHelpers.export(exports, "AccordionContent", ()=>AccordionContent);
parcelHelpers.export(exports, "AccordionHeader", ()=>AccordionHeader);
parcelHelpers.export(exports, "AccordionItem", ()=>AccordionItem);
parcelHelpers.export(exports, "AccordionTrigger", ()=>AccordionTrigger);
parcelHelpers.export(exports, "Content", ()=>Content2);
parcelHelpers.export(exports, "Header", ()=>Header);
parcelHelpers.export(exports, "Item", ()=>Item);
parcelHelpers.export(exports, "Root", ()=>Root2);
parcelHelpers.export(exports, "Trigger", ()=>Trigger2);
parcelHelpers.export(exports, "createAccordionScope", ()=>createAccordionScope);
// src/accordion.tsx
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactContext = require("@radix-ui/react-context");
var _reactCollection = require("@radix-ui/react-collection");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _primitive = require("@radix-ui/primitive");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactCollapsible = require("@radix-ui/react-collapsible");
var _reactId = require("@radix-ui/react-id");
var _reactDirection = require("@radix-ui/react-direction");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var ACCORDION_NAME = "Accordion";
var ACCORDION_KEYS = [
    "Home",
    "End",
    "ArrowDown",
    "ArrowUp",
    "ArrowLeft",
    "ArrowRight"
];
var [Collection, useCollection, createCollectionScope] = (0, _reactCollection.createCollection)(ACCORDION_NAME);
var [createAccordionContext, createAccordionScope] = (0, _reactContext.createContextScope)(ACCORDION_NAME, [
    createCollectionScope,
    (0, _reactCollapsible.createCollapsibleScope)
]);
var useCollapsibleScope = (0, _reactCollapsible.createCollapsibleScope)();
var Accordion = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
    const { type, ...accordionProps } = props;
    const singleProps = accordionProps;
    const multipleProps = accordionProps;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.Provider, {
        scope: props.__scopeAccordion,
        children: type === "multiple" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(AccordionImplMultiple, {
            ...multipleProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(AccordionImplSingle, {
            ...singleProps,
            ref: forwardedRef
        })
    });
});
Accordion.displayName = ACCORDION_NAME;
var [AccordionValueProvider, useAccordionValueContext] = createAccordionContext(ACCORDION_NAME);
var [AccordionCollapsibleProvider, useAccordionCollapsibleContext] = createAccordionContext(ACCORDION_NAME, {
    collapsible: false
});
var AccordionImplSingle = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue, onValueChange = ()=>{}, collapsible = false, ...accordionSingleProps } = props;
    const [value, setValue] = (0, _reactUseControllableState.useControllableState)({
        prop: valueProp,
        defaultProp: defaultValue ?? "",
        onChange: onValueChange,
        caller: ACCORDION_NAME
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value: (0, _reactDefault.default).useMemo(()=>value ? [
                value
            ] : [], [
            value
        ]),
        onItemOpen: setValue,
        onItemClose: (0, _reactDefault.default).useCallback(()=>collapsible && setValue(""), [
            collapsible,
            setValue
        ]),
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(AccordionCollapsibleProvider, {
            scope: props.__scopeAccordion,
            collapsible,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(AccordionImpl, {
                ...accordionSingleProps,
                ref: forwardedRef
            })
        })
    });
});
var AccordionImplMultiple = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue, onValueChange = ()=>{}, ...accordionMultipleProps } = props;
    const [value, setValue] = (0, _reactUseControllableState.useControllableState)({
        prop: valueProp,
        defaultProp: defaultValue ?? [],
        onChange: onValueChange,
        caller: ACCORDION_NAME
    });
    const handleItemOpen = (0, _reactDefault.default).useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]), [
        setValue
    ]);
    const handleItemClose = (0, _reactDefault.default).useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value2)=>value2 !== itemValue)), [
        setValue
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value,
        onItemOpen: handleItemOpen,
        onItemClose: handleItemClose,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(AccordionCollapsibleProvider, {
            scope: props.__scopeAccordion,
            collapsible: true,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(AccordionImpl, {
                ...accordionMultipleProps,
                ref: forwardedRef
            })
        })
    });
});
var [AccordionImplProvider, useAccordionContext] = createAccordionContext(ACCORDION_NAME);
var AccordionImpl = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion, disabled, dir, orientation = "vertical", ...accordionProps } = props;
    const accordionRef = (0, _reactDefault.default).useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(accordionRef, forwardedRef);
    const getItems = useCollection(__scopeAccordion);
    const direction = (0, _reactDirection.useDirection)(dir);
    const isDirectionLTR = direction === "ltr";
    const handleKeyDown = (0, _primitive.composeEventHandlers)(props.onKeyDown, (event)=>{
        if (!ACCORDION_KEYS.includes(event.key)) return;
        const target = event.target;
        const triggerCollection = getItems().filter((item)=>!item.ref.current?.disabled);
        const triggerIndex = triggerCollection.findIndex((item)=>item.ref.current === target);
        const triggerCount = triggerCollection.length;
        if (triggerIndex === -1) return;
        event.preventDefault();
        let nextIndex = triggerIndex;
        const homeIndex = 0;
        const endIndex = triggerCount - 1;
        const moveNext = ()=>{
            nextIndex = triggerIndex + 1;
            if (nextIndex > endIndex) nextIndex = homeIndex;
        };
        const movePrev = ()=>{
            nextIndex = triggerIndex - 1;
            if (nextIndex < homeIndex) nextIndex = endIndex;
        };
        switch(event.key){
            case "Home":
                nextIndex = homeIndex;
                break;
            case "End":
                nextIndex = endIndex;
                break;
            case "ArrowRight":
                if (orientation === "horizontal") {
                    if (isDirectionLTR) moveNext();
                    else movePrev();
                }
                break;
            case "ArrowDown":
                if (orientation === "vertical") moveNext();
                break;
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    if (isDirectionLTR) movePrev();
                    else moveNext();
                }
                break;
            case "ArrowUp":
                if (orientation === "vertical") movePrev();
                break;
        }
        const clampedIndex = nextIndex % triggerCount;
        triggerCollection[clampedIndex].ref.current?.focus();
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(AccordionImplProvider, {
        scope: __scopeAccordion,
        disabled,
        direction: dir,
        orientation,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.Slot, {
            scope: __scopeAccordion,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
                ...accordionProps,
                "data-orientation": orientation,
                ref: composedRefs,
                onKeyDown: disabled ? void 0 : handleKeyDown
            })
        })
    });
});
var ITEM_NAME = "AccordionItem";
var [AccordionItemProvider, useAccordionItemContext] = createAccordionContext(ITEM_NAME);
var AccordionItem = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion, value, ...accordionItemProps } = props;
    const accordionContext = useAccordionContext(ITEM_NAME, __scopeAccordion);
    const valueContext = useAccordionValueContext(ITEM_NAME, __scopeAccordion);
    const collapsibleScope = useCollapsibleScope(__scopeAccordion);
    const triggerId = (0, _reactId.useId)();
    const open = value && valueContext.value.includes(value) || false;
    const disabled = accordionContext.disabled || props.disabled;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(AccordionItemProvider, {
        scope: __scopeAccordion,
        open,
        disabled,
        triggerId,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactCollapsible.Root, {
            "data-orientation": accordionContext.orientation,
            "data-state": getState(open),
            ...collapsibleScope,
            ...accordionItemProps,
            ref: forwardedRef,
            disabled,
            open,
            onOpenChange: (open2)=>{
                if (open2) valueContext.onItemOpen(value);
                else valueContext.onItemClose(value);
            }
        })
    });
});
AccordionItem.displayName = ITEM_NAME;
var HEADER_NAME = "AccordionHeader";
var AccordionHeader = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion, ...headerProps } = props;
    const accordionContext = useAccordionContext(ACCORDION_NAME, __scopeAccordion);
    const itemContext = useAccordionItemContext(HEADER_NAME, __scopeAccordion);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).h3, {
        "data-orientation": accordionContext.orientation,
        "data-state": getState(itemContext.open),
        "data-disabled": itemContext.disabled ? "" : void 0,
        ...headerProps,
        ref: forwardedRef
    });
});
AccordionHeader.displayName = HEADER_NAME;
var TRIGGER_NAME = "AccordionTrigger";
var AccordionTrigger = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion, ...triggerProps } = props;
    const accordionContext = useAccordionContext(ACCORDION_NAME, __scopeAccordion);
    const itemContext = useAccordionItemContext(TRIGGER_NAME, __scopeAccordion);
    const collapsibleContext = useAccordionCollapsibleContext(TRIGGER_NAME, __scopeAccordion);
    const collapsibleScope = useCollapsibleScope(__scopeAccordion);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.ItemSlot, {
        scope: __scopeAccordion,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactCollapsible.Trigger, {
            "aria-disabled": itemContext.open && !collapsibleContext.collapsible || void 0,
            "data-orientation": accordionContext.orientation,
            id: itemContext.triggerId,
            ...collapsibleScope,
            ...triggerProps,
            ref: forwardedRef
        })
    });
});
AccordionTrigger.displayName = TRIGGER_NAME;
var CONTENT_NAME = "AccordionContent";
var AccordionContent = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion, ...contentProps } = props;
    const accordionContext = useAccordionContext(ACCORDION_NAME, __scopeAccordion);
    const itemContext = useAccordionItemContext(CONTENT_NAME, __scopeAccordion);
    const collapsibleScope = useCollapsibleScope(__scopeAccordion);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactCollapsible.Content, {
        role: "region",
        "aria-labelledby": itemContext.triggerId,
        "data-orientation": accordionContext.orientation,
        ...collapsibleScope,
        ...contentProps,
        ref: forwardedRef,
        style: {
            ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
            ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
            ...props.style
        }
    });
});
AccordionContent.displayName = CONTENT_NAME;
function getState(open) {
    return open ? "open" : "closed";
}
var Root2 = Accordion;
var Item = AccordionItem;
var Header = AccordionHeader;
var Trigger2 = AccordionTrigger;
var Content2 = AccordionContent;

},{"react":"IMRgT","@radix-ui/react-context":"hCNHZ","@radix-ui/react-collection":"c2qQj","@radix-ui/react-compose-refs":"45V1u","@radix-ui/primitive":"a4PHZ","@radix-ui/react-use-controllable-state":"hLuue","@radix-ui/react-primitive":"ipRBd","@radix-ui/react-collapsible":"ufYCD","@radix-ui/react-id":"3RhOQ","@radix-ui/react-direction":"hnA3M","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hCNHZ":[function(require,module,exports,__globalThis) {
// packages/react/context/src/create-context.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContext", ()=>createContext2);
parcelHelpers.export(exports, "createContextScope", ()=>createContextScope);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function createContext2(rootComponentName, defaultContext) {
    const Context = _react.createContext(defaultContext);
    const Provider = (props)=>{
        const { children, ...context } = props;
        const value = _react.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Context.Provider, {
            value,
            children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = _react.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function createContextScope(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = _react.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope, children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = _react.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Context.Provider, {
                value,
                children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = _react.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return _react.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return _react.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return _react.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}

},{"react":"IMRgT","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"c2qQj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCollection", ()=>createCollection);
parcelHelpers.export(exports, "unstable_createCollection", ()=>createCollection2);
// src/collection-legacy.tsx
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactContext = require("@radix-ui/react-context");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactSlot = require("@radix-ui/react-slot");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function createCollection(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, _reactContext.createContextScope)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope, children } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const itemMap = (0, _reactDefault.default).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionProviderImpl, {
            scope,
            itemMap,
            collectionRef: ref,
            children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, _reactSlot.createSlot)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope, children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, _reactSlot.createSlot)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope, children, ...itemData } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, _reactDefault.default).useEffect(()=>{
            context.itemMap.set(ref, {
                ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, _reactDefault.default).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}
// src/ordered-dictionary.ts
var __instanciated = /* @__PURE__ */ new WeakMap();
var OrderedDict = class _OrderedDict extends Map {
    #keys;
    constructor(entries){
        super(entries);
        this.#keys = [
            ...super.keys()
        ];
        __instanciated.set(this, true);
    }
    set(key, value) {
        if (__instanciated.get(this)) {
            if (this.has(key)) this.#keys[this.#keys.indexOf(key)] = key;
            else this.#keys.push(key);
        }
        super.set(key, value);
        return this;
    }
    insert(index, key, value) {
        const has = this.has(key);
        const length = this.#keys.length;
        const relativeIndex = toSafeInteger(index);
        let actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
        const safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
        if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
            this.set(key, value);
            return this;
        }
        const size = this.size + (has ? 0 : 1);
        if (relativeIndex < 0) actualIndex++;
        const keys = [
            ...this.#keys
        ];
        let nextValue;
        let shouldSkip = false;
        for(let i = actualIndex; i < size; i++)if (actualIndex === i) {
            let nextKey = keys[i];
            if (keys[i] === key) nextKey = keys[i + 1];
            if (has) this.delete(key);
            nextValue = this.get(nextKey);
            this.set(key, value);
        } else {
            if (!shouldSkip && keys[i - 1] === key) shouldSkip = true;
            const currentKey = keys[shouldSkip ? i : i - 1];
            const currentValue = nextValue;
            nextValue = this.get(currentKey);
            this.delete(currentKey);
            this.set(currentKey, currentValue);
        }
        return this;
    }
    with(index, key, value) {
        const copy = new _OrderedDict(this);
        copy.insert(index, key, value);
        return copy;
    }
    before(key) {
        const index = this.#keys.indexOf(key) - 1;
        if (index < 0) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position before the given key.
   */ setBefore(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index, newKey, value);
    }
    after(key) {
        let index = this.#keys.indexOf(key);
        index = index === -1 || index === this.size - 1 ? -1 : index + 1;
        if (index === -1) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position after the given key.
   */ setAfter(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index + 1, newKey, value);
    }
    first() {
        return this.entryAt(0);
    }
    last() {
        return this.entryAt(-1);
    }
    clear() {
        this.#keys = [];
        return super.clear();
    }
    delete(key) {
        const deleted = super.delete(key);
        if (deleted) this.#keys.splice(this.#keys.indexOf(key), 1);
        return deleted;
    }
    deleteAt(index) {
        const key = this.keyAt(index);
        if (key !== void 0) return this.delete(key);
        return false;
    }
    at(index) {
        const key = at(this.#keys, index);
        if (key !== void 0) return this.get(key);
    }
    entryAt(index) {
        const key = at(this.#keys, index);
        if (key !== void 0) return [
            key,
            this.get(key)
        ];
    }
    indexOf(key) {
        return this.#keys.indexOf(key);
    }
    keyAt(index) {
        return at(this.#keys, index);
    }
    from(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.at(dest);
    }
    keyFrom(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.keyAt(dest);
    }
    find(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return entry;
            index++;
        }
        return void 0;
    }
    findIndex(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return index;
            index++;
        }
        return -1;
    }
    filter(predicate, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) entries.push(entry);
            index++;
        }
        return new _OrderedDict(entries);
    }
    map(callbackfn, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            entries.push([
                entry[0],
                Reflect.apply(callbackfn, thisArg, [
                    entry,
                    index,
                    this
                ])
            ]);
            index++;
        }
        return new _OrderedDict(entries);
    }
    reduce(...args) {
        const [callbackfn, initialValue] = args;
        let index = 0;
        let accumulator = initialValue ?? this.at(0);
        for (const entry of this){
            if (index === 0 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
            index++;
        }
        return accumulator;
    }
    reduceRight(...args) {
        const [callbackfn, initialValue] = args;
        let accumulator = initialValue ?? this.at(-1);
        for(let index = this.size - 1; index >= 0; index--){
            const entry = this.at(index);
            if (index === this.size - 1 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
        }
        return accumulator;
    }
    toSorted(compareFn) {
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        return new _OrderedDict(entries);
    }
    toReversed() {
        const reversed = new _OrderedDict();
        for(let index = this.size - 1; index >= 0; index--){
            const key = this.keyAt(index);
            const element = this.get(key);
            reversed.set(key, element);
        }
        return reversed;
    }
    toSpliced(...args) {
        const entries = [
            ...this.entries()
        ];
        entries.splice(...args);
        return new _OrderedDict(entries);
    }
    slice(start, end) {
        const result = new _OrderedDict();
        let stop = this.size - 1;
        if (start === void 0) return result;
        if (start < 0) start = start + this.size;
        if (end !== void 0 && end > 0) stop = end - 1;
        for(let index = start; index <= stop; index++){
            const key = this.keyAt(index);
            const element = this.get(key);
            result.set(key, element);
        }
        return result;
    }
    every(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (!Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return false;
            index++;
        }
        return true;
    }
    some(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return true;
            index++;
        }
        return false;
    }
};
function at(array, index) {
    if ("at" in Array.prototype) return Array.prototype.at.call(array, index);
    const actualIndex = toSafeIndex(array, index);
    return actualIndex === -1 ? void 0 : array[actualIndex];
}
function toSafeIndex(array, index) {
    const length = array.length;
    const relativeIndex = toSafeInteger(index);
    const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
    return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
function toSafeInteger(number) {
    return number !== number || number === 0 ? 0 : Math.trunc(number);
}
function createCollection2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, _reactContext.createContextScope)(PROVIDER_NAME);
    const [CollectionContextProvider, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionElement: null,
        collectionRef: {
            current: null
        },
        collectionRefObject: {
            current: null
        },
        itemMap: new OrderedDict(),
        setItemMap: ()=>void 0
    });
    const CollectionProvider = ({ state, ...props })=>{
        return state ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionProviderImpl, {
            ...props,
            state
        }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionInit, {
            ...props
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const CollectionInit = (props)=>{
        const state = useInitCollection();
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionProviderImpl, {
            ...props,
            state
        });
    };
    CollectionInit.displayName = PROVIDER_NAME + "Init";
    const CollectionProviderImpl = (props)=>{
        const { scope, children, state } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const [collectionElement, setCollectionElement] = (0, _reactDefault.default).useState(null);
        const composeRefs = (0, _reactComposeRefs.useComposedRefs)(ref, setCollectionElement);
        const [itemMap, setItemMap] = state;
        (0, _reactDefault.default).useEffect(()=>{
            if (!collectionElement) return;
            const observer = getChildListObserver(()=>{});
            observer.observe(collectionElement, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            collectionElement
        ]);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionContextProvider, {
            scope,
            itemMap,
            setItemMap,
            collectionRef: composeRefs,
            collectionRefObject: ref,
            collectionElement,
            children
        });
    };
    CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, _reactSlot.createSlot)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope, children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, _reactSlot.createSlot)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope, children, ...itemData } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const [element, setElement] = (0, _reactDefault.default).useState(null);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref, setElement);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        const { setItemMap } = context;
        const itemDataRef = (0, _reactDefault.default).useRef(itemData);
        if (!shallowEqual(itemDataRef.current, itemData)) itemDataRef.current = itemData;
        const memoizedItemData = itemDataRef.current;
        (0, _reactDefault.default).useEffect(()=>{
            const itemData2 = memoizedItemData;
            setItemMap((map)=>{
                if (!element) return map;
                if (!map.has(element)) {
                    map.set(element, {
                        ...itemData2,
                        element
                    });
                    return map.toSorted(sortByDocumentPosition);
                }
                return map.set(element, {
                    ...itemData2,
                    element
                }).toSorted(sortByDocumentPosition);
            });
            return ()=>{
                setItemMap((map)=>{
                    if (!element || !map.has(element)) return map;
                    map.delete(element);
                    return new OrderedDict(map);
                });
            };
        }, [
            element,
            memoizedItemData,
            setItemMap
        ]);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useInitCollection() {
        return (0, _reactDefault.default).useState(new OrderedDict());
    }
    function useCollection(scope) {
        const { itemMap } = useCollectionContext(name + "CollectionConsumer", scope);
        return itemMap;
    }
    const functions = {
        createCollectionScope,
        useCollection,
        useInitCollection
    };
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        functions
    ];
}
function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if (a == null || b == null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
function sortByDocumentPosition(a, b) {
    return !a[1].element || !b[1].element ? 0 : isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
function getChildListObserver(callback) {
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "childList") {
            callback();
            return;
        }
    });
    return observer;
}

},{"react":"IMRgT","@radix-ui/react-context":"hCNHZ","@radix-ui/react-compose-refs":"45V1u","@radix-ui/react-slot":"gBrD8","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"45V1u":[function(require,module,exports,__globalThis) {
// packages/react/compose-refs/src/compose-refs.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeRefs", ()=>composeRefs);
parcelHelpers.export(exports, "useComposedRefs", ()=>useComposedRefs);
var _react = require("react");
function setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function composeRefs(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else setRef(refs[i], null);
            }
        };
    };
}
function useComposedRefs(...refs) {
    return _react.useCallback(composeRefs(...refs), refs);
}

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"gBrD8":[function(require,module,exports,__globalThis) {
// src/slot.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Root", ()=>Slot);
parcelHelpers.export(exports, "Slot", ()=>Slot);
parcelHelpers.export(exports, "Slottable", ()=>Slottable);
parcelHelpers.export(exports, "createSlot", ()=>createSlot);
parcelHelpers.export(exports, "createSlottable", ()=>createSlottable);
var _react = require("react");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _jsxRuntime = require("react/jsx-runtime");
// @__NO_SIDE_EFFECTS__
function createSlot(ownerName) {
    const SlotClone = /* @__PURE__ */ createSlotClone(ownerName);
    const Slot2 = _react.forwardRef((props, forwardedRef)=>{
        const { children, ...slotProps } = props;
        const childrenArray = _react.Children.toArray(children);
        const slottable = childrenArray.find(isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if (_react.Children.count(newElement) > 1) return _react.Children.only(null);
                    return _react.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: _react.isValidElement(newElement) ? _react.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var Slot = /* @__PURE__ */ createSlot("Slot");
// @__NO_SIDE_EFFECTS__
function createSlotClone(ownerName) {
    const SlotClone = _react.forwardRef((props, forwardedRef)=>{
        const { children, ...slotProps } = props;
        if (_react.isValidElement(children)) {
            const childrenRef = getElementRef(children);
            const props2 = mergeProps(slotProps, children.props);
            if (children.type !== _react.Fragment) props2.ref = forwardedRef ? (0, _reactComposeRefs.composeRefs)(forwardedRef, childrenRef) : childrenRef;
            return _react.cloneElement(children, props2);
        }
        return _react.Children.count(children) > 1 ? _react.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function createSlottable(ownerName) {
    const Slottable2 = ({ children })=>{
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var Slottable = /* @__PURE__ */ createSlottable("Slottable");
function isSlottable(child) {
    return _react.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === SLOTTABLE_IDENTIFIER;
}
function mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}

},{"react":"IMRgT","@radix-ui/react-compose-refs":"45V1u","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"a4PHZ":[function(require,module,exports,__globalThis) {
// src/primitive.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canUseDOM", ()=>canUseDOM);
parcelHelpers.export(exports, "composeEventHandlers", ()=>composeEventHandlers);
parcelHelpers.export(exports, "getActiveElement", ()=>getActiveElement);
parcelHelpers.export(exports, "getOwnerDocument", ()=>getOwnerDocument);
parcelHelpers.export(exports, "getOwnerWindow", ()=>getOwnerWindow);
parcelHelpers.export(exports, "isFrame", ()=>isFrame);
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}
function getOwnerWindow(element) {
    if (!canUseDOM) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
function getOwnerDocument(element) {
    if (!canUseDOM) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
function getActiveElement(node, activeDescendant = false) {
    const { activeElement } = getOwnerDocument(node);
    if (!activeElement?.nodeName) return null;
    if (isFrame(activeElement) && activeElement.contentDocument) return getActiveElement(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = getOwnerDocument(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
function isFrame(element) {
    return element.tagName === "IFRAME";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hLuue":[function(require,module,exports,__globalThis) {
// src/use-controllable-state.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useControllableState", ()=>useControllableState);
parcelHelpers.export(exports, "useControllableStateReducer", ()=>useControllableStateReducer);
var _react = require("react");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var _reactUseEffectEvent = require("@radix-ui/react-use-effect-event");
var useInsertionEffect = _react[" useInsertionEffect ".trim().toString()] || (0, _reactUseLayoutEffect.useLayoutEffect);
function useControllableState({ prop, defaultProp, onChange = ()=>{}, caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = useUncontrolledState({
        defaultProp,
        onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = _react.useRef(prop !== void 0);
        _react.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = _react.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function useUncontrolledState({ defaultProp, onChange }) {
    const [value, setValue] = _react.useState(defaultProp);
    const prevValueRef = _react.useRef(value);
    const onChangeRef = _react.useRef(onChange);
    useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    _react.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function isFunction(value) {
    return typeof value === "function";
}
var SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function useControllableStateReducer(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp, onChange: onChangeProp, caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, _reactUseEffectEvent.useEffectEvent)(onChangeProp);
    {
        const isControlledRef = _react.useRef(controlledState !== void 0);
        _react.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = _react.useReducer((state2, action)=>{
        if (action.type === SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = _react.useRef(uncontrolledState);
    _react.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        onChange,
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = _react.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    _react.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}

},{"react":"IMRgT","@radix-ui/react-use-layout-effect":"cKnNa","@radix-ui/react-use-effect-event":"8FOyP","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"cKnNa":[function(require,module,exports,__globalThis) {
// packages/react/use-layout-effect/src/use-layout-effect.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLayoutEffect", ()=>useLayoutEffect2);
var _react = require("react");
var useLayoutEffect2 = globalThis?.document ? _react.useLayoutEffect : ()=>{};

},{"react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"8FOyP":[function(require,module,exports,__globalThis) {
// src/use-effect-event.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEffectEvent", ()=>useEffectEvent);
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var _react = require("react");
var useReactEffectEvent = _react[" useEffectEvent ".trim().toString()];
var useReactInsertionEffect = _react[" useInsertionEffect ".trim().toString()];
function useEffectEvent(callback) {
    if (typeof useReactEffectEvent === "function") return useReactEffectEvent(callback);
    const ref = _react.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof useReactInsertionEffect === "function") useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        ref.current = callback;
    });
    return _react.useMemo(()=>(...args)=>ref.current?.(...args), []);
}

},{"@radix-ui/react-use-layout-effect":"cKnNa","react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ipRBd":[function(require,module,exports,__globalThis) {
// src/primitive.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Primitive", ()=>Primitive);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "dispatchDiscreteCustomEvent", ()=>dispatchDiscreteCustomEvent);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactSlot = require("@radix-ui/react-slot");
var _jsxRuntime = require("react/jsx-runtime");
var NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var Primitive = NODES.reduce((primitive, node)=>{
    const Slot = (0, _reactSlot.createSlot)(`Primitive.${node}`);
    const Node = _react.forwardRef((props, forwardedRef)=>{
        const { asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function dispatchDiscreteCustomEvent(target, event) {
    if (target) _reactDom.flushSync(()=>target.dispatchEvent(event));
}
var Root = Primitive;

},{"react":"IMRgT","react-dom":"fODdr","@radix-ui/react-slot":"gBrD8","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ufYCD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Collapsible", ()=>Collapsible);
parcelHelpers.export(exports, "CollapsibleContent", ()=>CollapsibleContent);
parcelHelpers.export(exports, "CollapsibleTrigger", ()=>CollapsibleTrigger);
parcelHelpers.export(exports, "Content", ()=>Content);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "Trigger", ()=>Trigger);
parcelHelpers.export(exports, "createCollapsibleScope", ()=>createCollapsibleScope);
// src/collapsible.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactContext = require("@radix-ui/react-context");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactPresence = require("@radix-ui/react-presence");
var _reactId = require("@radix-ui/react-id");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var COLLAPSIBLE_NAME = "Collapsible";
var [createCollapsibleContext, createCollapsibleScope] = (0, _reactContext.createContextScope)(COLLAPSIBLE_NAME);
var [CollapsibleProvider, useCollapsibleContext] = createCollapsibleContext(COLLAPSIBLE_NAME);
var Collapsible = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible, open: openProp, defaultOpen, disabled, onOpenChange, ...collapsibleProps } = props;
    const [open, setOpen] = (0, _reactUseControllableState.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: COLLAPSIBLE_NAME
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollapsibleProvider, {
        scope: __scopeCollapsible,
        disabled,
        contentId: (0, _reactId.useId)(),
        open,
        onOpenToggle: _react.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
            "data-state": getState(open),
            "data-disabled": disabled ? "" : void 0,
            ...collapsibleProps,
            ref: forwardedRef
        })
    });
});
Collapsible.displayName = COLLAPSIBLE_NAME;
var TRIGGER_NAME = "CollapsibleTrigger";
var CollapsibleTrigger = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible, ...triggerProps } = props;
    const context = useCollapsibleContext(TRIGGER_NAME, __scopeCollapsible);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": getState(context.open),
        "data-disabled": context.disabled ? "" : void 0,
        disabled: context.disabled,
        ...triggerProps,
        ref: forwardedRef,
        onClick: (0, _primitive.composeEventHandlers)(props.onClick, context.onOpenToggle)
    });
});
CollapsibleTrigger.displayName = TRIGGER_NAME;
var CONTENT_NAME = "CollapsibleContent";
var CollapsibleContent = _react.forwardRef((props, forwardedRef)=>{
    const { forceMount, ...contentProps } = props;
    const context = useCollapsibleContext(CONTENT_NAME, props.__scopeCollapsible);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
        present: forceMount || context.open,
        children: ({ present })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(CollapsibleContentImpl, {
                ...contentProps,
                ref: forwardedRef,
                present
            })
    });
});
CollapsibleContent.displayName = CONTENT_NAME;
var CollapsibleContentImpl = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible, present, children, ...contentProps } = props;
    const context = useCollapsibleContext(CONTENT_NAME, __scopeCollapsible);
    const [isPresent, setIsPresent] = _react.useState(present);
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    const heightRef = _react.useRef(0);
    const height = heightRef.current;
    const widthRef = _react.useRef(0);
    const width = widthRef.current;
    const isOpen = context.open || isPresent;
    const isMountAnimationPreventedRef = _react.useRef(isOpen);
    const originalStylesRef = _react.useRef(void 0);
    _react.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        const node = ref.current;
        if (node) {
            originalStylesRef.current = originalStylesRef.current || {
                transitionDuration: node.style.transitionDuration,
                animationName: node.style.animationName
            };
            node.style.transitionDuration = "0s";
            node.style.animationName = "none";
            const rect = node.getBoundingClientRect();
            heightRef.current = rect.height;
            widthRef.current = rect.width;
            if (!isMountAnimationPreventedRef.current) {
                node.style.transitionDuration = originalStylesRef.current.transitionDuration;
                node.style.animationName = originalStylesRef.current.animationName;
            }
            setIsPresent(present);
        }
    }, [
        context.open,
        present
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        "data-state": getState(context.open),
        "data-disabled": context.disabled ? "" : void 0,
        id: context.contentId,
        hidden: !isOpen,
        ...contentProps,
        ref: composedRefs,
        style: {
            [`--radix-collapsible-content-height`]: height ? `${height}px` : void 0,
            [`--radix-collapsible-content-width`]: width ? `${width}px` : void 0,
            ...props.style
        },
        children: isOpen && children
    });
});
function getState(open) {
    return open ? "open" : "closed";
}
var Root = Collapsible;
var Trigger = CollapsibleTrigger;
var Content = CollapsibleContent;

},{"react":"IMRgT","@radix-ui/primitive":"a4PHZ","@radix-ui/react-context":"hCNHZ","@radix-ui/react-use-controllable-state":"hLuue","@radix-ui/react-use-layout-effect":"cKnNa","@radix-ui/react-compose-refs":"45V1u","@radix-ui/react-primitive":"ipRBd","@radix-ui/react-presence":"7X069","@radix-ui/react-id":"3RhOQ","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"7X069":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Presence", ()=>Presence);
parcelHelpers.export(exports, "Root", ()=>Root);
// src/presence.tsx
var _react = require("react");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
"use client";
function useStateMachine(initialState, machine) {
    return _react.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// src/presence.tsx
var Presence = (props)=>{
    const { present, children } = props;
    const presence = usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : _react.Children.only(children);
    const ref = (0, _reactComposeRefs.useComposedRefs)(presence.ref, getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? _react.cloneElement(child, {
        ref
    }) : null;
};
Presence.displayName = "Presence";
function usePresence(present) {
    const [node, setNode] = _react.useState();
    const stylesRef = _react.useRef(null);
    const prevPresentRef = _react.useRef(present);
    const prevAnimationNameRef = _react.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    _react.useEffect(()=>{
        const currentAnimationName = getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: _react.useCallback((node2)=>{
            stylesRef.current = node2 ? getComputedStyle(node2) : null;
            setNode(node2);
        }, [])
    };
}
function getAnimationName(styles) {
    return styles?.animationName || "none";
}
function getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var Root = Presence;

},{"react":"IMRgT","@radix-ui/react-compose-refs":"45V1u","@radix-ui/react-use-layout-effect":"cKnNa","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"3RhOQ":[function(require,module,exports,__globalThis) {
// packages/react/id/src/id.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useId", ()=>useId);
var _react = require("react");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var useReactId = _react[" useId ".trim().toString()] || (()=>void 0);
var count = 0;
function useId(deterministicId) {
    const [id, setId] = _react.useState(useReactId());
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String(count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}

},{"react":"IMRgT","@radix-ui/react-use-layout-effect":"cKnNa","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"hnA3M":[function(require,module,exports,__globalThis) {
// packages/react/direction/src/direction.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectionProvider", ()=>DirectionProvider);
parcelHelpers.export(exports, "Provider", ()=>Provider);
parcelHelpers.export(exports, "useDirection", ()=>useDirection);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var DirectionContext = _react.createContext(void 0);
var DirectionProvider = (props)=>{
    const { dir, children } = props;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(DirectionContext.Provider, {
        value: dir,
        children
    });
};
function useDirection(localDir) {
    const globalDir = _react.useContext(DirectionContext);
    return localDir || globalDir || "ltr";
}
var Provider = DirectionProvider;

},{"react":"IMRgT","react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"4iCVt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useEmblaCarousel);
var _react = require("react");
var _emblaCarouselReactiveUtils = require("embla-carousel-reactive-utils");
var _emblaCarousel = require("embla-carousel");
var _emblaCarouselDefault = parcelHelpers.interopDefault(_emblaCarousel);
function useEmblaCarousel(options = {}, plugins = []) {
    const storedOptions = (0, _react.useRef)(options);
    const storedPlugins = (0, _react.useRef)(plugins);
    const [emblaApi, setEmblaApi] = (0, _react.useState)();
    const [viewport, setViewport] = (0, _react.useState)();
    const reInit = (0, _react.useCallback)(()=>{
        if (emblaApi) emblaApi.reInit(storedOptions.current, storedPlugins.current);
    }, [
        emblaApi
    ]);
    (0, _react.useEffect)(()=>{
        if ((0, _emblaCarouselReactiveUtils.areOptionsEqual)(storedOptions.current, options)) return;
        storedOptions.current = options;
        reInit();
    }, [
        options,
        reInit
    ]);
    (0, _react.useEffect)(()=>{
        if ((0, _emblaCarouselReactiveUtils.arePluginsEqual)(storedPlugins.current, plugins)) return;
        storedPlugins.current = plugins;
        reInit();
    }, [
        plugins,
        reInit
    ]);
    (0, _react.useEffect)(()=>{
        if ((0, _emblaCarouselReactiveUtils.canUseDOM)() && viewport) {
            (0, _emblaCarouselDefault.default).globalOptions = useEmblaCarousel.globalOptions;
            const newEmblaApi = (0, _emblaCarouselDefault.default)(viewport, storedOptions.current, storedPlugins.current);
            setEmblaApi(newEmblaApi);
            return ()=>newEmblaApi.destroy();
        } else setEmblaApi(undefined);
    }, [
        viewport,
        setEmblaApi
    ]);
    return [
        setViewport,
        emblaApi
    ];
}
useEmblaCarousel.globalOptions = undefined;

},{"react":"IMRgT","embla-carousel-reactive-utils":"56y2O","embla-carousel":"cHjPR","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"56y2O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areOptionsEqual", ()=>areOptionsEqual);
parcelHelpers.export(exports, "arePluginsEqual", ()=>arePluginsEqual);
parcelHelpers.export(exports, "canUseDOM", ()=>canUseDOM);
parcelHelpers.export(exports, "sortAndMapPluginToOptions", ()=>sortAndMapPluginToOptions);
function isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function isRecord(subject) {
    return isObject(subject) || Array.isArray(subject);
}
function canUseDOM() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
function areOptionsEqual(optionsA, optionsB) {
    const optionsAKeys = Object.keys(optionsA);
    const optionsBKeys = Object.keys(optionsB);
    if (optionsAKeys.length !== optionsBKeys.length) return false;
    const breakpointsA = JSON.stringify(Object.keys(optionsA.breakpoints || {}));
    const breakpointsB = JSON.stringify(Object.keys(optionsB.breakpoints || {}));
    if (breakpointsA !== breakpointsB) return false;
    return optionsAKeys.every((key)=>{
        const valueA = optionsA[key];
        const valueB = optionsB[key];
        if (typeof valueA === 'function') return `${valueA}` === `${valueB}`;
        if (!isRecord(valueA) || !isRecord(valueB)) return valueA === valueB;
        return areOptionsEqual(valueA, valueB);
    });
}
function sortAndMapPluginToOptions(plugins) {
    return plugins.concat().sort((a, b)=>a.name > b.name ? 1 : -1).map((plugin)=>plugin.options);
}
function arePluginsEqual(pluginsA, pluginsB) {
    if (pluginsA.length !== pluginsB.length) return false;
    const optionsA = sortAndMapPluginToOptions(pluginsA);
    const optionsB = sortAndMapPluginToOptions(pluginsB);
    return optionsA.every((optionA, index)=>{
        const optionB = optionsB[index];
        return areOptionsEqual(optionA, optionB);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"l3L62":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SaleBanner", ()=>SaleBanner);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
function useCountdown(endDate) {
    const [timeLeft, setTimeLeft] = (0, _react.useState)(()=>calculateTimeLeft(endDate));
    (0, _react.useEffect)(()=>{
        if (!endDate) return;
        const interval = setInterval(()=>{
            setTimeLeft(calculateTimeLeft(endDate));
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        endDate
    ]);
    return timeLeft;
}
function calculateTimeLeft(endDate) {
    if (!endDate) return null;
    const now = new Date().getTime();
    const end = new Date(endDate).getTime();
    const diff = end - now;
    if (diff <= 0) return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        expired: true
    };
    return {
        days: Math.floor(diff / 86400000),
        hours: Math.floor(diff % 86400000 / 3600000),
        minutes: Math.floor(diff % 3600000 / 60000),
        seconds: Math.floor(diff % 60000 / 1000),
        expired: false
    };
}
function SaleBanner({ coupon }) {
    if (!coupon) return null;
    const endDate = coupon.end_date ? new Date(coupon.end_date) : null;
    const timeLeft = useCountdown(endDate);
    // Don't show if expired
    if (timeLeft?.expired) return null;
    const discountText = coupon.api_data.percent_off ? `${coupon.api_data.percent_off}% OFF` : `$${(coupon.api_data.amount_off / 100).toFixed(0)} OFF`;
    const couponName = coupon.api_data.name || "Limited Time Sale";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "sale-banner-wrapper",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "sale-banner",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "sale-banner-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "sale-banner-info",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "sale-banner-badge",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "sale-banner-badge-icon",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-bolt"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "sale-banner-badge-text",
                                            children: "LIMITED TIME"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    className: "sale-banner-title",
                                    children: couponName
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "sale-banner-discount",
                                    children: discountText
                                })
                            ]
                        }),
                        timeLeft && !timeLeft.expired && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "sale-banner-countdown",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "sale-banner-countdown-label",
                                    children: "ENDS IN"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "sale-banner-countdown-timer",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(CountdownUnit, {
                                            value: timeLeft.days,
                                            label: "DAYS"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "sale-banner-countdown-sep",
                                            children: ":"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(CountdownUnit, {
                                            value: timeLeft.hours,
                                            label: "HRS"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "sale-banner-countdown-sep",
                                            children: ":"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(CountdownUnit, {
                                            value: timeLeft.minutes,
                                            label: "MIN"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "sale-banner-countdown-sep",
                                            children: ":"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(CountdownUnit, {
                                            value: timeLeft.seconds,
                                            label: "SEC"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("style", {
                children: `
				.sale-banner-wrapper {
					--banner-primary: #00f4ff;
					--banner-secondary: #e2e608;
					--banner-bg-dark: #0f1318;
					--banner-bg-medium: #161b22;
					display: flex;
					justify-content: center;
					width: 100%;
					padding: 0 0.25rem;
					margin-bottom: 1.5rem;
				}

				.sale-banner {
					position: relative;
					overflow: hidden;
					border-radius: 8px;
					background: var(--banner-bg-dark);
					padding: 0.875rem 1.25rem;
					width: 100%;
					max-width: calc(3 * 20rem + 2 * 0.5rem);
					border: 1px solid transparent;
					background-image: linear-gradient(var(--banner-bg-dark), var(--banner-bg-dark)),
						linear-gradient(135deg, rgba(0, 244, 255, 0.4) 0%, rgba(226, 230, 8, 0.3) 50%, rgba(0, 244, 255, 0.4) 100%);
					background-origin: border-box;
					background-clip: padding-box, border-box;
				}

				/* Content layout */
				.sale-banner-content {
					position: relative;
					display: flex;
					align-items: center;
					justify-content: space-between;
					gap: 1.5rem;
					flex-wrap: wrap;
				}

				/* Sale info section */
				.sale-banner-info {
					display: flex;
					flex-direction: column;
					gap: 0.25rem;
				}

				.sale-banner-badge {
					display: inline-flex;
					align-items: center;
					gap: 0.375rem;
					padding: 0.25rem 0.625rem;
					background: rgba(226, 230, 8, 0.15);
					border: 1px solid rgba(226, 230, 8, 0.4);
					border-radius: 4px;
					width: fit-content;
				}

				.sale-banner-badge-icon {
					color: var(--banner-secondary);
					font-size: 0.625rem;
					animation: flash 1.5s ease-in-out infinite;
				}

				@keyframes flash {
					0%, 100% { opacity: 1; }
					50% { opacity: 0.5; }
				}

				.sale-banner-badge-text {
					font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;
					font-size: 0.625rem;
					font-weight: 700;
					letter-spacing: 0.1em;
					color: var(--banner-secondary);
					text-transform: uppercase;
				}

				.sale-banner-title {
					font-family: system-ui, -apple-system, sans-serif;
					font-size: 1.125rem;
					font-weight: 700;
					color: #fff;
					margin: 0;
					line-height: 1.3;
				}

				.sale-banner-discount {
					font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;
					font-size: 1.75rem;
					font-weight: 800;
					background: linear-gradient(135deg, var(--banner-primary) 0%, #fff 50%, var(--banner-primary) 100%);
					background-size: 200% auto;
					-webkit-background-clip: text;
					background-clip: text;
					-webkit-text-fill-color: transparent;
					animation: shimmer 3s linear infinite;
					line-height: 1.2;
					letter-spacing: -0.02em;
				}

				@keyframes shimmer {
					0% { background-position: -200% center; }
					100% { background-position: 200% center; }
				}

				/* Countdown section */
				.sale-banner-countdown {
					display: flex;
					flex-direction: column;
					align-items: flex-end;
					gap: 0.375rem;
				}

				.sale-banner-countdown-label {
					font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;
					font-size: 0.625rem;
					font-weight: 600;
					letter-spacing: 0.15em;
					color: rgba(255, 255, 255, 0.5);
				}

				.sale-banner-countdown-timer {
					display: flex;
					align-items: center;
					gap: 0.25rem;
				}

				.sale-banner-countdown-sep {
					font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;
					font-size: 1.25rem;
					font-weight: 700;
					color: rgba(0, 244, 255, 0.5);
					margin-bottom: 1rem;
				}

				.countdown-unit {
					display: flex;
					flex-direction: column;
					align-items: center;
					min-width: 3.25rem;
				}

				.countdown-value {
					font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;
					font-size: 1.5rem;
					font-weight: 700;
					color: #fff;
					background: rgba(0, 244, 255, 0.1);
					border: 1px solid rgba(0, 244, 255, 0.2);
					border-radius: 6px;
					padding: 0.25rem 0.5rem;
					min-width: 2.75rem;
					text-align: center;
					line-height: 1.3;
					box-shadow:
						0 0 20px rgba(0, 244, 255, 0.1),
						inset 0 1px 0 rgba(255, 255, 255, 0.05);
				}

				.countdown-label {
					font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;
					font-size: 0.5rem;
					font-weight: 600;
					letter-spacing: 0.1em;
					color: rgba(255, 255, 255, 0.4);
					margin-top: 0.25rem;
				}

				/* Mobile responsive */
				@media (max-width: 640px) {
					.sale-banner {
						padding: 1rem;
					}

					.sale-banner-content {
						flex-direction: column;
						align-items: center;
						text-align: center;
						gap: 1rem;
					}

					.sale-banner-info {
						align-items: center;
					}

					.sale-banner-countdown {
						align-items: center;
					}

					.sale-banner-discount {
						font-size: 1.5rem;
					}

					.countdown-value {
						font-size: 1.25rem;
						min-width: 2.25rem;
						padding: 0.25rem 0.375rem;
					}

					.countdown-unit {
						min-width: 2.5rem;
					}
				}
			`
            })
        ]
    });
}
function CountdownUnit({ value, label }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "countdown-unit",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "countdown-value",
                children: String(value).padStart(2, "0")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "countdown-label",
                children: label
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"ja211":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SeshToaster", ()=>SeshToaster);
var _jsxRuntime = require("react/jsx-runtime");
var _reactHotToast = require("react-hot-toast");
function SeshToaster() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHotToast.Toaster), {
        position: "bottom-center",
        toastOptions: {
            style: {
                background: "#1f242b",
                color: "#ffffff",
                border: "1px solid #313a46",
                borderRadius: "6px"
            },
            success: {
                iconTheme: {
                    primary: "#44d788",
                    secondary: "#29303a"
                }
            },
            error: {
                iconTheme: {
                    primary: "#ff5500",
                    secondary: "#29303a"
                }
            }
        }
    });
}

},{"react/jsx-runtime":"dpQXr","react-hot-toast":"iYXGG","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}]},[], null, "parcelRequire7ff5", {})

//# sourceMappingURL=dashboard.d6a0a375.js.map
